export default {
  translation: {
    Automation_flow_templates: "Modèles de flux",
    Automation_ai_templates: "Modèles IA",
    Automation_sample: "Exemple",
    Automation_sample_notice: "Vous pouvez utiliser des modèles prédéfinis et les personnaliser",
    Automation_template_number: "Modèle n° {{number}}",
    Automation_beginner: "Débutant",
    Automation_intermediate: "Intermédiaire",
    Automation_advanced: "Avancé",
    Automation_trending: "Tendance",
    Automation_sample_cart: "Récupération du panier",
    Automation_sample_cart_description:
      "Exemple : aidez les clients à retrouver leur panier et répondez à leurs questions.",
    Automation_sample_language: "Conversations multilingues",
    Automation_sample_language_description:
      "Exemple : guidez les visiteurs vers une conversation dans leur langue préférée.",
    Automation_sample_support: "Assistant du service client",
    Automation_sample_support_description:
      "Exemple : répondez aux questions fréquentes et indiquez la prochaine étape.",
    Automation_sample_welcome: "Accueil des nouveaux clients",
    Automation_sample_welcome_description: "Exemple : accueillez les visiteurs et présentez vos produits et services.",
    Automation_flow_history: "Historique des flux",
    Automation_ai_history: "Historique IA",
    Automation_loaded_count: "Éléments chargés ; + indique que d’autres sont disponibles.",
    Automation_sort_newest: " plus récents",
    Automation_sort_oldest: " plus anciens",
    Automation_sort_title: " par titre",
    Automation_connected_posts: "Publications connectées",
    Automation_not_connected: "Aucune publication connectée.",
    Automation_connections_access:
      "L’autorisation des commentaires et l’accès Automatisation/Commentaires sont requis.",
    Automation_checking_connections: "Vérification des connexions...",
    Automation_connections_retry: "Certaines connexions n’ont pas pu être vérifiées. Réessayer.",
    aiSuggestedPrompts_title: "Prompts suggérés",
    aiSuggestedPrompts_openImage: "Ouvrir l’image en plein écran",
    aiSuggestedPrompts_explain: "Choisissez un prompt pour commencer.",
    aiSuggestedPrompts_category: "Catégorie du prompt",
    aiSuggestedPrompts_subCategory: "Sous-catégorie",
    aiSuggestedPrompts_allCategories: "Toutes les catégories",
    aiSuggestedPrompts_loading: "Chargement...",
    aiSuggestedPrompts_empty: "Aucun prompt suggéré trouvé.",
    aiSuggestedPrompts_loadMore: "Charger plus",
    aiSuggestedPrompts_prompt: "Prompt",
    aiSuggestedPrompts_copy: "Copier le prompt",
    aiSuggestedPrompts_showMore: "Afficher plus",
    aiSuggestedPrompts_showLess: "Afficher moins",
    // #region landing page
    unpin: "Détacher",
    pin: "Épingler",
    usethisPrompt: "Utiliser dans le Prompt",
    AudienceTooltip:
      "Pour mesurer plus précisément votre engagement actuel, les statistiques sont basées sur vos performances des 30 derniers jours ; les statistiques Instagram couvrent toute la période d'activité du compte et peuvent différer de ces données",
    toggleShowAll: "afficher tout",
    toggleShowmonthly: "afficher mensuel",
    Nodetutorial: "Description du bloc",
    Dublicate: "Dupliquer",
    zoomout: "Dézoomer",
    fitscreen: "Ajuster à l’écran",
    zoomin: "Zoomer",
    shortcuts: "Raccourcis",
    Workflow_Statistics: "Statistiques du flux de travail",
    Nodes: "Nœuds",
    Connections: "Connexions",
    History_saved: "Historique enregistré",
    Data_Management_explain:
      "Vous pouvez enregistrer votre flux de travail et, si nécessaire, importer des flux de travail depuis d'autres plateformes.",
    flow_shortcuts_explain:
      "Raccourcis clavier pour augmenter la vitesse et la maîtrise dans la gestion des flux de travail.",
    Last_Auto_saved: "Dernière sauvegarde automatique",
    Canvas_Behavior: "Comportement du canevas",
    Canvas_Behavior_explain:
      "Configurez l’accrochage à la grille et les limites du panoramique pour un meilleur contrôle",
    Data_Management: "Gestion des données",
    importJSON_success: "Fichier importé avec succès",
    importJSON_error: "Erreur lors de l'importation du fichier",
    exportJSON: "Exporter en JSON",
    importJSON: "Importer JSON",

    quantity: "Quantité",
    allquantity: "Quantité totale",
    remainingquantity: "Quantité restante",
    Connecting: "Connexion",
    Connected: "Connecté",
    EmailNotification: "Notifications Email",
    EmailNotificationExplain: "Les notifications du système sont envoyées à cette adresse Email.",
    MobileNotification: "Notifications Mobile",
    MobileNotificationExplain: "Les notifications du système sont envoyées à ce numéro Mobile.",
    Responded: "Répondu",
    notimelimit: "Sans limite de temps",
    usersettingexplain:
      "Les informations du compte Instagram ne peuvent être modifiées que dans Instagram et seront mises à jour automatiquement ici.",

    loading: "Chargement...",
    Beginner: "Débutant",
    Basic: "Basique",
    Growing: "En Croissance",
    Advanced: "Avancé",
    Professional: "Professionnel",
    Special: "Spécial",
    Unavailable: "Indisponible",
    menu: "Menu",
    level: "Niveau",
    bestposts: "Meilleurs Posts",
    daysAgo: "Il y a quelques jours",
    hoursAgo: "Il y a quelques heures",
    minutesAgo: "Il y a quelques minutes",
    justNow: "À l’instant",
    upgradeyouraccount: "Améliorez votre compte",
    featureNotAvailable: "Cette fonctionnalité n'est pas disponible",
    featureNotAvailableDesc: "Améliorez votre compte pour utiliser cette fonctionnalité.",
    likeaprouser: "Lancez une vraie entreprise",
    followerrate: "Taux de croissance des abonnés",
    shoppertitle: "Tout est prêt à la vente 👌",
    advertisertitle: "Tout est prêt pour la publicité 👌",
    shopperdescription: "Suivez précisément vos performances de vente.",
    advertiserdescription: "Suivez précisément vos performances publicitaires.",
    syncingAccountTitle: "Récupération des informations",
    syncingAccountDescription: "Vos informations Instagram sont en cours de mise à jour dans Brancy",
    syncingAccountDescriptiontooltip:
      "Certaines de vos informations seront mises à jour dans les prochaines 24 heures.",
    subscriptionExpiringTitle: "Votre abonnement arrive à expiration",
    subscriptionExpiringDescription:
      "Renouvelez votre abonnement pour continuer à utiliser les fonctionnalités disponibles.",
    subscriptionDaysRemaining: "{{days}} jours restants",
    priceHistory: "Historique des prix",
    unselect: "Unselect",
    shopper: "Vendeur",
    onlinestore: "Boutique en ligne",
    onlinestoreExplain: "Tout ce dont vous avez besoin pour vendre plus, en un seul endroit.",
    influencerExplain: "Tous les outils pour les annonceurs et influenceurs, de manière professionnelle",
    advertiser: "Annonceur",
    influencer: "Influenceur",
    skip: "Ignorer",
    skipfornow: "Ignorer pour le moment",
    freedays: "40 Jours",
    freedaysExplain:
      "Si vous avez une page Instagram active et en croissance, ce plan est conçu pour vous. Accès complet aux outils, statistiques, gestion du contenu, des messages et des commentaires, et création d’administrateurs collaborateurs sur Brancy est activé.",
    instagramerplanactive: "Votre plan Instagram est actif",
    influencerplanactive: "Votre plan Influenceur est actif",
    onlinestoreplanactive: "Votre plan Boutique en ligne est actif",

    SwitchtoUserpanel: "Passer au panneau utilisateur",
    chooselanguage: "Choisir la langue",
    chooselanguageExplain: "Sélectionnez votre langue préférée",
    chooseTheme: "Choisir le thème",
    chooseThemeExplain: "Sélectionnez votre thème préféré",
    chooseCalendar: "Choisir le calendrier",
    chooseCalendarExplain: "Sélectionnez le type de calendrier souhaité",
    setupchooseexplain: "Ces paramètres peuvent être modifiés plus tard dans les réglages",

    Lottery: "Loterie",
    services: "Fonctionnalités",
    markets: "Plateformes",
    pricing: "Tarification",
    page1_text1: "Gestion des affaires Instagram",
    page1_text2: "Avec la prochaine génération de",
    page1_StartNow: "Un début gratuit avec accès à des outils professionnels",
    page1_services: "Services",
    page1_analytics: "Analytique",
    page1_transportation: "Transport",
    page1_financial_solutions: "Solutions financières",
    page1_customer_communication: "Communication client",
    page1_content_management: "Gestion de contenu",
    page1_artificial_intelligence: "Intelligence artificielle",
    page1_tools: "Outils",
    page1_advertises: "Gestion des publicités",
    page2_text1: "Les services et solutions commerciales les plus complets",
    page2_text2:
      "Brancy est un outil puissant pour gérer votre compte Instagram, vous fournissant les outils dont vous avez besoin pour réussir.",
    page2_ads_statistics_title: "Statistiques",
    page2_ads_statistics_description: "Outil avancé d’analyse de performance",
    page2_ads_statistics_servicedescription:
      "Surveillez précisément tous les indicateurs clés de vos publicités en temps réel. Obtenez une vision complète et professionnelle pour optimiser vos campagnes.",
    page2_ads_calendar_title: "Calendrier de travail",
    page2_ads_calendar_description: "Gestion publicitaire la plus pratique",
    page2_ads_calendar_servicedescription:
      "Gérez toutes vos publicités—acceptées ou proposées par l’IA—dans un calendrier intelligent avec une timeline avancée et organisée. Planifiez rapidement et sans erreur.",
    page2_ads_adlist_title: "Liste des publicités",
    page2_ads_adlist_description: "Affiche la file d’attente des publicités en attente d’approbation",
    page2_ads_adlist_servicedescription:
      "Visualisez clairement la liste catégorisée des publicités en attente et approuvez ou refusez-les d’un clic. Simplifiez la gestion de vos annonces.",
    page2_store_addproduct_title: "Ajouter Produit",
    page2_store_addproduct_description: "Identifier tous les produits depuis votre page",
    page2_store_addproduct_servicedescription:
      "Notre système intelligent détecte tous les produits dans vos posts et les prépare automatiquement pour l’ajout. Accélérez votre travail et minimisez les erreurs.",
    page2_store_productlist_title: "Liste des Produits",
    page2_store_productlist_description: "Gestion des stocks et produits",
    page2_store_productlist_servicedescription:
      "Gérez produits et stocks de manière professionnelle, précise et sans souci. Tout est accessible intelligemment avec rapports complets.",
    page2_store_orders_title: "Commandes",
    page2_store_orders_description: "Gestion des commandes, factures et expéditions",
    page2_store_orders_servicedescription:
      "De la commande à la facture et à l’expédition suivie, toutes les étapes sont automatisées et fluides. Garantie d’une expérience client rapide et sans faute.",
    page2_store_statistics_title: "Statistiques",
    page2_store_statistics_description: "Outil d’analyse de performance avancé",
    page2_store_statistics_servicedescription:
      "Suivez ventes, revenus et tendances de croissance sous plusieurs angles et prenez des décisions intelligentes basées sur les données.",
    page2_delivery_smartshipping_title: "Coût d'Expédition Intelligent",
    page2_delivery_smartshipping_description: "Coût selon origine, destination, taille et poids",
    page2_delivery_smartshipping_servicedescription:
      "Le coût d’expédition est calculé précisément et automatiquement selon origine, destination, dimensions et poids. Frais exacts sans erreur humaine.",
    page2_delivery_postalservice_title: "Service Postal",
    page2_delivery_postalservice_description: "Collecte et envoi des colis",
    page2_delivery_postalservice_servicedescription:
      "Vos colis sont collectés intelligemment depuis le magasin et envoyés sans suivi manuel. Une logistique fluide, rapide et organisée.",
    page2_delivery_tracking_title: "Suivi de Colis",
    page2_delivery_tracking_description: "Affichage et suivi automatique des colis",
    page2_delivery_tracking_servicedescription:
      "Suivi automatique avec statut précis en temps réel pour les clients, assurant transparence et confiance.",
    page2_jobs_subadmin_title: "Sous-Admin",
    page2_jobs_subadmin_description: "Possibilité d'ajouter des sous-admins",
    page2_jobs_subadmin_servicedescription:
      "Ajoutez des sous-admins sans partager les mots de passe et personnalisez les accès. Contrôle total avec sécurité garantie.",
    page2_ids_store_title: "Boutique ID",
    page2_ids_store_description: "Achat et vente d’IDs Instagram",
    page2_ids_store_servicedescription:
      "Achetez et vendez des comptes Instagram en toute sécurité avec authentification. Analyse détaillée, tarification intelligente, enchères et validation des statistiques—all in one place.",
    page2_publish_contentmanagement_title: "Gestion de Contenu",
    page2_publish_contentmanagement_description: "Gestion des Posts et Stories",
    page2_publish_contentmanagement_servicedescription:
      "Gérez tous les posts et stories sur une plateforme intelligente et avancée avec planification, catégorisation et publication rapide pour un contrôle sans souci des réseaux sociaux.",
    page2_publish_contentpublishing_title: "Publication de Contenu",
    page2_publish_contentpublishing_description: "Publication programmée des Posts et Stories",
    page2_publish_contentpublishing_servicedescription:
      "Publiez intelligemment les posts et stories selon un planning. Le système propose le meilleur moment basé sur l’analyse du comportement des followers.",
    page2_publish_analytics_title: "Analyse des Posts et Stories",
    page2_publish_analytics_description: "Analyse complète du contenu",
    page2_publish_analytics_servicedescription:
      "Obtenez une vision approfondie de la performance du contenu et des retours du public pour optimiser votre stratégie.",
    page2_publish_statistics_title: "Statistiques",
    page2_publish_statistics_description: "Outil avancé d’analyse de performance",
    page2_publish_statistics_servicedescription:
      "L’outil d’analyse de contenu le plus avancé avec détails complets sur les performances des posts et stories, graphiques et analyses précises pour de meilleures décisions.",
    page2_extension_biolink_title: "Bio Link",
    page2_extension_biolink_description: "Plus qu’un simple lien bio",
    page2_extension_biolink_servicedescription:
      "Une page dédiée et élégante présentant tous vos liens importants avec design réactif et personnalisation complète, au-delà d’un simple lien.",
    page2_extension_paymentgateway_title: "Passerelle de Paiement",
    page2_extension_paymentgateway_description: "Passerelle de paiement dédiée",
    page2_extension_paymentgateway_servicedescription:
      "Une passerelle de paiement sécurisée et dédiée sans besoin de connaissances techniques, avec rapports détaillés et gestion des transactions dans un environnement convivial.",
    page2_extension_customwebsite_title: "Site Web Personnalisé",
    page2_extension_customwebsite_description: "Site web personnalisé adapté à votre page",
    page2_extension_customwebsite_servicedescription:
      "Un site personnalisé en accord avec l’identité visuelle de votre page, sans codage. Présentez tous vos produits et services de manière professionnelle et élégante.",
    page4_menu_instagram_management: "Gestion de la Page Instagram",
    page4_menu_admin_subadmin: "Admin & Sous-Admin",
    page4_menu_store_shipping: "Boutique & Livraison",
    page4_menu_advertising: "Publicité",
    page4_menu_hashtag_management: "Gestion des Hashtags",
    page4_menu_ai_analysis: "Analyse IA Intelligente",
    page4_menu_ad_scheduling: "Planification des Annonces",
    page4_menu_financial_wallet: "Finance & Portefeuille",
    page4_menu_page_statistics: "Statistiques de la Page",
    page4_menu_professional_messaging: "Messagerie Professionnelle",

    page4_content_instagram_management_text:
      "Gérez toutes les parties de votre page—de la publication au réponse aux commentaires et directs—intégrées et professionnelles, sans besoin de multiples apps !",
    page4_content_admin_subadmin_text:
      "Construisez votre équipe ! Assignez des rôles spécifiques, limitez les accès et contrôlez totalement les activités sans erreurs humaines.",
    page4_content_store_shipping_text:
      "Une vraie boutique Instagram ! Gérez stocks, commandes, factures et suivi des livraisons depuis un seul panneau. Vendre en ligne n'a jamais été aussi simple !",
    page4_content_advertising_text:
      "Concevez, lancez et analysez vos pubs Instagram en quelques clics ! Attirez votre audience cible, mesurez le ROI et arrêtez de gaspiller votre budget.",
    page4_content_hashtag_management_text:
      "Choisissez intelligemment vos hashtags ! Analysez les meilleurs hashtags, stockez et classez-les, et recevez des suggestions intelligentes pour chaque post pour un max de vues.",
    page4_content_ai_analysis_text:
      "Surveillez le comportement de vos followers ! Découvrez patterns, intérêts et heures clés avec une IA avancée et gagnez en stratégie.",
    page4_content_ad_scheduling_text:
      "Gardez vos annonces actives même en dormant ! Planifiez vos campagnes, définissez les heures de début et fin et développez-vous sans souci.",
    page4_content_financial_wallet_text:
      "Gardez toutes vos transactions sous contrôle ! Suivez revenus, dépenses, solde portefeuille et obtenez des rapports financiers complets pour mieux gérer votre capital.",
    page4_content_page_statistics_text:
      "Des stats précises et réelles sur la croissance : taux d'engagement, croissance des followers, performances des posts, vues et plein de données pour de meilleures décisions.",
    page4_content_professional_messaging_text:
      "Vivez le vrai marketing direct ! Envoyez des messages groupés, configurez des réponses automatiques et gérez pro vos conversations followers sans confusion.",

    shipping: "Expédition",
    jobs: "Emplois",
    IDstore: "Boutique ID",
    page3_text1: "La solution à tous vos besoins commerciaux",
    page5_whyBrancy: "Pourquoi Brancy?",
    page5_title1: "Partenaire officiel et sécurisé d'Instagram",
    page5_title2: "Écosystème intégré, économie intelligente",
    page5_title3: "Interaction intelligente et professionnelle",
    page5_title4: "Tableau de bord avancé et intelligent",
    page5_title5: "Système de vente et de logistique intelligent",
    page5_title6: "Site web intelligent dédié",
    page5_explain1: "Gestion intelligente sans données sensibles – sécurisé et conforme à Instagram.",
    page5_explain2: "Tous les outils réunis : -70% de coût, -85% de temps.",
    page5_explain3: "Réponses IA automatiques : +40% réponses, 95% fidélisation.",
    page5_explain4: "Interface rapide, analyses live, admins, planification & rapports.",
    page5_explain5: "Vente via Direct – passerelle sécurisée, boutique, stock intelligent.",
    page5_explain6: "Site & lien Bio pro – vente, réservation, SEO & réseaux.",
    page9_plantitle: "Choisissez votre nombre de followers pour voir le bon pack",

    page9_planheader: "Commencez pro et profitez des fonctionnalités !",
    page9_planexplain: "40 jours d’accès complet, gratuit et illimité !",
    page9_freeplan: "Gratuit",
    page9_basicplan: "Basique",
    page9_proplan: "Pro",
    page9_adsplan: "Publicité",
    page9_storeplan: "Magasin",
    page9_monthly: "mensuel",
    page9_Compare: "Comparer les plans en détail",
    page9_content_management: "Gestion des Posts et Stories",
    page9_analize_management: "Analyse avancée et outils statistiques",
    page9_message_management: "Gestion des Directs et des Commentaires",
    page9_biolink_management: "Lien bio intelligent et site personnalisé",
    page9_subadmin_management: "Recrutement et gestion des sous-admins",
    page9_basicoption: "Fonctionnalités de base",
    page9_ticket_management: "Ventes via Direct et ticket",
    page9_finance_management: "Passerelle de paiement et portefeuille",
    page9_store_management: "Gestion intelligente du stock",
    page9_logestic_management: "Expédition et livraison automatiques",
    page9_storeanalize_management: "Analyse avancée",
    page9_calendar_management: "Calendrier de planification des publicités",
    page9_advertise_management: "Gestion intelligente des publicités",
    page9_adsanalize_management: "Analyse avancée des publicités",
    page9_campagin_management: "Créer et participer à des campagnes",
    page9_adsticket_management: "Envoi automatique de feedback publicitaire aux clients",

    page6_Header: "Des milliers d'entreprises actives",
    page6_Explain: "La plupart des entreprises prospères ont rejoint la grande famille Brancy",
    page10_header: "Ce que disent nos clients",
    page8_HelpCenter: "Centre d'aide",
    page8_Community: "Communauté",
    page8_learn: "Apprendre",
    page8_Blog: "Blog",
    page8_FAQ: "FAQ",
    Addfaq: "Ajouter une FAQ",
    addfaqexplain: "Vous pouvez ajouter jusqu'à 4 questions fréquentes",
    faqEmptyState: "Vos questions fréquentes s’afficheront ici",

    page8_Support: "Support",
    support_Online: "Assistance en ligne",
    support_EnterBlog: "Accéder au blog",
    page8_CommunityExplain:
      "Connectez-vous avec d'autres utilisateurs, partagez vos expériences et bénéficiez des conseils collectifs pour une croissance supplémentaire.",
    page8_learnExplain:
      "Dans cette section, vous apprendrez les dernières stratégies pour utiliser Instagram dans les affaires. Tout ce dont vous avez besoin pour la croissance de votre entreprise est ici.",
    page8_BlogExplain:
      "Accédez aux derniers articles et contenus éducatifs. Des informations à jour dans divers domaines des affaires et du marketing numérique vous attendent.",
    page8_FAQExplain:
      "Vos questions fréquentes sont répondues ici. Pour toute aide concernant les services ou produits, consultez cette section.",
    page8_SupportExplain:
      "Notre équipe de support est prête à vous aider. Si vous avez des problèmes ou des questions, contactez-nous simplement.",
    page8_CommunityBTN: "Apprenons ensemble",
    page8_learnBTN: "Apprentissage rapide",
    page8_BlogBTN: "Dernières nouvelles",
    page8_FAQBTN: "Réponses instantanées",
    page8_SupportBTN: "Nous sommes là pour aider",
    footer_Brancy: "Brancy",
    footer_AboutUs: "À propos de nous",
    footer_ContactUs: "Contactez-nous",
    footer_JoinUs: "Rejoignez-nous",
    footer_OrgChart: "Organigramme",
    footer_FollowUs: "Suivez-nous",
    footer_Solutions: "Solutions",
    footer_HelpCenter: "Centre d’aide",
    footer_Support: "Assistance",
    footer_FAQ: "Questions Fréquemment Posées",
    footer_ReportAnIssue: "Signaler un problème",
    footer_TrustLegal: "Confiance & Légal",
    footer_TermsAndConditions: "Conditions générales",
    footer_PrivacyNotice: "Avis de confidentialité",
    footer_CookieNotice: "Avis sur les cookies",
    footer_Blog: "Blog",
    footer_ProductUpdates: "Dernières mises à jour",
    footer_Articles: "Articles",
    footer_LatestNews: "Dernières nouvelles",
    installPromptMessage: "Installer l'application web Brancy",
    install: "Installer",
    installStep1: "Appuyez sur le bouton de partage en bas.",
    installStep2: "Faites défiler le menu vers le haut et choisissez Add to Home Screen.",
    installStep3: "Appuyez sur Add en haut de l'écran.",

    joinUs_subtitle: "Rejoignez Brancy; Là Où L'Innovation Et Un Avenir Durable Prennent Forme.",
    joinUs_whyWorkWithUs: "Pourquoi Brancy?",
    joinUs_whyWorkWithUsDescription:
      "Brancy N’est Pas Seulement Un Lieu De Travail; C’est Une Plateforme Stratégique Pour La Croissance Professionnelle Et Personnelle. Nous Croyons Que Les Organisations De Pointe Sont Construites Par Des Talents D’Exception. Notre Engagement Est De Créer Un Environnement Dynamique, Transparent Et Solidaire Où Les Membres De L’équipe Peuvent Avoir Un Impact Durable.",
    joinUs_openPositions: "Postes Ouverts",
    joinUs_openPositionsDescription:
      "Explorez Les Opportunités Disponibles Et Choisissez Le Poste Qui Correspond À Votre Expertise Et À Votre Parcours Professionnel.",
    joinUs_frontendDeveloper: "Développeur Frontend",
    joinUs_frontendDeveloperDescription:
      "Concevoir Et Mettre En Œuvre Des Expériences Utilisateurs Modernes Avec React Et TypeScript. Rôle Clé Dans L’amélioration De La Qualité Et De L’efficacité Des Produits.",
    joinUs_backendDeveloper: "Développeur Backend",
    joinUs_backendDeveloperDescription:
      "Concevoir Et Développer Des Systèmes Évolutifs Et Sécurisés Avec Node.js Et Les Technologies Cloud. Nécessite Une Pensée Systémique Et Des Compétences En Résolution De Problèmes Complexes.",
    joinUs_uiUxDesigner: "Designer UI/UX",
    joinUs_uiUxDesignerDescription:
      "Créer Des Interfaces Standards Et Des Expériences Intuitives Pour Garantir La Satisfaction Et La Fidélité Des Utilisateurs. L’attention Aux Détails Et La Créativité Sont Essentielles.",
    joinUs_productManager: "Chef De Produit",
    joinUs_productManagerDescription:
      "Diriger La Stratégie Produit Et Coordonner Les Équipes Pour Offrir Des Solutions Compétitives Et Efficaces. Idéal Pour Les Personnes Ayant Une Vision Analytique Et Des Compétences En Gestion Des Parties Prenantes.",
    joinUs_marketingSpecialist: "Spécialiste Marketing",
    joinUs_marketingSpecialistDescription:
      "Planifier Et Exécuter Des Campagnes Digitales Et Renforcer La Position De La Marque. Un Mélange De Compétences Analytiques Et Créatives.",
    joinUs_customerSupport: "Spécialiste Support Client",
    joinUs_customerSupportDescription:
      "Fournir Un Support Professionnel, Résoudre Les Problèmes Et Améliorer L’expérience Utilisateur. Nécessite Précision, Patience Et Compétences De Communication.",
    joinUs_engineering: "Ingénierie",
    joinUs_design: "Design",
    joinUs_product: "Produit",
    joinUs_marketing: "Marketing",
    joinUs_support: "Support",
    joinUs_remoteOnsite: "Télétravail / Sur Site",
    joinUs_onsite: "Sur Site",
    joinUs_remote: "Télétravail",
    joinUs_fullTime: "Temps Plein",
    joinUs_partTimeFullTime: "Temps Partiel / Temps Plein",
    joinUs_applyNow: "Postulez Maintenant",
    joinUs_applicationProcess: "Processus de Recrutement chez Brancy",
    joinUs_submitApplication: "Soumettre la Candidature",
    joinUs_submitApplicationDescription:
      "Envoyez votre CV et vos compétences. Notre équipe les examinera attentivement.",
    joinUs_initialScreening: "Sélection Initiale",
    joinUs_initialScreeningDescription:
      "Le département RH examine les CV dans un délai de 3 à 5 jours ouvrables et contacte si approprié.",
    joinUs_technicalInterview: "Entretien Technique",
    joinUs_technicalInterviewDescription:
      "Évaluation des connaissances et de l'expérience technique via des entretiens spécialisés avec les équipes.",
    joinUs_finalInterview: "Entretien Final",
    joinUs_finalInterviewDescription:
      "Session finale avec les managers seniors et les équipes clés pour assurer l’alignement des objectifs et des valeurs.",
    joinUs_welcomeAboard: "Bienvenue",
    joinUs_welcomeAboardDescription:
      "Après l’acceptation, un processus complet d’intégration commencera pour vous familiariser avec la culture et les objectifs de l’organisation.",
    joinUs_readyToJoinUs: "Vous n’avez pas trouvé le poste souhaité ?",
    joinUs_readyToJoinUsDescription:
      "Nous accueillons toujours les individus qualifiés et motivés. Envoyez votre CV et décrivez votre vision de collaboration avec Brancy.",
    joinUs_sendYourResume: "Envoyer Votre CV",

    aboutUs_pageTitle: "À Propos de Brancy",
    aboutUs_metaDescription:
      "Découvrez Brancy, une plateforme complète et internationale pour gérer les réseaux sociaux et les entreprises numériques ; un lieu où innovation, confiance et croissance durable façonnent l'avenir de l'économie numérique.",
    aboutUs_subtitle: "Gestion Intelligente de l'Économie Numérique avec Brancy",
    aboutUs_ourStoryTitle: "Notre Histoire",
    aboutUs_ourStoryPara1:
      "Brancy est né avec l'objectif de redéfinir la gestion des entreprises en ligne ; un point où les technologies avancées rencontrent les besoins réels des entrepreneurs. Nous ne proposons pas seulement un outil, mais un environnement permettant aux entreprises d'agir comme une grande organisation professionnelle.",
    aboutUs_ourStoryPara2:
      "Ce chemin s’est construit sur une conviction : la technologie doit faciliter la croissance de l’homme et des affaires, et non en être un obstacle.",
    aboutUs_innovationTitle: "L'Innovation comme Avantage Fondamental",
    aboutUs_innovationPara1:
      "Brancy utilise l'intelligence artificielle, le big data et les technologies web modernes pour offrir une expérience fluide, sécurisée et efficace aux utilisateurs. Chaque fonctionnalité est conçue en mettant l’accent sur la simplicité et la productivité maximale.",
    aboutUs_innovationPara2:
      "Pour nous, l'innovation ne se limite pas à la technologie ; c’est une approche stratégique enracinée dans notre culture organisationnelle et notre vision de l’avenir.",
    aboutUs_coreValuesTitle: "Nos Valeurs Fondamentales",
    aboutUs_innovationFirstTitle: "Pionnier de l'Innovation",
    aboutUs_innovationFirstDesc:
      "Nous recherchons constamment des solutions répondant aux besoins futurs des entreprises numériques.",
    aboutUs_trustSecurityTitle: "Confiance & Sécurité",
    aboutUs_trustSecurityDesc:
      "La sécurité des données et la transparence des processus sont nos priorités afin que les utilisateurs puissent croître en toute confiance.",
    aboutUs_globalCommunityTitle: "Une Communauté Globale",
    aboutUs_globalCommunityDesc:
      "Brancy dépasse les frontières géographiques en connectant un écosystème mondial d'entreprises et de professionnels.",
    aboutUs_sustainableGrowthTitle: "Croissance Durable",
    aboutUs_sustainableGrowthDesc:
      "Nous nous engageons à une expansion intelligente et durable, alignée sur des principes éthiques et de responsabilité sociale.",
    aboutUs_userEmpowermentTitle: "Autonomisation des Utilisateurs",
    aboutUs_userEmpowermentDesc:
      "Nos outils intuitifs et nos ressources éducatives assurent un accès égal aux opportunités numériques pour tous.",
    aboutUs_continuousEvolutionTitle: "Évolution Continue",
    aboutUs_continuousEvolutionDesc:
      "Dans un monde dynamique, le changement fait partie de notre parcours. Nous avançons constamment avec l'apprentissage et l'amélioration continue.",
    aboutUs_globalImpactTitle: "Impact Global",
    aboutUs_globalImpactPara:
      "Aujourd'hui, Brancy est une plateforme qui autonomise des millions d'entrepreneurs et d'entreprises ; un pont entre les opportunités numériques et un avenir sans frontières.",
    aboutUs_activeUsers: "Utilisateurs Actifs",
    aboutUs_countries: "Pays Couverts",
    aboutUs_uptime: "Disponibilité du Système",
    aboutUs_support: "Support Dédié",
    aboutUs_teamTitle: "Équipe Brancy",
    aboutUs_teamPara1:
      "Notre équipe est composée de technologues, de stratèges et de créatifs du monde entier, unis par la mission commune de développer l'économie numérique.",
    aboutUs_teamPara2:
      "De l’expérience des pionniers de l’industrie à l’énergie des jeunes talents, nous chez Brancy menons un mouvement mondial façonnant une nouvelle génération de commerce numérique.",

    // #region  landing page
    Dashboard: "Tableau de bord",
    greeting1: "Le soleil est réveillé avec toi,",
    greeting2: "Bon matin plein d'énergie,",
    greeting3: "Bonne journée,",
    greeting4: "Bon après-midi,",
    greeting5: "Bonne soirée dorée,",
    greeting6: "La nuit approche",
    greeting7: "Bonne nuit paisible,",
    greetingtext1: "Le matin tôt est vraiment magique🌅",
    greetingtext2: "Le monde attend tes pas 💪",
    greetingtext3: "Il est temps pour un thé et un sourire ☕😊",
    greetingtext4: "Profite de ton délicieux repas 🍽️",
    greetingtext5: "Le soleil est encore dans le ciel, vas-y 🌟",
    greetingtext6: "Crée une fin cool 🌇",
    greetingtext7: "Rêve grand et commence demain🌙",
    userpanel_yourorders: "Vos Commandes",
    userpanel_SavedProducts: "Produits Sauvegardés",
    userpanel_NoSavedProducts: "Aucun produit sauvegardé disponible.",
    userpanel_Startexplore: "Commencez à explorer entre des millions",
    userpanel_Startexploreexplain: "Marchés, Produits et Pages",
    userpanel_TicketSupportExplain: "Suivi de commande, discussion avec le vendeur",
    userpanel_TicketSupport: "Communiquez via ticket",

    userpanel_UseInstagram: "Gérez Instagram comme un Pro.",
    userpanel_FreeProPanel: "ProPanel Gratuit",
    userpanel_Premiumaccount: "Compte Premium",
    userpanel_daysFreePremium: "40 jours Premium Gratuit",
    userpanel_LimitedOffer: "Offre Limitée !",
    // #region 0️⃣ General Section
    //0️⃣ General -> sidebar
    color: "Couleur",
    button: "Bouton",
    Liter: "Litre",
    FrontFace: "Face Avant",
    SideFace: "Face Latérale",
    TopFace: "Face Supérieure",
    Area: "Surface",
    Perimeter: "Périmètre",
    Volume: "Volume",
    inSystem: "Dans le système",
    sending: "Envoi",
    uploadsRemaining: "Téléchargements restants",
    logoutExplain: "Vous essayez de vous déconnecter de Brancy",
    welcomeToBrancy: "Bienvenue chez Brancy!",
    notloginexplain: "Pour bénéficier des services de Brancy, veuillez connecter votre compte Instagram.",
    welcomeToBrancyExplain: "Entrez votre identifiant Instagram pour configurer votre panneau de gestion ultime.",
    welcomeToBrancyExplainPhone: "Entrez votre numéro de téléphone pour configurer votre panneau de gestion ultime.",
    loginWithGoogle: "Login Google",
    loginWithMobile: "Login SMS",

    or: "ou",
    InstagramID: "Nom d'utilisateur Instagram (ID)",
    EmptyNotification: "Il n'y a pas encore de notification",
    Notification_NewMessage: "Vous avez un nouveau message de {{sender}}",
    Notification_NewOrder: "Vous avez une nouvelle commande de {{sender}}",
    Notification_ImagesCreatedBy: "Vos images ont été créées avec succès par le modèle {{version}}.",
    Notification_VideoCreatedBy: "Votre vidéo a été créée avec succès par le modèle {{version}}.",
    Notification_MediaCreationFailed: "Échec de création de votre média par le modèle {{version}} : {{metadata}}",
    Notification_VideoCreationFailed: "Échec de création de votre vidéo par le modèle {{version}} : {{metadata}}",
    Notification_NewPost: "Nouveau post",
    Notification_UploadPostFailed: "Échec du téléchargement du post",
    Notification_NewStory: "Nouvelle story",
    Notification_UploadStoryFailed: "Échec du téléchargement de la story",
    Notification_NewVideo: "Nouvelle vidéo",
    Notification_VideoCreationFailedTitle: "Échec de création de la vidéo",
    Notification_YouHaveNewMessage: "Vous avez un nouveau message",
    Notification_AccountDeauthorized: "Compte Instagram désautorisé",
    EnterYourText: "Entrez votre texte",
    EnterYourphonenumber: "Entrez votre numéro de téléphone",
    CopyText: "Copier le texte",
    successfulCopy: "Copié",
    download: "Télécharger",
    automatic: "Automatique",
    manual: "Manuel",
    phonenumber: "Numéro de Téléphone",
    SendVerificationCode: "Envoyer le Code",
    ShowUserDashboard: "Aller au Tableau de Bord",
    VerificationCode: "Code de Vérification",
    VerificationCodeExplain: "Veuillez entrer le code de vérification envoyé à votre téléphone.",
    remainingTime: "Temps Restant",
    createtime: "Heure de Création",
    ResendVerificationCode: "Renvoyer le Code de Vérification",
    VerifyCode: "Vérifier le Code",
    Verify: "Vérifier",
    VerifyAddress: "Vérifier l'adresse",
    Continue: "Continuer",
    metaRedirect_aiAnalysisNotice:
      "Veuillez noter que l'analyse de votre page par intelligence artificielle peut prendre plusieurs heures.",
    Efficiency: "Efficacité",
    max: "Max",
    logout: "Déconnexion",
    notallowed: "Non autorisé",
    notallowedExplain: "Vous n'êtes pas autorisé à accéder à cette fonctionnalité",
    notallowedExplainPage: "Vous n'êtes pas autorisé à accéder à cette page",
    CreateAutomationFlow: "Créer un flux d'automatisation",
    CreateAutomationFlowExplain: "Automatisez les interactions Instagram avec un créateur de flux visuel.",
    CreateAutomationAI: "Créer une IA d'automatisation",
    CreateAutomationAIExplain: "Automatisez les interactions Instagram avec des réponses basées sur l'IA.",
    flowProperties_notworking_privateReply:
      "⚠️ Attention : ce flux ne fonctionne pas dans les conversations privées avec des amis et sert uniquement à répondre automatiquement aux commentaires et aux messages Direct",
    flowProperties_privateReply_requiresFollower:
      "Ce flux ne peut pas être utilisé pour les réponses privées. Pour l'activer, activez l'option « L'utilisateur doit suivre la page » dans les paramètres.",

    needPass: "Vérification et Activation",
    needPassExplain: "Pour accéder pleinement à cette fonctionnalité, le mot de passe du compte Instagram est requis",
    soon: "Bientôt",
    soonExplain: "Cette fonctionnalité sera bientôt disponible",
    underdevelop: "En cours de développement",
    reject: "Rejeter",
    rejected: "Rejeté",
    approved: "Approuvé",
    ExpirationTime: "Date d’expiration",
    send: "Envoyer",
    accept: "Accepter",
    selectall: "Tout sélectionner",
    General: "Général",
    Business: "Affaires",
    undo: "Annuler",
    redo: "Refaire",
    total: "Total",
    Unknown: "Inconnu",
    close: "Fermer",
    closed: "Fermé",
    admin: "Admin",
    user: "Utilisateur",
    stop: "Arrêter",
    save: "Enregistrer",
    discard: "Ignorer",
    all: "Tout",
    update: "Mise à jour",
    like: "like",
    dislike: "Dislike",
    next: "suivant",
    cancel: "annuler",
    canceled: "annulé",
    comment: "commentaire",
    mention: "mentionner",
    add: "Ajouter",
    icon: "Icône",
    copylist: "Copier la liste",
    reply: "Répondre",
    replies: "Réponses",
    PrivateReply: "Réponse Privée",
    copy: "Copier",
    everywhere: "Partout",
    UnHide: "Afficher",
    show: "Afficher",
    Hide: "Masquer",
    pageSummary: "Résumé de la page",
    summaryGeneralIntro: "Aperçu général de la page",
    summaryUserEngagement: "Analyse de l'engagement des utilisateurs",
    summaryContentStrategy: "Révision de la stratégie de contenu",
    summaryPostingSchedule: "Évaluation du calendrier de publication",
    summaryImprovementSuggestions: "Suggestions d'amélioration et de croissance",
    Ignore: "Ignorer",
    Orange: "Orange",
    Purple: "Violet",
    Green: "Vert",
    White: "Blanc",
    DarkGray: "Gris foncé",
    Blue: "Bleu",
    LightGray: "Gris clair",
    Brown: "Marron",
    Pink: "Rose",
    Yellow: "Jaune",
    Silver: "Argent",
    Black: "Noir",
    Red: "Rouge",
    select: "sélectionner",
    back: "Retour",
    start: "Démarrer",
    country: "Pays",
    device: "Appareil",
    yourdevice: "Votre Appareil",
    otherdevice: "Autre appareil",
    SessionID: "ID de Session",
    header: "En-tête",
    upload: "Télécharger",
    active: "Actif",
    activate: "Activer",
    activateAll: "Activer tout",
    DeactivateAll: "Désactiver tout",
    signout: "Déconnexion",
    switchaccount: "Changer de compte",
    instagramConnect: "Connecter le compte Instagram",
    upgrade: "Mise à niveau",
    Renew_Subscription: "Renouveler l’abonnement",
    deactive: "Désactivé",
    Deactivate: "Désactiver",
    done: "Terminé",
    text: "Texte",
    PlaceHolder: "Saisie en cours...",
    media: "Vidéo/Photo",
    ReplyStory: "Répondre à la Story",
    photo: "Photo",
    audio: "Message vocal",
    Generic: "Général",
    StoryMention: "Mention dans la Story",
    FileShare: "Fichier",
    voice: "Audio",
    CollaboratorExplain: "Partager un Post ou Reels en Collaboration entre Plusieurs Pages Instagram",

    abort: "Annuler",
    Pending: "En attente",
    Preparing: "En préparation",
    Finished: "Fini",
    finish: "Terminer",
    exportJPG: "Exporter JPG",
    exportPDF: "Exporter PDF",
    exportXlxs: "Exporter Excel",
    dismiss: "Fermer",
    empty: "Vide",
    searching: "Recherche ...",
    searchMessage: "Rechercher des personnes ou un mot-clé",
    searchKeyword: "Rechercher un mot-clé",
    Recommended: "Recommandé",
    VERFIED: "Vérifié",
    SuccessADS: "Succès des publicités",
    SuccessSALES: "Succès des ventes",
    StartOrder: "Commencer la commande",
    Startshoping: "Commencer les achats",
    question: "Question",
    Answer: "Réponse",
    shareStory: "Partager Story",
    search: "recherche",
    searchLocation: "Rechercher un emplacement",
    searchPeople: "Rechercher des personnes",
    edit: "Éditer",
    delete: "Supprimer",
    deletecover: "Supprimer la couverture",
    details: "Détails",
    Insights: "Statistiques",
    new: "Nouveau",
    comments: "Commentaires",
    nocomment: "Aucun commentaire",
    SimilarProducts: "Produits Similaires",
    QandA: "Questions",
    caption: "Légende",
    collaborator: "Page Collaborateur",
    collaboratorpost: "Publication Collaborateur",
    sidebar_Home: "Maison",
    sidebar_Page: "Gestion page",
    sidebar_Message: "Messages",
    sidebar_Wallet: "Portefeuille",
    sidebar_biolink: "Lien Bio",
    sidebar_Advertise: "Publicités",
    sidebar_Store: "Boutique",
    sidebar_Stores: "Boutiques",
    sidebar_Business: "Entreprise",
    sidebar_Setting: "Paramètres",
    //0️⃣ General -> navbar
    navbar_Post: "Posts",
    navbar_Live: "Live",
    navbar_Story: "Strory",
    navbar_Feed: "Feed",
    navbar_Reels: "Reels",
    navbar_Statistics: "Statistiques",
    navbarTools: "Outils",
    navbar_Direct: "Directs",
    navbar_Comments: "Commentaires",
    navbar_Ticket: "Billets",
    navbar_AI: "IA",
    navbar_ContentCreator: "Créateur de Contenu",
    navbar_Properties: "Propriétés",
    navbar_AIAndFlow: "IA & Agent",
    navbar_Payment: "Paiements",
    navbar_Title: "Titre",
    navbar_Home: "Accueil",
    navbar_Biolink: "Mon lien",
    navbar_Calendar: "Calendrier",
    navbar_AdList: "Annonces",
    navbar_General: "Général",
    navbar_SubAdmin: "Sous-admins",
    navbar_HelpCenter: "Aide et Support",

    addnewaccount: "Ajouter compte",
    addedaccounts: "Comptes Ajoutés",
    SwitchtoAccountexplain: "Tous vos comptes ajoutés dans Brancy sont listés ici",
    SwitchtoAccount: "Passer au compte",
    accountmanagement: "Gestion de compte",
    subadmininvitation: "Invitation de collaboration",
    subadmininvitationexplain: "Invitation à gérer Instagram en tant qu’administrateur adjoint",

    navbar_Products: "Produits",
    navbar_Orders: "Commandes",
    navbar_totalOrders: "Commandes Totales",
    //0️⃣ countdown
    countdown_Days: "Jour",
    countdown_Hours: "Heure",
    countdown_Minutes: "Minute",
    Expired: "Expiré",
    justnow: "À l'instant",
    LessThanAMinute: "Moins d'une minute",
    ExpiresIn: "Expire dans",
    ExportPDF: "Exporter en PDF",
    ExportJPG: "Exporter en JPG",
    ShareTo: "Partager à",
    Expand: "Étendre",
    // #endregion General Section
    // #region 1️⃣home Section
    // 1️⃣ Home -> cards
    home_FollowRequest: "Demandes de Suivi",
    home_UnreadNewComments: "Nouveaux Commentaires Non Lus",
    home_Last24H: "Dernières 24 Heures",
    home_Last30Days: "Au cours des 30 derniers jours",
    home_LastLikes: "Nouveaux J'aime",
    home_LastPost: "Dernier Post",
    home_Followings: "Abonnements",
    home_Followers: "Abonnés",
    AudienceLocation: "Localisation de l’audience active",
    AudienceGender: "Genre de l’audience active",
    AudienceAge: "Âge de l’audience active",

    AudienceGenderStats: "Vous avez {{female}} femmes, {{male}} hommes et {{unknown}} personnes au genre inconnu",

    AudienceAgeStats:
      "La plupart de votre audience appartient à la tranche d'âge {{ageRange}} ({{percentage}}%) donc le contenu doit être attrayant et adapté au public {{ageCategory}}.",

    AgeCategoryYoung: "jeune",
    AgeCategoryMiddleAged: "d'âge moyen",
    AgeCategoryOlder: "âgé",

    AudienceLocationStats:
      "La majorité de votre audience active vient du pays {{country}} avec {{countryCount, number}} personnes et de la ville {{city}} avec {{cityCount, number}} personnes",

    // 1️⃣ Home -> last like
    lastLike: "Derniers J'aime",
    // 1️⃣ Home -> last message
    lastMessage: "Derniers Messages",
    lastOrder: "Dernières Commandes",
    lastTransaction: "Dernières Transactions",
    // 1️⃣ Home -> last follower
    LastFollowers: "Derniers Abonnés",
    // #endregion home Section
    // #region 2️⃣page Section
    // 2️⃣ Page -> Post
    CreateNewPost: "Créer un Nouveau Post",
    Postnotvisible: "Le Post ne s’affiche pas ?",
    Storynotvisible: "La Story ne s’affiche pas ?",
    SmartPageAnalysis: "Analyse intelligente de la page",
    EducationAndGuidance: "Formation et accompagnement",
    HowToUseBrancy: "Comment utiliser Brancy",
    BrancyKnowsYou: "Brancy vous connaît",
    BrancyKnowsYouExplain:
      "Brancy analyse votre page en profondeur afin de construire une vision complète de votre identité numérique : votre personnalité, votre activité et vos actions, mais aussi votre ton et votre style de communication, votre type de contenu, votre manière de présenter les informations, votre calendrier de publication et votre façon d’interagir avec votre audience.\n\nCette analyse prend également en compte votre manière d’utiliser tous les points de contact de votre page, des réponses aux commentaires et aux messages Direct à votre style d’écriture, votre façon d’échanger avec votre audience et vos réactions face aux différentes situations.\n\nAucune formation manuelle, aucun réglage du ton ni aucune information supplémentaire ne sont nécessaires : Brancy vous connaît et adapte son intelligence artificielle à votre identité et à votre style réels.",
    CreateYourDigitalVersion: "Créer votre version numérique",
    CreateNewStrory: "Créer une Nouvelle Story",
    PostDraft: "Brouillon de Publication",
    StoryDraft: "Brouillon de Story",
    publishError: "Erreur de publication",
    DeletedPost: "Publication supprimée",
    errorDraft_title: "Une erreur s'est produite lors de la publication du post",
    errorDraft_configFailed: "Les paramètres de publication du post sont incorrects, veuillez vérifier et corriger.",
    errorDraft_invalidTags: "Tags invalides: ",
    errorDraft_unknown: "Erreur inconnue ! Veuillez réessayer.",
    errorDraft_uploadError: "Échec du téléchargement de l'image, veuillez réessayer.",
    errorDraft_userCancel: "La publication du post a été annulée par vous.",
    InvalidAspectRatio: "Rapport d’aspect invalide",
    SizeLimitExceed: "La taille du fichier dépasse la limite autorisée",
    UnSupportMediaType: "Type de média non pris en charge",
    NotPublishedAtTheTime: "Le post n’a pas été publié à l’heure choisie",
    NotSuccessLogin: "Échec de la connexion",

    NewScheduledPost: "Nouvelle Publication Programmée",
    thereAreNoPost: "Vous n'avez pas encore créé de Post programmé",
    ScheduledPost: "Publication Programmée",
    // 2️⃣ Page -> story
    pageStory_CreateNewStory: "Créer une Nouvelle Story",
    pageStory_CreateNewStories: "Nouvelle Story Programmée",
    pageStory_thereAreNoStories: "Vous n'avez pas encore créé de Story programmée",
    pageStory_ScheduledStories: "Story Programmée",
    // 2️⃣ Page -> highlight
    pageStory_highlightManagement: "Gestion des Points Forts",
    pageStory_thereAreNoHighlight: "Il n'y a pas de Points Forts",
    pageStory_HighlightTitle: "Points Forts / Dossiers",
    pageStatistics_YourBestFollowers: "Vos Meilleurs Abonnés",
    pageStatistics_YourBestFollowersExplain:
      "Calculé en fonction du score total d'interaction sur toute la page (y compris les likes, commentaires et partages).",
    pageStatistics_LoadMore: "Charger Plus",
    pageStatistics_UnFollowers: "Désabonnés",
    pageStatistics_Followers: "Abonnés",
    pageStatistics_NewFollowers: "Nouveaux Abonnés",
    pageStatistics_ActiveFollowers: "Abonnés Actifs",
    pageStatistics_MediaFollows: "Abonnés aux Médias",
    pageStatistics_Reach: "Portée",
    pageStatistics_ProfileVisit: "Visites de Profil",
    pageStatistics_30Days: "30 jours",
    pageStatistics_60Days: "60 jours",
    pageStatistics_90Days: "90 jours",
    pageStatistics_120Days: "120 jours",
    pageStatistics_WorstTime: "Pire moment",
    pageStatistics_BestTime: "Meilleur moment",
    pageStatistics_likes: "J’aime",
    pageStatistics_Engagements: "Engagements",
    pageStatistics_Impression: "Impression",
    pageStatistics_Views: "Vues",
    pageStatistics_RePosts: "Republications",
    pageStatistics_followerViews: "Followers visiteurs",
    pageStatistics_ghostViewers: "Vues fantômes",
    pageStatistics_Comments: "Commentaires",
    pageStatistics_Shares: "Partages",
    pageStatistics_summary: "Résumé",
    pageStatistics_EmptyList: "Aucune donnée disponible pour le moment !",
    pageStatistics_from: "Par rapport à",
    pageStatistics_post: "Publications",
    pageStatistics_stories: "Histoires",
    pageStatistics_MaxView: "Portée maximale",
    pageStatistics_MinView: "Portée minimale",
    pageStatistics_MaxCommentLike: "Max Commentaire & J’aime",
    pageStatistics_MinCommentLike: "Min Commentaire & J’aime",
    pageStatistics_PostTimeAnalysis: "Analyse du temps de publication",
    pageStatistics_Rate: "Taux",
    pageStatistics_RateExplain: "Basé sur le plus grand nombre de commentaires reçus sur l’ensemble de la page",

    pageStatistics_24HourHeatmap: "Carte thermique 24 heures",
    pageStatistics_Low: "Faible",
    pageStatistics_High: "Élevé",
    pageStatistics_TopHour: "Heure optimale",
    pageStatistics_WeakHour: "Heure faible",
    pageStatistics_AverageHour: "Heure moyenne",
    pageStatistics_TopMinute: "Minute optimale",
    pageStatistics_WeakMinute: "Minute faible",
    pageStatistics_AverageMinute: "Minute moyenne",
    pageStatistics_HourExcellentLevel:
      "Cette heure présente un niveau d'engagement excellent (au-dessus de 80% de capacité). L’engagement est supérieur à la moyenne de {{percentage}}%, ce qui en fait un moment idéal pour publier du contenu important.",
    pageStatistics_HourGoodLevel:
      "Cette heure présente un bon niveau d'engagement (60–80% de capacité). L’engagement est {{percentage}}% au-dessus de la moyenne, adaptée pour les publications ordinaires.",
    pageStatistics_HourAverageLevel:
      "Cette heure présente un niveau d'engagement moyen (40–60% de capacité). Pour de meilleurs résultats, essayez les heures avec une intensité plus élevée (vert). Différence avec le meilleur moment : {{difference}}%.",
    pageStatistics_HourWeakLevel:
      "Cette heure présente un faible niveau d'engagement (20–40% de capacité). Il est recommandé de publier durant des heures à intensité plus élevée.",
    pageStatistics_HourVeryWeakLevel:
      "Cette heure présente un très faible niveau d'engagement (moins de 20% de capacité). L’engagement est inférieur aux attentes et la publication n’est pas recommandée.",
    pageStatistics_MinuteTopDescription:
      "Cette minute fait partie des 10 meilleures minutes de {{hour}}:00. Pour un engagement maximal, il est recommandé de publier exactement à ce moment-là. Différence avec la minute la plus faible : {{difference}}%.",
    pageStatistics_MinuteWeakDescription:
      "L’engagement est faible durant cette minute. Publier au début ou au milieu de l’heure peut offrir de meilleurs résultats. Différence avec la meilleure minute : {{difference}}%.",
    pageStatistics_MinuteAverageDescription:
      "L’engagement est moyen. Pour une optimisation supplémentaire, consultez les minutes les mieux classées de cette heure.",
    pageStatistics_PeakEngagement: "Engagement maximal",
    pageStatistics_StableGrowth: "Croissance stable",
    pageStatistics_HighEngagementProbability: "Probabilité d'engagement élevée",
    pageStatistics_LowestEngagement: "Engagement instantané le plus faible",
    pageStatistics_SustainedLowPeriod: "Période faible prolongée",
    pageStatistics_LowEngagementProbability: "Faible probabilité d'engagement",
    pageStatistics_BestTimes: "Meilleurs moments",
    pageStatistics_WorstTimes: "Pires moments",
    pageStatistics_EngagementPrediction: "Prévision d'engagement",
    pageStatistics_PeakTimeDescription:
      "C’est le moment où l’engagement est le plus élevé. Recommandé pour un maximum de portée.",
    pageStatistics_StableTimeDescription:
      "À partir de ce moment, l’engagement commence à croître et reste au-dessus de la moyenne. Idéal pour un engagement stable.",
    pageStatistics_SecondaryTimeDescription: "Publier à ce moment peut donner de bons résultats.",
    pageStatistics_LowestTimeDescription:
      "C’est le moment de plus faible engagement instantané. Publier maintenant fait perdre {{percentage}}% d’engagement potentiel.",
    pageStatistics_SustainedLowTimeDescription:
      "L’engagement commence à diminuer à ce moment et reste faible. Déconseillé pour publier.",
    pageStatistics_SecondaryLowTimeDescription:
      "Un autre moment faible avec une faible probabilité d’engagement. Publication déconseillée.",
    pageStatistics_HourEngagementTooltip: "{{hour}}:00 - {{count}} interactions ({{percentage}}%)",
    pageStatistics_MinuteEngagementTooltip: "{{hour}}:{{minute}} - {{count}} interactions",

    // statistics suggestions box

    Statistics_UnFollowers_up_title: "Baisse des Unfollowers 💡Il est temps de renforcer ta stratégie de rétention",
    Statistics_UnFollowers_up_summary:
      "La baisse a diminué, ce qui signifie que ton contenu récent a fonctionné. Continue dans cette direction avec plus de précision.",
    Statistics_UnFollowers_up_action1: "Analyse tes trois derniers Posts : cover, première phrase et CTA.",
    Statistics_UnFollowers_up_action2:
      "Planifie un calendrier hebdomadaire basé sur ces formats et suis les changements.",
    Statistics_UnFollowers_up_action3:
      "Crée une Story de bienvenue et un Highlight propre pour les nouveaux Followers.",
    Statistics_UnFollowers_up_urgency: "Moyen",

    Statistics_UnFollowers_neutral_title: "Taux stable 💡recueille des données des utilisateurs avant tout changement",
    Statistics_UnFollowers_neutral_summary:
      "Le comportement de l’audience n’a pas changé ; tu dois recueillir leurs avis directement et faire des tests courts.",
    Statistics_UnFollowers_neutral_action1: "Publie un sondage en Story pour savoir ce qui les attire le plus.",
    Statistics_UnFollowers_neutral_action2: "Publie un Post au format fixe chaque semaine et compare les résultats.",
    Statistics_UnFollowers_neutral_action3:
      "Rassemble les trois problèmes les plus fréquents des Comments et crée un Post pour chacun.",
    Statistics_UnFollowers_neutral_urgency: "Faible",

    Statistics_UnFollowers_down_title: "Augmentation des désabonnements 💡Corrections rapides nécessaires",
    Statistics_UnFollowers_down_summary:
      "Une hausse des désabonnements indique un signal négatif dans ton contenu ou ton rythme de publication ; tu dois réagir rapidement.",
    Statistics_UnFollowers_down_action1:
      "Analyse les données des 7 derniers jours et identifie les deux Publications avec le plus de désabonnements.",
    Statistics_UnFollowers_down_action2:
      "Publie une Publication honnête ou en coulisses et demande directement la raison à ton audience.",
    Statistics_UnFollowers_down_action3:
      "Publie une Story avec une question ouverte : « Pourquoi t’es parti ? » et classe les réponses.",
    Statistics_UnFollowers_down_urgency: "Élevé",

    Statistics_UnFollowers_zero_title: "Aucune activité enregistrée 💡aucune donnée à analyser",
    Statistics_UnFollowers_zero_summary:
      "Sans activité, aucun signal n’est généré ; commence par relancer ton cycle de publication.",
    Statistics_UnFollowers_zero_action1:
      "Publie une Publication à forte valeur pour créer un premier signal comportemental.",
    Statistics_UnFollowers_zero_action2:
      "Publie deux Stories interactives (Poll ou Question) pour obtenir une première réaction.",
    Statistics_UnFollowers_zero_action3:
      "Publie une courte Publication d’introduction ou de mise à jour pour relancer la portée.",
    Statistics_UnFollowers_zero_urgency: "Élevé",

    Statistics_Followers_up_title: "Augmentation des Followers 💡Accueille correctement les nouveaux",
    Statistics_Followers_up_summary:
      "La croissance augmente ; dès leur arrivée, crée une expérience positive pour qu’ils deviennent des Followers actifs.",
    Statistics_Followers_up_action1:
      "Crée un Highlight d’accueil au format « Ce que tu trouveras & comment cela t’aide ».",
    Statistics_Followers_up_action2:
      "Prévois deux collaborations ou Mentions légères pour maintenir une croissance continue et qualitative.",
    Statistics_Followers_up_action3:
      "Analyse la qualité des Followers via les statistiques de campagnes et les entrées des Reels.",
    Statistics_Followers_up_urgency: "Moyen",

    Statistics_Followers_neutral_title: "Croissance stable 💡Temps pour des tests courts",
    Statistics_Followers_neutral_summary:
      "La croissance est stable ; réalise des tests de 7 jours pour comprendre ce qui influence l’acquisition.",
    Statistics_Followers_neutral_action1:
      "Effectue un test de 7 jours sur les hashtags, l’heure de publication et différentes couvertures.",
    Statistics_Followers_neutral_action2: "Note les résultats et transforme la meilleure combinaison en format fixe.",
    Statistics_Followers_neutral_action3:
      "Publie une courte vidéo d’introduction pour que les nouveaux visiteurs sachent rapidement à quoi s’attendre.",
    Statistics_Followers_neutral_urgency: "Moyen",

    Statistics_Followers_down_title:
      "Baisse d’attraction 💡Le contenu récent ne correspond probablement pas au persona",
    Statistics_Followers_down_summary:
      "Une baisse d’attraction indique un signal de décalage entre ton contenu actuel et ton audience cible.",
    Statistics_Followers_down_action1:
      "Identifie trois décalages entre le persona et ton contenu récent, puis corrige-les.",
    Statistics_Followers_down_action2:
      "Réécris rapidement la bio, le CTA et les covers de quelques Posts récents, puis teste-les.",
    Statistics_Followers_down_action3:
      "Lance une petite campagne de collaboration ou UGC pour réactiver l’image de ton compte.",
    Statistics_Followers_down_urgency: "Élevée",

    Statistics_Followers_zero_title: "Aucune activité récente 💡Aucune donnée d’attraction",
    Statistics_Followers_zero_summary:
      "En absence de publication ou d’actions d’attraction, aucun signal n’est généré ; tu dois réactiver ton cycle d’acquisition.",
    Statistics_Followers_zero_action1:
      "Publie cinq Reels courtes avec un hook de 3 secondes pour créer les premières entrées.",
    Statistics_Followers_zero_action2:
      "Publie un Post d’introduction ou de mise à jour pour lancer la portée naturelle.",
    Statistics_Followers_zero_action3:
      "Lance une petite campagne d’attraction (même locale) pour relancer la croissance.",
    Statistics_Followers_zero_urgency: "Élevée",

    Statistics_MediaFollows_up_title: "Hausse du trafic Explore 💡La création de séries est la meilleure stratégie",
    Statistics_MediaFollows_up_summary:
      "Vous avez des références et du trafic externe ; transformez vos formats réussis en une série cohérente.",
    Statistics_MediaFollows_up_action1:
      "Transformez le format réussi en 3 à 5 parties avec un CTA commun dans tous les épisodes.",
    Statistics_MediaFollows_up_action2:
      "Choisissez une couverture fixe et un planning régulier pour habituer le public à suivre la série.",
    Statistics_MediaFollows_up_action3:
      "Surveillez la distribution des premiers jours et concentrez-vous sur la source qui apporte le trafic le plus rapide.",
    Statistics_MediaFollows_up_urgency: "Moyen",

    Statistics_MediaFollows_neutral_title:
      "Trafic modéré 💡Il est temps de faire un test A/B sur la couverture et la source",
    Statistics_MediaFollows_neutral_summary:
      "Pour augmenter l’entrée depuis Explore, la couverture et la source doivent être optimisées.",
    Statistics_MediaFollows_neutral_action1:
      "Publiez deux couvertures A/B et comparez leurs performances sur 48 heures.",
    Statistics_MediaFollows_neutral_action2:
      "Listez les sources qui ont généré le plus de trafic et ciblez-les à nouveau.",
    Statistics_MediaFollows_neutral_action3: "Créez une banque de formats réussis pour faciliter leur réutilisation.",
    Statistics_MediaFollows_neutral_urgency: "Faible",

    Statistics_MediaFollows_down_title: "Baisse du trafic Explore 💡Un contenu plus engageant est nécessaire",
    Statistics_MediaFollows_down_summary:
      "Pour augmenter la portée via Explore, un contenu plus pratique ou téléchargeable est plus efficace.",
    Statistics_MediaFollows_down_action1:
      "Crée un PDF ou une checklist téléchargeable et partage un lien pour faciliter la diffusion.",
    Statistics_MediaFollows_down_action2: "Publie un contenu éducatif court et teste une promotion ciblée dessus.",
    Statistics_MediaFollows_down_action3:
      "Vérifie techniquement tous les liens et chemins de renvoi pour t’assurer qu’ils ne sont pas défectueux.",
    Statistics_MediaFollows_down_urgency: "Élevé",

    Statistics_MediaFollows_zero_title: "Aucune activité 💡Aucun signal Explore n’a été généré",
    Statistics_MediaFollows_zero_summary:
      "Sans publication ni actions de croissance, aucune donnée n’est disponible ; il faut d’abord relancer le cycle de création.",
    Statistics_MediaFollows_zero_action1:
      "Commence à être régulier dans la création et la publication de contenu engageant.",
    Statistics_MediaFollows_zero_action2:
      "Publie cinq contenus courts par jour pour générer les premiers signaux de renvoi.",
    Statistics_MediaFollows_zero_action3: "Publie un Post boosté le premier jour pour créer un trafic initial.",
    Statistics_MediaFollows_zero_urgency: "Élevé",

    Statistics_Reach_up_title: "Reach en hausse 💡Il est temps de scaler",
    Statistics_Reach_up_summary:
      "La portée a augmenté ; répétez vos meilleurs formats pour maintenir la vague de croissance.",
    Statistics_Reach_up_action_1: "Republiez deux des formats Reach les plus performants pendant les pics.",
    Statistics_Reach_up_action_2: "Fixez les hashtags efficaces et incluez-les toujours dans la légende.",
    Statistics_Reach_up_action_3: "Créez des Posts très partageables pour augmenter le Reach organique.",
    Statistics_Reach_up_urgency: "Moyen",

    Statistics_Reach_neutral_title: "Reach stable 💡Tests nécessaires",
    Statistics_Reach_neutral_summary:
      "Pour sortir de la stagnation, une collaboration légère ou tester des hashtags est la meilleure option.",
    Statistics_Reach_neutral_action_1: "Coordonnez un cross-Post avec une page du même domaine.",
    Statistics_Reach_neutral_action_2: "Publiez deux Reels éducatifs ou divertissants et évaluez les retours.",
    Statistics_Reach_neutral_action_3:
      "Vérifiez votre liste hebdomadaire de hashtags et trouvez la meilleure combinaison.",
    Statistics_Reach_neutral_urgency: "Faible",

    Statistics_Reach_down_title: "Reach en baisse 💡Action rapide nécessaire",
    Statistics_Reach_down_summary:
      "La portée a diminué ; le contenu partageable et les tests à court terme sont prioritaires.",
    Statistics_Reach_down_action_1: "Effectuez un test de 7 jours sur les Reels à fort potentiel.",
    Statistics_Reach_down_action_2: "Créez des Posts partageables et boostez-les avec une courte publicité.",
    Statistics_Reach_down_action_3: "Réécrivez le titre, la couverture et les hashtags, puis republiez le Post.",
    Statistics_Reach_down_urgency: "Élevé",

    Statistics_Reach_zero_title: "Aucun Reach enregistré 💡Activité faible",
    Statistics_Reach_zero_summary:
      "En raison du manque de publications ou de signaux suffisants, aucune donnée Reach n'existe ; le cycle de contenu doit être activé.",
    Statistics_Reach_zero_action_1: "Vérifiez la collecte des données (API/logs) pour assurer son bon fonctionnement.",
    Statistics_Reach_zero_action_2: "Publiez 5 Reels tendance et boostez-en un dès le deuxième jour.",
    Statistics_Reach_zero_action_3:
      "Testez le système de planification des publications et réinitialisez-le si nécessaire.",
    Statistics_Reach_zero_urgency: "Élevé",

    Statistics_ProfileVisit_up_title: "Visites de Profil Élevées 💡Concentrez-vous sur la Conversion",
    Statistics_ProfileVisit_up_summary:
      "Bon trafic entrant ; Bio et CTA doivent être optimisés rapidement pour convertir les visites en follows et clicks.",
    Statistics_ProfileVisit_up_action_1: "Réécrivez la Bio avec une proposition de valeur claire et un CTA direct.",
    Statistics_ProfileVisit_up_action_2:
      "Créez des Highlights clés pour que l'utilisateur comprenne ce qu'il a vu et ce à quoi s'attendre.",
    Statistics_ProfileVisit_up_action_3:
      "Publiez un Post avec une offre spéciale pour augmenter le taux de clic sur le lien.",
    Statistics_ProfileVisit_up_urgency: "Élevé",

    Statistics_ProfileVisit_neutral_title: "Visites Présentes, Conversion Faible 💡Générer des Leads",
    Statistics_ProfileVisit_neutral_summary:
      "Vous avez du trafic mais une faible conversion ; un Lead attractif peut changer le flux.",
    Statistics_ProfileVisit_neutral_action_1: "Ajoutez un fichier gratuit ou une checklist dans les Highlights.",
    Statistics_ProfileVisit_neutral_action_2: "Renforcez les légendes avec un CTA lié au profil.",
    Statistics_ProfileVisit_neutral_action_3: "Augmentez les Stories invitantes et guidant vers le profil.",
    Statistics_ProfileVisit_neutral_urgency: "Moyen",

    Statistics_ProfileVisit_down_title: "Baisse des Visites de Profil 💡Besoin d’un Hook Plus Fort",
    Statistics_ProfileVisit_down_summary:
      "La curiosité a diminué ; les débuts de légendes et CTA doivent être plus engageants et clairs.",
    Statistics_ProfileVisit_down_action_1: "Réécrivez les légendes avec un hook de 3 à 5 mots.",
    Statistics_ProfileVisit_down_action_2: "Ajoutez des Stories guidantes et mettez le lien en gras.",
    Statistics_ProfileVisit_down_action_3:
      "Publiez un Post invitant pour encourager les utilisateurs à visiter le profil.",
    Statistics_ProfileVisit_down_urgency: "Élevé",

    Statistics_ProfileVisit_zero_title: "Aucune Visite de Profil 💡Activité Insuffisante",
    Statistics_ProfileVisit_zero_summary:
      "En raison du manque de publication ou de signaux, aucune visite de profil enregistrée ; le cycle d’engagement doit être réactivé.",
    Statistics_ProfileVisit_zero_action_1: "Vérifiez le statut du compte pour vous assurer qu’il est public.",
    Statistics_ProfileVisit_zero_action_2: "Publiez un Post invitant avec un CTA clair.",
    Statistics_ProfileVisit_zero_action_3:
      "Mettez à jour les Highlights clés pour générer le premier signal de visite.",
    Statistics_ProfileVisit_zero_urgency: "Élevé",

    Statistics_Likes_up_title: "Les Likes sont Bons 💡Créez une Habitude",
    Statistics_Likes_up_summary:
      "Les utilisateurs likent ; maintenant, l'objectif est de transformer ce comportement en habitude constante.",
    Statistics_Likes_up_action_1: "Documentez les formats réussis (cover, template, longueur).",
    Statistics_Likes_up_action_2:
      "Ajoutez un CTA simple pour les likes à la fin du Post (ex. 'Si vous êtes d'accord ❤').",
    Statistics_Likes_up_action_3: "Faites un petit test A/B pour le cover et les 3 premières secondes.",
    Statistics_Likes_up_urgency: "Moyen",

    Statistics_Likes_neutral_title: "Les Likes Peuvent Augmenter 💡Améliorez Hook & Cover",
    Statistics_Likes_neutral_summary:
      "Il y a du potentiel ; changer le cover et le hook peut augmenter le taux de like.",
    Statistics_Likes_neutral_action_1: "Optimisez et testez le cover et les 3 premières secondes.",
    Statistics_Likes_neutral_action_2:
      "Utilisez des CTA émotionnels ou sous forme de questions pour inviter aux likes.",
    Statistics_Likes_neutral_action_3:
      "Faites un petit sondage pour comprendre les préférences visuelles de l’audience.",
    Statistics_Likes_neutral_urgency: "Faible",

    Statistics_Likes_down_title: "Likes en Baisse 💡Redessinez l’Identité Visuelle",
    Statistics_Likes_down_summary:
      "Le message ou l’image peut ne pas être fort ; concentrez-vous sur le premier instant du contenu.",
    Statistics_Likes_down_action_1: "Réécrivez le cover et la première ligne du caption.",
    Statistics_Likes_down_action_2: "Effectuez un test A/B pour la couleur/le design du cover.",
    Statistics_Likes_down_action_3: "Publiez des Posts visuellement forts et pertinents.",
    Statistics_Likes_down_urgency: "Élevé",

    Statistics_Likes_zero_title: "Zéro Likes 💡Pas de Données ou Pas de Contenu",
    Statistics_Likes_zero_summary:
      "S’il y a du contenu mais pas de likes, vérifiez les données ; sinon, commencez à produire.",
    Statistics_Likes_zero_action_1: "Vérifiez l’exactitude de l’enregistrement des données.",
    Statistics_Likes_zero_action_2: "S’il n’y a pas de contenu, publiez plusieurs Posts avec des covers fortes.",
    Statistics_Likes_zero_action_3: "Utilisez les réseaux partenaires pour recueillir des retours.",
    Statistics_Likes_zero_urgency: "Élevé",

    Statistics_Comments_up_title: "Commentaires en Hausse 💡Prenez les Conversations au Sérieux",
    Statistics_Comments_up_summary:
      "Les gens parlent ; profitez-en en répondant et en transformant les commentaires en contenu.",
    Statistics_Comments_up_action1: "Répondez aux commentaires et transformez les 3 meilleures idées en Post.",
    Statistics_Comments_up_action2: "Mettez en avant les meilleurs commentaires ou montrez-les dans une Story.",
    Statistics_Comments_up_action3: "Ajoutez une question dans le caption pour inciter les gens à répondre.",
    Statistics_Comments_up_urgency: "Moyen",

    Statistics_Comments_neutral_title: "Commentaires Faibles 💡Ajoutez un Stimulus",
    Statistics_Comments_neutral_summary: "Pour générer de la conversation, posez des questions simples et directes.",
    Statistics_Comments_neutral_action1: "Laissez une question ouverte à la fin du Post.",
    Statistics_Comments_neutral_action2: "Répondez rapidement aux 5 premiers commentaires pour encourager les autres.",
    Statistics_Comments_neutral_action3: "Lancez un petit challenge ou un sondage.",
    Statistics_Comments_neutral_urgency: "Faible",

    Statistics_Comments_down_title: "Commentaires en Baisse 💡Mettez des Stimuli Clairs",
    Statistics_Comments_down_summary: "Vous avez besoin de CTA directs et d’invitations pour lancer la conversation.",
    Statistics_Comments_down_action1: "Publiez un challenge ou demandez des expériences personnelles.",
    Statistics_Comments_down_action2:
      "Incluez un CTA clair pour les commentaires dans le caption (ex: 'Quel est ton avis ?').",
    Statistics_Comments_down_action3: "Répondez rapidement aux premiers commentaires.",
    Statistics_Comments_down_urgency: "Élevé",

    Statistics_Comments_zero_title: "Pas de Commentaires 💡Soyez Invitatif",
    Statistics_Comments_zero_summary: "Le contenu n’incite pas à commenter ; rendez les formats plus invitants.",
    Statistics_Comments_zero_action1: "Concevez des questions simples et engageantes (ex: choix entre deux options).",
    Statistics_Comments_zero_action2: "Répondez rapidement aux premiers commentaires pour encourager les autres.",
    Statistics_Comments_zero_action3: "Utilisez des CTA directs pour inviter à commenter.",
    Statistics_Comments_zero_urgency: "Élevé",

    Statistics_Views_up_title: "Vues en Hausse 💡Profitez du Trafic",
    Statistics_Views_up_summary:
      "Les vues des vidéos sont bonnes ; utilisez la fin de la vidéo pour diriger le trafic (profil/enregistrer).",
    Statistics_Views_up_action1: "Ajoutez un CTA clair à la fin de la vidéo (ex : 'Enregistrer pour plus').",
    Statistics_Views_up_action2: "Placez un lien vers du contenu supplémentaire dans la bio ou les highlights.",
    Statistics_Views_up_action3: "Créez et publiez une version plus courte ou un teaser.",
    Statistics_Views_up_urgency: "Moyen",

    Statistics_Views_neutral_title: "Vues Stables 💡Renforcez le Hook et la Couverture",
    Statistics_Views_neutral_summary:
      "Travaillez sur les 3 premières secondes et la couverture pour améliorer le taux de vues.",
    Statistics_Views_neutral_action1: "Réécrivez le hook d'ouverture et la couverture.",
    Statistics_Views_neutral_action2: "Publiez une version plus courte pour tester.",
    Statistics_Views_neutral_action3: "Recueillez des retours visuels du public.",
    Statistics_Views_neutral_urgency: "Faible",

    Statistics_Views_down_title: "Vues en Baisse 💡Renforce le Hook",
    Statistics_Views_down_summary:
      "Le début de la vidéo est faible ; commence à tester des versions courtes et engageantes.",
    Statistics_Views_down_action1: "Crée 5 vidéos de 15 secondes avec un hook fort.",
    Statistics_Views_down_action2: "Réécris le début de la vidéo et fais des tests A/B.",
    Statistics_Views_down_action3: "Augmente la vitesse du montage pour maintenir l’attention.",
    Statistics_Views_down_urgency: "Élevé",

    Statistics_Views_zero_title: "Zéro Vue ? 💡Publie le Contenu ASAP",
    Statistics_Views_zero_summary: "Commence la production de contenu dès que possible.",
    Statistics_Views_zero_action1: "Commence uniquement par analyser le flux de travail de la page.",
    Statistics_Views_zero_action2: "Si aucune vidéo n’est publiée, crée 3 reels courts.",
    Statistics_Views_zero_action3: "Lance un post booster pour générer les premières vues.",
    Statistics_Views_zero_urgency: "Élevé",

    Statistics_FollowerViews_up_title: "Les abonnés regardent 💡Créez de l'engagement interne",
    Statistics_FollowerViews_up_summary:
      "Les abonnés sont actifs ; utilisez-les pour l'engagement interne (AMA, sondages).",
    Statistics_FollowerViews_up_action1:
      "Posez des questions ou lancez des sondages dans les Stories pour les abonnés.",
    Statistics_FollowerViews_up_action2: "Publiez du contenu exclusif pour les abonnés (comme AMA).",
    Statistics_FollowerViews_up_action3:
      "Vérifiez les formats par rapport aux personas pour mieux correspondre à leurs préférences.",
    Statistics_FollowerViews_up_urgency: "Moyen",

    Statistics_FollowerViews_neutral_title: "Les vues des abonnés sont moyennes 💡Testez le timing et le format",
    Statistics_FollowerViews_neutral_summary:
      "L'heure de publication ou le type de contenu pourrait nécessiter un ajustement ; effectuez des tests simples.",
    Statistics_FollowerViews_neutral_action1: "Déplacez les horaires de publication et suivez l'impact.",
    Statistics_FollowerViews_neutral_action2: "Testez un nouveau format spécialement pour les abonnés.",
    Statistics_FollowerViews_neutral_action3: "Personnalisez le contenu en fonction du comportement passé du public.",
    Statistics_FollowerViews_neutral_urgency: "Faible",

    Statistics_FollowerViews_down_title: "Vues des abonnés en baisse 💡Recueillez des retours",
    Statistics_FollowerViews_down_summary:
      "Possible éloignement de la persona ; collectez les retours et appliquez 3 changements rapides.",
    Statistics_FollowerViews_down_action1: "Recueillez les retours récents et appliquez trois changements rapides.",
    Statistics_FollowerViews_down_action2: "Publiez des Stories engageantes pour réactiver l'audience.",
    Statistics_FollowerViews_down_action3: "Testez des versions personnalisées du contenu.",
    Statistics_FollowerViews_down_urgency: "Élevé",

    Statistics_FollowerViews_zero_title: "Vues des abonnés à zéro 💡Assurez-vous d'avoir des abonnés actifs",
    Statistics_FollowerViews_zero_summary:
      "Vous avez peut-être peu d'abonnés actifs ; réveillez-les d'abord, puis engagez.",
    Statistics_FollowerViews_zero_action1: "Publiez plusieurs Stories et posts pour activer l'audience.",
    Statistics_FollowerViews_zero_action2: "Interagissez directement avec 10 abonnés actifs.",
    Statistics_FollowerViews_zero_action3: "Créez du contenu basé sur les intérêts passés.",
    Statistics_FollowerViews_zero_urgency: "Élevé",

    Statistics_NonFollowerViews_up_title: "Vues des non-abonnés en hausse 💡Nouvelle opportunité",
    Statistics_NonFollowerViews_up_summary:
      "Des personnes en dehors de vos abonnés regardent ; chaque post doit donner une raison solide de s'abonner.",
    Statistics_NonFollowerViews_up_action1:
      "Incluez une raison forte de s'abonner dans la légende (ex. : contenu en série ou tutoriels étape par étape).",
    Statistics_NonFollowerViews_up_action2: "Créez des Reels tendance et engageants pour attirer les non-abonnés.",
    Statistics_NonFollowerViews_up_action3: "Utilisez des hashtags ciblés et des collaborations pertinentes.",
    Statistics_NonFollowerViews_up_urgency: "Moyen",

    Statistics_NonFollowerViews_neutral_title: "Vues des non-abonnés stables 💡Optimisez hashtags et diffusion",
    Statistics_NonFollowerViews_neutral_summary:
      "L'optimisation des hashtags et du contenu partageable peut augmenter le trafic des non-abonnés.",
    Statistics_NonFollowerViews_neutral_action1:
      "Identifiez les hashtags efficaces et maintenez-en quelques-uns constants.",
    Statistics_NonFollowerViews_neutral_action2: "Produisez plus de contenu partageable.",
    Statistics_NonFollowerViews_neutral_action3: "Faites une courte collaboration avec des pages connexes.",
    Statistics_NonFollowerViews_neutral_urgency: "Faible",

    Statistics_NonFollowerViews_down_title: "Vues non-abonnés en baisse 💡Collaboration et promo nécessaires",
    Statistics_NonFollowerViews_down_summary:
      "La portée Explore est en baisse ; ramenez du trafic avec une collaboration ou une petite promo.",
    Statistics_NonFollowerViews_down_action1: "Organisez rapidement une collaboration avec une page pertinente.",
    Statistics_NonFollowerViews_down_action2: "Créez plus de posts partageables et publiez un post boosté.",
    Statistics_NonFollowerViews_down_action3: "Lancez une petite publicité ciblée pour récupérer le trafic.",
    Statistics_NonFollowerViews_down_urgency: "Élevé",

    Statistics_NonFollowerViews_zero_title: "Vues non-abonnés zéro 💡Créez des signaux pour Explore",
    Statistics_NonFollowerViews_zero_summary:
      "Pour générer le premier trafic, les Reels tendance et les collaborations sont le meilleur début.",
    Statistics_NonFollowerViews_zero_action1: "Produisez 3 Reels basés sur les tendances.",
    Statistics_NonFollowerViews_zero_action2: "Publiez un post boosté pour générer le trafic initial.",
    Statistics_NonFollowerViews_zero_action3: "Démarrez une collaboration rapide avec une page pertinente.",
    Statistics_NonFollowerViews_zero_urgency: "Élevé",

    Statistics_Shares_up_title: "Partages en hausse 💡Ton contenu vaut la peine d’être diffusé",
    Statistics_Shares_up_summary:
      "Les gens partagent tes posts ; le contenu a une valeur immédiate et peut générer des conversions.",
    Statistics_Shares_up_action1: "Analyse les retours de partage et identifie les modèles.",
    Statistics_Shares_up_action2: "Ajoute une raison claire de partager dans la légende ('Envoie à ton ami').",
    Statistics_Shares_up_action3: "Conçois une série éducative partageable.",
    Statistics_Shares_up_urgency: "Moyen",

    Statistics_Shares_neutral_title: "Partages faibles ou stables 💡juste un petit déclencheur nécessaire",
    Statistics_Shares_neutral_summary: "Parfois, un simple CTA court suffit à augmenter les partages.",
    Statistics_Shares_neutral_action1: "Ajoute un CTA très court pour partager à la fin du post.",
    Statistics_Shares_neutral_action2: "Produis plus de contenu sauvegardable et partageable.",
    Statistics_Shares_neutral_action3: "Teste un modèle 'Envoie à ton ami'.",
    Statistics_Shares_neutral_urgency: "Faible",

    Statistics_Shares_down_title: "Partages en baisse 💡Besoin de contenu plus pratique",
    Statistics_Shares_down_summary:
      "Le contenu est moins partageable ; crée quelque chose que les gens voudront envoyer aux autres.",
    Statistics_Shares_down_action1: "Conçois des checklists ou du contenu étape par étape.",
    Statistics_Shares_down_action2: "Publie des tutoriels courts et concis.",
    Statistics_Shares_down_action3: "Ajoute un CTA clair pour le partage.",
    Statistics_Shares_down_urgency: "Élevé",

    Statistics_Shares_zero_title: "Aucun partage 💡Il faut un point de départ",
    Statistics_Shares_zero_summary:
      "Soit il n’y a pas de données, soit le contenu n’est pas partageable ; crée rapidement un plan de distribution.",
    Statistics_Shares_zero_action1: "Produis plusieurs contenus de 5 conseils ou checklists.",
    Statistics_Shares_zero_action2: "Lance un petit boost pour obtenir le premier signal.",
    Statistics_Shares_zero_action3: "Écris une raison claire de partager dans la légende.",
    Statistics_Shares_zero_urgency: "Élevé",

    Statistics_Engagement_up_title: "Engagement en hausse 💡Consolidez la formule",
    Statistics_Engagement_up_summary:
      "Vous avez trouvé un modèle gagnant ; il est temps de le répéter et de l'amplifier.",
    Statistics_Engagement_up_action1: "Enregistrez précisément les formats et horaires réussis.",
    Statistics_Engagement_up_action2: "Ajoutez des formats favorisant l'engagement au calendrier de contenu.",
    Statistics_Engagement_up_action3: "Testez un nouveau format de rétention chaque semaine.",
    Statistics_Engagement_up_urgency: "Moyen",

    Statistics_Engagement_neutral_title: "Engagement moyen 💡Besoin d'un nouvel déclencheur",
    Statistics_Engagement_neutral_summary:
      "Pour croître, introduisez de nouveaux déclencheurs comme des questions, défis ou invitations aux commentaires.",
    Statistics_Engagement_neutral_action1: "Publiez un post hebdomadaire invitant aux commentaires.",
    Statistics_Engagement_neutral_action2: "Canalisez l'engagement et comparez les résultats de différents formats.",
    Statistics_Engagement_neutral_action3: "Concevez quelques modèles pour des interactions rapides.",
    Statistics_Engagement_neutral_urgency: "Faible",

    Statistics_Engagement_down_title: "Engagement en baisse 💡Redesign rapide nécessaire",
    Statistics_Engagement_down_summary:
      "De nouveaux tests doivent être lancés immédiatement ; un plan de 14 jours est le meilleur départ.",
    Statistics_Engagement_down_action1: "Exécutez un plan de 14 jours avec 3 formats différents.",
    Statistics_Engagement_down_action2: "Enregistrez les données quotidiennement et ajustez rapidement.",
    Statistics_Engagement_down_action3: "Demandez directement à votre audience quel contenu l'intéresse.",
    Statistics_Engagement_down_urgency: "Élevé",

    Statistics_Engagement_zero_title: "Engagement zéro 💡Plan intensif de 7 jours nécessaire",
    Statistics_Engagement_zero_summary:
      "Vous devez générer rapidement des signaux d'engagement ; publiez quotidiennement du contenu interactif et suivez les données.",
    Statistics_Engagement_zero_action1: "Publiez des sondages, questions ouvertes et petits défis.",
    Statistics_Engagement_zero_action2: "Testez chaque format pendant 3 jours.",
    Statistics_Engagement_zero_action3: "Répondez rapidement aux commentaires et messages.",
    Statistics_Engagement_zero_urgency: "Élevé",

    Statistics_Replies_up_title: "Réponses aux Stories élevées 💡Transforme-les en contenu",
    Statistics_Replies_up_summary: "Ton audience écrit ; elle veut interagir. C’est de l’or pour le contenu.",
    Statistics_Replies_up_action_1: "Sélectionne 3 des meilleures réponses et transforme-les en post ou Reel.",
    Statistics_Replies_up_action_2: "Crée un Q&A ou FAQ avec les réponses les plus fréquentes.",
    Statistics_Replies_up_action_3: "Montre quelques réponses dans la prochaine story pour motiver les autres.",
    Statistics_Replies_up_urgency: "Moyen",

    Statistics_Replies_neutral_title: "Réponses faibles 💡Ajoute un déclencheur",
    Statistics_Replies_neutral_summary: "Parfois, une simple question suffit pour obtenir plus de réponses.",
    Statistics_Replies_neutral_action_1: "Ajoute un sticker question, sondage ou quiz.",
    Statistics_Replies_neutral_action_2: "Pose des questions courtes et engageantes.",
    Statistics_Replies_neutral_action_3: "Réagis rapidement aux réponses pour booster l’interaction.",
    Statistics_Replies_neutral_urgency: "Faible",

    Statistics_Replies_down_title: "Réponses en baisse 💡Renforce la proximité",
    Statistics_Replies_down_summary: "Le public semble distant ; reconnecte avec du contenu plus personnel.",
    Statistics_Replies_down_action_1:
      "Publie quelques stories plus personnelles, basées sur l’expérience ou émotionnelles.",
    Statistics_Replies_down_action_2: "Pose des questions nécessitant des expériences personnelles pour répondre.",
    Statistics_Replies_down_action_3: "Accorde de l’importance aux premières réponses ; réagis ou réponds-y.",
    Statistics_Replies_down_urgency: "Élevé",

    Statistics_Replies_zero_title: "Zéro réponse 💡Invitation directe nécessaire",
    Statistics_Replies_zero_summary: "Quand personne ne répond, pose des questions tentantes et directes.",
    Statistics_Replies_zero_action_1:
      "Publie des questions très simples et engageantes (comme choisir entre deux options).",
    Statistics_Replies_zero_action_2: "Mets en avant les réponses obtenues pour encourager les autres.",
    Statistics_Replies_zero_action_3: "Fais une story interactive légère chaque jour.",
    Statistics_Replies_zero_urgency: "Élevé",

    Statistics_TotalTime_up_title: "Temps de visionnage augmenté 💡Donne du contenu plus profond",
    Statistics_TotalTime_up_summary:
      "Le public investit du temps ; il est prêt pour des contenus plus longs et segmentés.",
    Statistics_TotalTime_up_action_1: "Crée des vidéos plus longues avec structure introduction/milieu/conclusion.",
    Statistics_TotalTime_up_action_2: "Ajoute des liens vers du contenu supplémentaire dans la bio ou les Highlights.",
    Statistics_TotalTime_up_action_3: "Segmenter clairement la vidéo pour augmenter la rétention.",
    Statistics_TotalTime_up_urgency: "Moyen",

    Statistics_TotalTime_neutral_title: "Temps de visionnage normal 💡Renforce la structure",
    Statistics_TotalTime_neutral_summary:
      "Le public reste, mais n’est pas totalement captif ; améliore la structure pour les retenir.",
    Statistics_TotalTime_neutral_action_1: "Applique une structure en trois couches pour les vidéos.",
    Statistics_TotalTime_neutral_action_2:
      "Mets en évidence les points clés pour que les spectateurs sachent à quoi s’attendre.",
    Statistics_TotalTime_neutral_action_3: "Crée une version résumée pour tests et comparaisons.",
    Statistics_TotalTime_neutral_urgency: "Faible",

    Statistics_TotalTime_down_title: "Temps de visionnage en baisse 💡Premier hook faible",
    Statistics_TotalTime_down_summary:
      "Les 3 premières secondes doivent accrocher ; rendez-les plus rapides, percutantes et engageantes.",
    Statistics_TotalTime_down_action_1: "Réécrivez les 3 premières secondes et testez plusieurs versions.",
    Statistics_TotalTime_down_action_2: "Créez des versions très courtes de 15–30 secondes.",
    Statistics_TotalTime_down_action_3: "Affinez le rythme du montage, les cuts et la musique.",
    Statistics_TotalTime_down_urgency: "Élevé",

    Statistics_TotalTime_zero_title: "Temps de visionnage zéro 💡Pas encore publié ?",
    Statistics_TotalTime_zero_summary:
      "Si la vidéo existe mais aucun temps n'est enregistré, vérifiez d'abord les problèmes techniques.",
    Statistics_TotalTime_zero_action_1: "Assurez-vous que le contenu est bien publié.",
    Statistics_TotalTime_zero_action_2: "Si non publié, postez 3 reels courts consécutifs.",
    Statistics_TotalTime_zero_action_3: "Exécutez un boost ou une première diffusion pour collecter les données.",
    Statistics_TotalTime_zero_urgency: "Élevé",

    Statistics_ReachMonth_up_title: "Reach Mensuel en Hausse 💡Bloquez les Modèles",
    Statistics_ReachMonth_up_summary: "Les mois réussis sont clairs ; notez les modèles et planifiez le mois prochain.",
    Statistics_ReachMonth_up_action_1: "Analysez les mois performants et enregistrez les modèles.",
    Statistics_ReachMonth_up_action_2: "Mettez à jour le calendrier de contenu avec ces modèles.",
    Statistics_ReachMonth_up_action_3: "Repostez les formats gagnants pour le mois suivant.",
    Statistics_ReachMonth_up_urgency: "Moyen",

    Statistics_ReachMonth_neutral_title: "Reach Mensuel Stable 💡Temps pour Tester & Croître",
    Statistics_ReachMonth_neutral_summary:
      "Pour augmenter le reach mensuel, lancez une campagne courte ou une publicité limitée.",
    Statistics_ReachMonth_neutral_action_1: "Lancez une campagne conjointe ou une publicité limitée.",
    Statistics_ReachMonth_neutral_action_2: "Enregistrez, comparez les résultats et optimisez.",
    Statistics_ReachMonth_neutral_action_3: "Boostez à nouveau les posts précédemment performants.",
    Statistics_ReachMonth_neutral_urgency: "Faible",

    Statistics_ReachMonth_down_title: "Reach Mensuel en Baisse 💡Recréez le Contenu",
    Statistics_ReachMonth_down_summary: "Pour restaurer le reach, republiez ou reconstruisez les posts clés.",
    Statistics_ReachMonth_down_action_1: "Republiez ou recréez les posts clés.",
    Statistics_ReachMonth_down_action_2: "Lancez une campagne de production et promotion de contenu de 14 jours.",
    Statistics_ReachMonth_down_action_3: "Revérifiez les hashtags et tags.",
    Statistics_ReachMonth_down_urgency: "Élevé",

    Statistics_ReachMonth_zero_title: "Reach Mensuel Zéro 💡Vérifiez d'abord les données",
    Statistics_ReachMonth_zero_summary:
      "Pas de données ou données incomplètes ; vérifiez les problèmes techniques, puis exécutez un plan de 14 jours.",
    Statistics_ReachMonth_zero_action_1: "Vérifiez les connexions et enregistrements de données.",
    Statistics_ReachMonth_zero_action_2: "Exécutez un plan de production de contenu de 14 jours.",
    Statistics_ReachMonth_zero_action_3: "Suivez les résultats quotidiens.",
    Statistics_ReachMonth_zero_urgency: "Élevé",

    Statistics_MonthEngagement_up_title: "Engagement Mensuel en Hausse 💡Passez à l’Échelle",
    Statistics_MonthEngagement_up_summary: "Enregistrez les modèles positifs mensuels et répétez-les.",
    Statistics_MonthEngagement_up_action_1: "Documentez les modèles et formats réussis.",
    Statistics_MonthEngagement_up_action_2: "Définissez des KPI et un plan clair pour le mois prochain.",
    Statistics_MonthEngagement_up_action_3: "Effectuez de petits tests hebdomadaires pour améliorer l’engagement.",
    Statistics_MonthEngagement_up_urgency: "Moyen",

    Statistics_MonthEngagement_neutral_title: "Engagement Mensuel Normal 💡Ajoutez un Élément Défi",
    Statistics_MonthEngagement_neutral_summary: "Un défi ou une question hebdomadaire peut augmenter l’engagement.",
    Statistics_MonthEngagement_neutral_action_1:
      "Publiez un contenu challenge ou basé sur une question chaque semaine.",
    Statistics_MonthEngagement_neutral_action_2: "Enregistrez et comparez les résultats.",
    Statistics_MonthEngagement_neutral_action_3: "Créez une série hebdomadaire d’engagement.",
    Statistics_MonthEngagement_neutral_urgency: "Faible",

    Statistics_MonthEngagement_down_title: "Engagement Mensuel en Baisse 💡Lancez un Plan de 14 Jours",
    Statistics_MonthEngagement_down_summary: "Révisez les formats et exécutez un plan de 14 jours.",
    Statistics_MonthEngagement_down_action_1: "Mettez en place un plan de 14 jours avec 3 formats différents.",
    Statistics_MonthEngagement_down_action_2: "Analysez les résultats quotidiennement.",
    Statistics_MonthEngagement_down_action_3: "Collectez les retours directs du public.",
    Statistics_MonthEngagement_down_urgency: "Élevé",

    Statistics_MonthEngagement_zero_title: "Engagement Mensuel Zéro 💡Programme Urgent de 7 Jours",
    Statistics_MonthEngagement_zero_summary: "Publiez 7 posts interactifs rapides et suivez quotidiennement.",
    Statistics_MonthEngagement_zero_action_1: "Créez 7 posts interactifs.",
    Statistics_MonthEngagement_zero_action_2: "Examinez les résultats chaque jour.",
    Statistics_MonthEngagement_zero_action_3: "Interagissez avec le public via DM et commentaires.",
    Statistics_MonthEngagement_zero_urgency: "Élevé",

    Statistics_MonthView_up_title: "Vues Mensuelles en Hausse 💡Verrouillez la Structure",
    Statistics_MonthView_up_summary: "La stratégie vidéo fonctionne ; publiez ces formats de manière cohérente.",
    Statistics_MonthView_up_action_1: "Documentez votre stratégie vidéo.",
    Statistics_MonthView_up_action_2: "Transformez la production régulière en format standard.",
    Statistics_MonthView_up_action_3: "Examinez et enregistrez les indicateurs clés mensuels.",
    Statistics_MonthView_up_urgency: "Moyen",

    Statistics_MonthView_neutral_title: "Vues Mensuelles Stables 💡Essayez un Mix de Formats",
    Statistics_MonthView_neutral_summary: "Mixer Reels et Stories peut créer de nouveaux canaux de trafic.",
    Statistics_MonthView_neutral_action_1: "Créez du contenu mixte Reels+Stories.",
    Statistics_MonthView_neutral_action_2: "Enregistrez et comparez les performances.",
    Statistics_MonthView_neutral_action_3: "Ajoutez des légendes guidant vers la vidéo.",
    Statistics_MonthView_neutral_urgency: "Faible",

    Statistics_MonthView_down_title: "Vues Mensuelles en Baisse 💡Concentrez-vous sur les Reels",
    Statistics_MonthView_down_summary:
      "Les Reels courts avec des couvertures attrayantes sont le moyen le plus rapide de récupérer les vues.",
    Statistics_MonthView_down_action_1: "Créez des Reels de 15 à 30 secondes.",
    Statistics_MonthView_down_action_2: "Concevez des couvertures attrayantes.",
    Statistics_MonthView_down_action_3: "Effectuez des tests de timing.",
    Statistics_MonthView_down_urgency: "Élevé",

    Statistics_MonthView_zero_title: "Vues Mensuelles Zéro 💡Vérifiez les Problèmes Techniques d’Abord",
    Statistics_MonthView_zero_summary:
      "Les données ou la publication peuvent poser problème ; vérifiez la technique d’abord, puis lancez un plan de 14 jours.",
    Statistics_MonthView_zero_action_1: "Vérifiez les données vidéo techniquement.",
    Statistics_MonthView_zero_action_2: "Mettez en œuvre un plan de production de contenu de 14 jours.",
    Statistics_MonthView_zero_action_3: "Surveillez les résultats quotidiennement.",
    Statistics_MonthView_zero_urgency: "Élevé",
    Statistics_RePosts_up_title: "Les Reposts Augmentent 💡 Profitez-en",
    Statistics_RePosts_up_summary:
      "Votre audience partage vos posts ; cela signifie que votre contenu mérite d’être diffusé.",
    Statistics_RePosts_up_action_1: "Ajoutez une raison claire de repost dans la légende (« Envoie-le à un ami »).",
    Statistics_RePosts_up_action_2: "Créez une série éducative facilement partageable.",
    Statistics_RePosts_up_action_3: "Analysez les retours des reposts et identifiez les patterns.",
    Statistics_RePosts_up_urgency: "Moyen",
    Statistics_RePosts_neutral_title: "Les Reposts Sont Faibles ou Stables 💡 Il Suffit d’un Simple Déclencheur",
    Statistics_RePosts_neutral_summary: "Parfois, un CTA court suffit pour augmenter les reposts.",
    Statistics_RePosts_neutral_action_1: "Ajoutez un CTA très court pour le repost à la fin du Post.",
    Statistics_RePosts_neutral_action_2: "Créez davantage de contenu enregistrable et partageable.",
    Statistics_RePosts_neutral_action_3: "Testez un format comme « Envoie-le à un ami ».",
    Statistics_RePosts_neutral_urgency: "Faible",
    Statistics_RePosts_down_title: "Les Reposts Sont en Baisse 💡 Il Faut un Contenu Plus Utile",
    Statistics_RePosts_down_summary:
      "Le contenu est moins partageable ; vous devez créer quelque chose que les gens veulent envoyer aux autres.",
    Statistics_RePosts_down_action_1: "Concevez une checklist ou un contenu étape par étape.",
    Statistics_RePosts_down_action_2: "Publiez des tutoriels courts et concis.",
    Statistics_RePosts_down_action_3: "Ajoutez un CTA clair pour le repost.",
    Statistics_RePosts_down_urgency: "Élevé",
    Statistics_RePosts_zero_title: "Aucun Repost Enregistré 💡 Il Faut Créer un Point de Départ",
    Statistics_RePosts_zero_summary:
      "Soit il n’y a pas de données, soit le contenu n’est pas partageable ; concevez rapidement un plan de distribution.",
    Statistics_RePosts_zero_action_1: "Créez plusieurs contenus en 5 points ou sous forme de checklist.",
    Statistics_RePosts_zero_action_2: "Lancez un petit boost pour obtenir le premier signal.",
    Statistics_RePosts_zero_action_3: "Ajoutez une raison claire de repost dans la légende.",
    Statistics_RePosts_zero_urgency: "Élevé",

    // statistics suggestions box

    // 4️⃣ Page -> tools
    pageTools_hashtags: "Hashtags",
    pageTools_MyList: "Liste des hashtags",
    pageTools_CreateNewListexplain: "Créez votre liste # et utilisez-la pour créer des posts",
    Analyzer: "Analyseur (AI)",
    pageTools_CreateNewList: "Créer Une Nouvelle Liste",
    pageTools_CustomFont: "Police personnalisée",
    pageTools_CustomFontExplain: "Utilisez des polices personnalisées pour vos publications Instagram!",
    pageToolspopup_CreateNewListexplain:
      "Appuyez sur <Enter> ou <Space> pour créer un nouveau hashtag. Cliquez sur un hashtag pour le supprimer.",
    pageToolspopup_Listname: "Nom de la liste",
    pageToolspopup_hashtags: "Hashtags",
    pageToolspopup_typehere: "Tapez ici",
    pageTools_hashtagList: "Liste des hashtags",
    pageTools_CreateNewListpic: "Nouveau analyseur d'image",
    pageTools_CreateNewListpicexplain: "Générer des hashtags liés à l'image",
    pageTools_CreateNewListpage: "Nouveau analyseur de page",
    pageTools_CreateNewListpageexplain: "Générer des hashtags liés à l'URL de la page Instagram",
    pageToolspopup_pageURL: "ID Instagram",
    pageToolspopup_HideLikeandViewCounts: "Masquer les mentions J'aime et les vues",
    pageToolspopup_TurnoffCommenting: "Désactiver les commentaires",
    pageToolspopup_TurnoffCommentingExplain: "Les commentaires sur ce Post seront désactivés",
    pageToolspopup_TurnoffCommentingexplainforlottery:
      "Les commentaires sur ce Post seront désactivés pendant le loterie",

    pageToolspopup_TopHashtag: "Hashtag le plus utilisé",
    pageToolspopup_TopHashtagexplain: "Voici combien de fois vous avez utilisé ce hashtag sur la page.",
    pageToolspopup_allRepliedcomments: "Tous les commentaires répondus",
    noresult: "Aucun résultat",
    viewreplies: "Voir les réponses",
    allRepliedcomments: "Tous les commentaires répondus",
    Followers: "Abonnés",
    NonFollowers: "Non abonnés",
    pageToolspopup_ViewersLikes: "Spectateurs et J'aime",
    supportedformat: "Format Pris en Charge",
    limitsize: "Taille Limite",
    TagMention: "Tag & Mention",
    cover: "Couverture",
    Pleaseselect: "Veuillez sélectionner",
    replace: "Remplacer",
    Album: "Album",
    SavedHashtagList: "Liste de Hashtags Sauvegardée",
    SavedHashtagListexplain: "Sélectionnez un hashtag pour l'ajouter à la fin de la légende",
    FirstComment: "Premier Commentaire",
    PinFirstComment: "Épingler le Premier Commentaire",
    areyousure: "Êtes-vous sûr !?",
    shouldFollower: "L'utilisateur doit suivre la page",
    draftexplain: "Vous tentez d'enregistrer en tant que brouillon",
    deletedraftexplain: "Vous tentez de supprimer le brouillon",
    deleteorderexplain: "Vous essayez de supprimer une commande",

    Addpeopleexplain: "*Après avoir tagué des personnes, ajustez le tag ou double-cliquez pour le supprimer",
    AdvanceSettings: "Paramètres avancés",
    sharepreviewtofeed: "Partager l'aperçu sur le fil",
    Videocopyrightbypass: "Contournement des droits d'auteur vidéo",
    SetScheduledPost: "Programmer une Publication",
    SetScheduledPostexplain: "Cette publication sera publiée à l'heure spécifiée",
    SetScheduledStoryexplain: "Cette story sera publiée à l'heure spécifiée",
    addtoproduct: "Ajouter aux Produits",
    addtoproductexplain: "Cette publication sera ajoutée en tant que produit à votre liste de produits",
    TurnoffCommentingexplain: "Les commentaires sur cette publication seront désactivés",
    RecommendedDateTime: "Date et heure recommandées",
    RecommendedDateTimeexplain: "Ces horaires sont basés sur l'analyse de votre page",
    publish: "Publier",
    pageTools_global: "Global",
    pageTools_FA_AR: "Farsi / Arabe",
    pageTools_Overall: "Global",
    pageTools_year: "Année",
    pageTools_Month: "Mois",
    pageTools_Week: "Semaine",
    pageTools_Day: "Jour",
    pageTools_hashtag: "Hashtag",
    pageTools_USED: "Utilisé",
    pageTools_SearchedHashtag: "Hashtag recherché",
    pageTools_TrendHashtags: "Hashtags tendance",
    pageTools_AutoInterAction: "Interaction Auto avec les Abonnés",
    pageTools_AcceptPendingRequests: "Accepter Automatiquement les Demandes de Suivi",
    pageTools_LikeAllNewComments: "Aimer les Nouveaux Commentaires",
    pageTools_LikeNewFollowersPosts: "Aimer les Derniers Posts des Nouveaux Abonnés",
    pageTools_RemoveAllFollowings: "Supprimer Tous les Abonnements",
    pageTools_WinnerPicker: "Loterie (Choix du Gagnant)",
    pageTools_DayEvents: "Événements du Jour",
    pageTools_EventDateRange: "Plage de Dates",
    pageTools_EventLanguage: "Langue",
    pageTools_EventSelectDate: "Sélectionner la Plage de Dates",
    pageTools_EventSearch: "Rechercher des Événements",
    pageTools_EventEmpty: "Aucun événement trouvé pour la plage sélectionnée",
    pageTools_EventReligious: "Religieux",
    pageTools_EventIdeas: "Idées d'Événements",
    pageTools_IdeaCreate: "Générer des Idées d'Événements",
    pageTools_IdeaExplain: "Obtenez des idées de contenu basées sur l'IA pour les événements et occasions à venir",
    pageTools_CreateEventIdea: "Générer des Idées d'Événements",
    pageTools_CreateEventIdeaPrompt: "Sujet / Invite",
    pageTools_CreateEventIdeaPromptPlaceholder:
      "ex: chaussures, fitness, voyage... (laisser vide pour tous les sujets)",
    pageTools_CreateEventIdeaOptional: "optionnel",
    pageTools_CreateEventIdeaSubmit: "Générer",
    pageTools_CreateEventIdeaCancel: "Annuler",
    pageTools_EventIdeasLanguage: "Langue",
    pageTools_EventIdeasFetch: "Charger les Idées",
    pageTools_EventIdeasEmpty: "Aucune idée d'événement trouvée",
    pageTools_EventIdeasLoadMore: "Plus",
    pageTools_EventIdeasIdea: "Idée",
    pageTools_EventIdeasCountry: "Pays",
    pageTools_EventIdeasPrompt: "Sujet",
    pageTools_EventIdeasCreatedTime: "Date de Création",
    pageTools_CustomEvent: "Événement Personnalisé",
    pageTools_exportcomments:
      "Tous les commentaires sont exportés sous forme de fichier Excel et peuvent être téléchargés et partagés",

    pageTools_Lottery: "Créer une Loterie par Points",
    pageTools_emptylotteryList: "Vous n'avez encore créé aucune loterie",

    pageTools_LotteryExplain: "Basé sur les scores des utilisateurs dans un post",
    pageTools_fromFollowers: "Depuis les Abonnés",
    pageTools_FromFollowersExplain: "Au hasard parmi tous les abonnés",
    pageTools_Result: "Résultat",
    pageTools_ResultExplain: "État de la loterie précédente",
    pageTools_popup_detail: "Détail",
    pageTools_popup_history: "Historique",
    pageTools_LikeAllNewCommentsExplain:
      "Lorsque l'un de vos abonnés laisse un commentaire sur un post, il sera automatiquement aimé.",
    pageTools_AcceptType: "Type d'activation",
    pageTools_popup_AlwaysActive: "Toujours actif",
    pageTools_popup_JustOnce: "Une seule fois",
    pageTools_AcceptPendingRequestsexplain: "Accepter automatiquement toutes les demandes de follow des individus.",
    pageTools_onlyprivate: "*Fonctionne uniquement avec les pages privées.",
    pageTools_MaxLike: "Nombre de publications qui seront aimées",
    pageTools_Reacceptfollower: "Re-suivre après désabonnement",
    pageTools_Reacceptfollowerexplain:
      "Si quelqu'un a déjà suivi, se désabonne puis demande à suivre à nouveau, le système acceptera.",
    waitday: "Temps d'attente",
    waitdayexplain:
      "Si une personne est suivie par vous ou par le système, elle sera supprimée après la période d'attente spécifiée.",
    waitdayexplain2: "Le nombre d'attente est en jours. Si ce nombre est 0, l'action sera exécutée immédiatement.",
    pageTools_LikeNewFollowersPostsexplain:
      "Lorsque quelqu'un de nouveau vous suit, son dernier post sera automatiquement liké.",
    pageTools_RemoveAllFollowingsexplain: "Cette option supprime automatiquement tous vos suivis de la page.",
    pageTools_progress: "Ce processus peut prendre jusqu'à plusieurs jours, en fonction du nombre de vos followers.",
    pageTools_JustUnfollowwho: "Seul Unfollow ceux qui ne m'ont pas suivi en retour",
    pageTools_AllmyFollowings: "Tous mes Followings",
    pageTools_pageanAnalyzer: "Analyseur de page",
    pageTools_pictureanAnalyzer: "Analyseur d'image",
    pageTools_StartAnalysis: "Commencer l'analyse",
    pageLottery_Step: "Étape",
    pageLottery_Specifications: "Spécifications",
    pageLottery_SelectaPost: "Sélectionner un Post",
    pageLottery_SetDateTime: "Définir la date et l'heure",
    pageLottery_WinnersTasks: "Tâches des gagnants",
    pageLottery_WinnersTasksexplain: "Les tâches que chaque participant doit accomplir pour entrer dans la loterie.",
    pageLottery_NumberofWinners: "Nombre de gagnants",
    pageLottery_SetScoreForLottery: "Mentionner des Personnes",
    pageLottery_SetScoreForLotteryexplain:
      "Les utilisateurs doivent mentionner d'autres personnes pour participer à la Loterie",

    pageLottery_MinimumMention: "Mention minimum",
    pageLottery_MinimumMentionexplain: "Le nombre de personnes à mentionner",
    pageLottery_FollowedPage: "Page suivie",
    pageLottery_FollowedPageexplain:
      "Les gens doivent suivre votre page et/ou les pages que vous choisissez pour participer au tirage au sort",
    pageLottery_FollowmyPage: "Suivre ma Page",
    pageLottery_FollowalternativePages: "Suivre des pages alternatives",
    pageLottery_Termsconditions: "Conditions générales",
    pageLottery_publishTermsconditions: "Publier les conditions générales",
    pageLottery_previewTermsconditionsexplain: "Cette story sera montrée comme une story aux participants.",
    pageLottery_Termsconditionsbanner: "Bannière des conditions générales",
    pageLottery_Termsconditionsbannerexplain:
      "Choisissez une bannière pour annoncer les conditions du tirage au sort à vos followers.",
    pageLottery_model: "Modèle",
    pageLottery_Solid: "Solide",
    pageLottery_Radial: "Radial",
    pageLottery_Linear: "Linéaire",
    pageLottery_Background: "Arrière-plan",
    pageLottery_Color: "Couleur",
    pageLottery_Position: "Position",
    pageLottery_Degree: "Degré",
    pageLottery_TextBox: "Zone de texte",
    pageLottery_Opacity: "Opacité",
    pageLottery_Blur: "Flou",
    pageLottery_Font: "Police",
    pageLottery_Winnerannouncement: "Annonce du gagnant",
    pageLottery_participants1: "🎉 parmi 999,999 participants 🎉",
    pageLottery_participants2: "🥳 voici les chanceux : 🥳",
    pageLottery_participantsexplain:
      "*Le système ajuste automatiquement le nombre de participants et le nombre de gagnants et assigne leurs identifiants après chaque caractère @.",
    pageLottery_Addtocaption: "Ajouter à la légende après la fin de la loterie",
    pageLottery_Publishasstory: "Publiez la liste des gagnants en tant qu' story",
    pageLottery_deleteexplain: "Il supprimera définitivement la loterie, et cela ne peut pas être annulé.",
    pageLottery_Winnerpickersstatus: "Statut de la Lottery",
    pageLottery_scoreLotteryWinners: "Gagnants de la Loterie",
    pageLottery_NoWinners: "Aucun gagnant trouvé",
    pageLottery_RandomFollowersWinners: "Gagnants aléatoires des Followers",
    pageLottery_specifickeywordexplain:
      "Les utilisateurs doivent inclure un mot-clé spécifique dans leur Comment pour participer à la Lottery",
    pageLottery_FollowmyPageexplain: "Les utilisateurs doivent Follow la page pour participer à la Lottery",

    pageLottery_ShareRemainingTime: "Partager le temps restant",
    ShareTermsAndCondition: "Partager les conditions générales",
    pageLottery_LotteryRemainingTime: "Temps restant pour la Lottery",
    pageLottery_Winnerpickerisrunning: "La Lottery est en cours",
    pageLottery_ViewandEditDetails: "Voir & Modifier les détails",
    pageLottery_ActiveWinnerpickers: "Lottery active",
    pageTools_WinnerPickertooltip24hour: "La loterie peut être effectuée une fois toutes les 24 heures",
    specifickeywordstooltip: "Le système détecte automatiquement les emojis et les chiffres persans, arabes et anglais",
    pageLottery_FilterKeywords:
      "Le système sélectionne et affiche aléatoirement les commentaires contenant le mot-clé spécifié",
    pageLottery_NumberofWinnersexplain:
      "Définissez le nombre de gagnants du tirage au sort. Le nombre maximal de gagnants est de 100",
    pageLottery_permanentlinktooltip:
      "Ce lien est permanent, mais il sera supprimé lorsqu'un nouveau tirage au sort sera effectué",
    pageLottery_permanentlinkexplain:
      "Vous pouvez partager ce lien avec les utilisateurs pour vérifier l'intégrité et l'authenticité du tirage au sort",
    pageTools_randomly: "Aléatoirement",
    pageTools_BestEngagement: "Meilleur Engagement",
    pageTools_BestEngagementexplain: "Sélectionner parmi les followers qui ont eu le plus de likes et de commentaires",
    // #endregion page Section
    // #region 3️⃣ Message Section
    message_youareattemptingto: "Vous essayez de",
    message_blockexplain:
      "Ils ne pourront pas trouver votre profil, publications ou story sur Instagram. Instagram ne les informera pas que vous les avez bloqués.",
    message_deleteexplain: "Cela supprimera définitivement la discussion et ne peut pas être annulé.",
    message_block: "Bloquer",
    notactivemessage:
      "Ce chat a été temporairement désactivé. Veuillez envoyer votre réponse via l'application Instagram.",
    notactivemessageexplain:
      "Veuillez noter que si aucune réponse n'est envoyée dans les 24 heures, le chat deviendra inaccessible. Pour réactiver, vous pouvez soit répondre via l'application Instagram, soit attendre que l'autre partie vous envoie un nouveau message.",
    waitingforconnection: "En attente de connexion...",
    message_unblock: "Débloquer",
    messagesetting_goodbye: "Au revoir",
    messagesetting_welcome: "Bienvenue",
    messagesetting_welcomingmessage: "message de bienvenue",
    messagesetting_Activewelcomemessageexplain:
      "Ce message sera envoyé dans le Direct d'Instagram comme un <message de bienvenue> aux personnes qui vous suivent.",
    messagesetting_Sentmessages: "Message envoyé",
    message: "message",
    messagesetting_Activewelcomingmessage: "Message de bienvenue",
    receivedmessage: "Le message reçu",
    Messageresponse: "Réponse au message",
    receivedcomment: "Commentaire reçu",
    commentresponse: "Réponse au commentaire",
    Likethereceivedcomment: "Aimer le commentaire reçu",
    unreadmessage: "Message non lu",
    specifickeywords: "Mots-clés spécifiques",
    unreadcomment: "Commentaires non lus",
    hiddencommenttooltip:
      "Ce commentaire a été masqué de l'affichage. Seuls les administrateurs peuvent voir les commentaires masqués.",
    vanishmode: "Mode masqué",
    vanishmodeexplain:
      "En mode masqué, les messages restés sans réponse et qui n’ont été ni ignorés ni masqués seront affichés.",
    totalcomments: "Commentaires Totaux",
    unansweredcomments: "Commentaires Non Répondu",
    totalcommenters: "Total des Commentateurs",
    commentmanagement: "Bienvenue dans la gestion des commentaires",
    ticketmanagement: "Bienvenue dans la section de gestion des tickets clients",
    flowmanagement: "Créez un Flow et rendez vos réponses Instagram intelligentes et automatiques",

    QuickReplyexplain: "Tous les commentaires reçus sont automatiquement répondus.",
    autocommentReply: "Réponse Automatique aux Commentaires",
    Sendresponseifthepageisfollowed: "Envoyer une réponse si la page est suivie",
    Likethereceivedmessage: "Aimer le message reçu",
    messagesetting_welcometext:
      "Bonjour! 🌟\nBienvenue dans notre monde! 🎉 Nous sommes ravis que vous ayez rejoint notre communauté de followers. Nous sommes sûrs que nous passerons des moments incroyables ensemble. 🤗\n\nNous espérons que le contenu de cette page sera intéressant et utile pour vous, et que vous resterez avec nous. Si vous avez des questions ou des suggestions, nous serions heureux de vous aider. 😊\n\nMerci d'avoir choisi notre page et de rester avec nous. Nous avons hâte de vous accueillir dans notre monde incroyable.✨\n\nAvec respect et appréciation 💫",
    messagesetting_goodbyetext:
      "Bonjour! 👋\nNous sommes désolés de voir que vous avez quitté notre page. 😢 Nous apprécions chacun de nos followers, et vos retours et suggestions sont très importants pour nous.\n\nSi vous avez pris cette décision pour une raison spécifique, nous serions heureux que vous la partagiez avec nous. Nous sommes prêts à écouter vos idées et suggestions afin d'améliorer notre expérience pour nos followers. 🫡\n\nEn tout cas, nous vous souhaitons tout le meilleur et espérons que vous nous rejoindrez à nouveau à l'avenir. 💫",
    messagesetting_ActiveFarewellmessage: "Message d'adieu",
    messagesetting_ActiveFarewellmessageexplain:
      "Ce message sera envoyé dans Instagram Direct en tant que <Message d'adieu> aux personnes qui vous ont désabonné.",
    messagesetting_businessmessagefilter: "Filtre des messages professionnels",
    messagesetting_businessmessagefiltering: "Filtrage des messages professionnels",
    messagesetting_businessmessagefilteringexplain:
      "La conversation souhaitée sera automatiquement envoyée dans la section <Messages professionnels> dans l'onglet Direct.",
    messagesetting_specificwords: "mots personnalisés",
    messagesetting_autofiltering: "filtrage automatique (IA)",
    messagesetting_selectedwords: "Éléments sélectionnés",
    messagesetting_specificwordsexplain:
      "Vous pouvez entrer plusieurs mots, séparez chaque mot avec la touche <Entrée>.",
    messagesetting_Createanewsupportticket: "Créer un Ticket de Support",
    messagesetting_CreateanewsupportticketExplain:
      "Les utilisateurs peuvent utiliser cette option pour créer un ticket de support dans leur Direct. Vous pouvez également y répondre via le panneau Brancy ou directement dans Direct.",
    messagesetting_Changeapplicationlanguage: "Changer la Langue des Options de Direct",
    messagesetting_ChangeapplicationlanguageExplain:
      "En activant cette option, les utilisateurs peuvent afficher toutes les fonctionnalités de Direct en sept langues (anglais, persan, arabe, français, russe, turc et allemand). Le système effectuera les traductions nécessaires de manière intelligente.",
    messagesetting_ViewStoreandproducts: "Voir la Boutique et les Produits",
    messagesetting_ViewStoreandproductsExplain:
      "Avec cette option, les utilisateurs peuvent consulter votre catalogue de produits sous forme de liste ou d’album, avec des détails tels que la disponibilité, le prix et d’autres spécifications.",
    messagesetting_Visityourwebsite: "Afficher le Site Web",
    messagesetting_VisityourwebsiteExplain:
      "Les utilisateurs peuvent voir l'adresse de votre site Web et un bref résumé, et y accéder directement si nécessaire. (La vitesse de chargement de la page sera très rapide.)",
    messagesetting_Viewuserrolesandpermissions: "Règles et Régulations Commerciales",
    messagesetting_ViewuserrolesandpermissionsExplain:
      "En activant cette option, les utilisateurs peuvent consulter les règles, règlements et restrictions de votre entreprise définis dans les paramètres de Brancy.",
    messagesetting_Viewbusinesshourschart: "Horaires d'Ouverture de l'Entreprise",
    messagesetting_ViewbusinesshourschartExplain:
      "Les utilisateurs peuvent utiliser cette option pour consulter vos horaires d'ouverture. Cette fonctionnalité permet de réduire les messages envoyés en dehors des heures de travail.",
    messagesetting_Viewpricinginformation: "Tarifs des Services Publicitaires",
    messagesetting_ViewpricinginformationExplain:
      "En activant cette option, les utilisateurs peuvent voir les prix mis à jour de chacun de vos services publicitaires. Cette fonctionnalité réduit les demandes répétitives.",
    messagesetting_Searchforproducts: "Rechercher des Produits",
    messagesetting_SearchforproductsExplain:
      "Les utilisateurs peuvent envoyer le nom du produit, le numéro du post ou une partie de la légende pour obtenir les détails complets du produit et, s'ils le souhaitent, effectuer leur achat directement. Cette fonctionnalité a un impact positif sur la croissance des ventes.",
    messagesetting_addautomaticreplysystemsystem: "Une réponse système unifiée pour toutes les sections de la page",
    messagesetting_HideRobotReply: "Masquer les messages automatiques et les bots",
    messagesetting_HideRobotReplyExplain:
      "Les messages automatiques des bots sont masqués et seuls les vrais messages sont affichés dans le Direct",
    messagesetting_LikeRobotReply: "Like automatique des commentaires Story",
    messagesetting_HideRobotReplytooltip:
      "Les messages ne sont pas supprimés, ils sont uniquement masqués afin de faciliter la gestion des Direct",
    messagesetting_LikeRobotReplyExplain:
      "Les commentaires Story sont automatiquement likés pour améliorer l'engagement plus rapidement",
    messagesetting_automaticreplysystem: "Contrôle des réponses automatiques",
    messagesetting_automaticreplysystemforallpost:
      "Activer ou désactiver les réponses automatiques aux commentaires pour tous les Post",
    messagesetting_automaticreplysystemforallposttooltip:
      "Si vous avez configuré des réponses automatiques pour différents Post, cette option vous permet de toutes les activer ou désactiver en une seule fois. Pour modifier les réponses, vous devez ouvrir la page de chaque Post séparément",

    messagesetting_messagePanellanguage: "Langue par défaut du Direct",
    messagesetting_messagePanellanguageExplain: "La langue par défaut du bot Direct pour répondre aux messages.",
    messagesetting_AutoReplyPerFollow: "Modèle de suivi personnalisé",
    messagesetting_AutoReplyPerFollowExplain:
      "Utilisez ce modèle lorsque vous demandez à un utilisateur de suivre la page.",
    messagesetting_AutoReplyPerFollowtooltip:
      "Les utilisateurs qui ne vous follow pas recevront d'abord une demande de Follow. Après avoir follow votre page, le message automatique leur sera envoyé",
    messagesetting_AutoReplyPerFollowtitle: "Texte du message",
    messagesetting_AutoReplyPerFollowtitlesample: "Exemple : Follow notre page pour recevoir le message",
    messagesetting_AutoReplyPerFollowbtn: "Texte du bouton",
    messagesetting_AutoReplyPerFollowbtnsample: "Exemple : J'ai Follow, envoyez le message",
    messagesetting_automaticreplysystemexplain:
      "Le système répond automatiquement avec un message prédéfini à chaque message ou commentaire reçu dans n'importe quelle section de la page (Feed, Story, Reels, Live, etc.).",

    messagesetting_KeywordSensitive: "Sensible aux mots-clés",
    messagesetting_KeywordsSensitive: "Sensible aux mots-clés",
    sendreplydirectedsuccessfully: "Message de confirmation envoyé dans le comment après le Direct",

    autoReplyFor: "Réponse automatique dans",
    autocommentReplyExplain: "Le système répond automatiquement aux commentaires et messages reçus.",
    selectnewmessage: "Pour envoyer une réponse, veuillez sélectionner un message.",
    sendreplyticket: "Envoyer des Réponses",
    emptyticketdirect: "Aucun ticket reçu depuis les Directs de votre page",
    emptysystemticket: "Aucun ticket reçu des clients du système Brancy",
    emptycomment: "Aucun commentaire à afficher pour le moment",
    emptydirect: "Aucun message Direct à afficher pour le moment",

    respondToAllComments: "Répondre à Tous les Commentaires",
    sensitiveToSpecificKeywords: "Sensible à des Mots-clés Spécifiques",
    sensitiveToSpecificKeywordsExplain:
      "Si ces mots-clés apparaissent n'importe où dans le texte du commentaire, le système répond automatiquement",
    contain: "Contient le mot-clé",
    containExplain:
      "Activé, une réponse est envoyée si le commentaire contient le mot-clé. Désactivé, une réponse est envoyée uniquement si le commentaire entier correspond au mot-clé.",
    replyMethod: "Méthode de Réponse",
    respondInSameComment: "Répondre dans le Même Commentaire",
    respondDirectly: "Répondre par Message Direct",
    ticketID: "ID du Ticket",
    noNewAnsweredTickets: "Vous n’avez aucun ticket récemment répondu",
    noNewPendingTickets: "Vous n’avez aucun nouveau ticket en cours de traitement",
    noNewClosedTickets: "Vous n’avez aucun ticket fermé",

    Ticketclosedby: "Ticket fermé par",
    waitingforuserresponse: "En attente de la réponse de l'utilisateur",
    inactiveticketexpired: "Ce ticket a été désactivé en raison d'une inactivité au cours des dernières 24 heures.",
    automaticreply: "Réponse automatique",
    autodirectexplain:
      "Lorsque un mot-clé spécifique est reçu en Direct, votre réponse prédéfinie sera envoyée automatiquement en Direct",
    adddirectexplain: "Ajouter des réponses automatiques directes",
    autocommentexplain:
      "Lorsqu'un mot-clé spécifique est reçu dans un commentaire, votre réponse prédéfinie sera automatiquement envoyée dans le même commentaire",
    addcommentexplain: "Ajouter des réponses automatiques aux commentaires",
    messagesetting_icebreaker: "Bouton de démarrage de chat rapide",
    messagesetting_addNewButton: "Ajouter un Nouveau Bouton",
    messagesetting_icebreakerexplain:
      "Lorsqu'un utilisateur entre dans Direct pour la première fois, quatre boutons s'affichent, et en sélectionnant chacun, la réponse correspondante est envoyée.",
    messagesetting_addicebreakerexplain: "Ajoutez jusqu'à 4 boutons de démarrage de chat rapide",
    messagesetting_PersistentMenu: "Menu Persistant Direct",
    messagesetting_PersistentMenuexplain:
      "Un menu toujours disponible qui rend l'interaction des clients avec votre marque rapide, facile et sans besoin de taper.",
    messagesetting_addPersistentMenuexplain: "Ajoutez jusqu'à 3 boutons de menu persistant",
    Welcometodirectmessages: "Bienvenue dans les messages directs d'Instagram!",
    messagesetting_UseSystemButtonsExplain:
      "Utilisez les boutons système prêts à l’emploi pour fournir des informations standard comme Voir la boutique, Ticket de support et Changement de langue",
    messagesetting_UseAIPromptsExplain:
      "Grâce aux prompts IA, proposez des réponses intelligentes et personnalisées aux utilisateurs avec votre propre ton et style",
    messagesetting_ButtonTitle: "Titre du bouton",
    messagesetting_NoPromptsFound:
      "Aucun prompt trouvé. Vous serez redirigé vers la page de création pour créer un nouveau prompt.",
    messagesetting_CreateNewPrompt: "Créer un nouveau Prompt",
    messagesetting_SelectYourPrompt: "Sélectionnez votre Prompt",
    messagesetting_DefineCustomResponseExplain:
      "Définissez votre texte de réponse personnalisé afin qu’il soit envoyé automatiquement aux utilisateurs",
    messagesetting_SelectPredefinedFlowExplain:
      "Sélectionnez un flow prédéfini pour démarrer une conversation automatique et intelligente avec l’utilisateur",
    messagesetting_NoFlowsFound:
      "Aucun flow trouvé. Vous serez redirigé vers la page de création pour créer un nouveau flow.",
    messagesetting_CreateNewFlow: "Créer un nouveau Flow",
    messagesetting_SelectFlow: "Sélectionner le Flow",
    messagesetting_ViewFlow: "Afficher le Flow",
    messagesetting_UseGeneralAIExplain:
      "Utiliser l’IA générale pour une interaction libre et sans restriction avec les utilisateurs",
    tool_token_usage_guide: "Consommation approximative de tokens lors de l’exécution de cet outil",
    tool_how_use: "Comment utiliser l’outil",
    tool_how_work: "Comment fonctionne l’outil",
    send_sms_ir_code_description: "Envoyer un SMS au mobile de l'utilisateur via la plateforme SMS.ir",
    send_sms_ir_code_completeDescription:
      "Cet outil permet d’envoyer des SMS aux utilisateurs, comme des codes de vérification, d’inscription ou des notifications. Il permet de récupérer les numéros de téléphone et de les utiliser dans votre service SMS.",
    send_sms_ir_code_howUse: `1- Obtenez votre ApiKey depuis SMS.ir et saisissez-le.
2- Ajoutez votre modèle SMS dans le champ TemplateId.
3- Partout où {CODE} apparaît, il sera remplacé automatiquement par un code OTP.
`,
    send_sms_ir_code_howWork: `1- L’utilisateur envoie son numéro en Direct.
2- Le SMS est envoyé. Si {CODE} est présent, il est remplacé par un OTP.
3- L’utilisateur renvoie le code à l’IA.
4- L’IA vérifie le code et confirme le numéro.
`,

    send_to_telegram_description: "Envoyer un message sur Telegram via un bot",
    send_to_telegram_completeDescription:
      "Cet outil permet d’envoyer des messages sur Telegram via un bot. Les messages sont envoyés via Bot Token à un chat ou canal spécifique.",
    send_to_telegram_howUse:
      "1- Entrez le Token du bot.\n2- Entrez l’ID du chat ou du canal.\n3- Exécutez l’outil pour envoyer le message.",
    send_to_telegram_howWork:
      "1- L’utilisateur entre Token et Channel.\n2- Le système prépare la requête API Telegram.\n3- Le message est envoyé au chat ou canal.",

    sender_username_description: "Utiliser le nom d’utilisateur de l’expéditeur dans le prompt",
    sender_username_completeDescription:
      "Cet outil permet d’utiliser le nom d’utilisateur de l’expéditeur dans les prompts IA. En ajoutant {SENDER_USERNAME}, il sera remplacé automatiquement.",
    sender_username_howUse:
      "1- Ajoutez {SENDER_USERNAME} dans votre prompt.\n2- Il sera remplacé automatiquement lors de l’exécution.",
    sender_username_howWork:
      "1- L’utilisateur ajoute {SENDER_USERNAME}.\n2- Le système le remplace par le nom d’utilisateur.\n3- L’IA génère la réponse avec ce nom.",
    // #endregion Message Section
    // #region 5️⃣market Section
    // 5️⃣ Market -> home
    filter_most_expensive: "Le plus cher",
    filter_cheapest: "Le moins cher",
    filter_newest: "Le plus récent",
    filter_highest_discount: "Réduction maximale",
    filter_all_products: "Tous les produits",
    filter_only_available: "Produits disponibles uniquement",
    filter_reset: "Réinitialiser",
    filter_sortby: "Trier par",
    filter_category: "Catégorie",
    filter_price: "Prix",
    Pricerange: "Plage de Prix",
    from: "De",
    to: "À",
    filter_rating: "Note",
    filter_followers: "followers",
    default: "Défaut",
    lowtohigh: "Du plus bas au plus élevé",
    hightolow: "Du plus élevé au plus bas",

    biolinkHomerating: "Évaluer",
    biolinkHomefollower: "Follower",
    biolinkHomepost: "Post",
    biolinkHomeAllMarkets: "Tout",
    biolinkHomeAdvertise: "Annonceur",
    biolinkHomeStore: "Magasin",
    biolinkStatisticsAllLinkclicks: "Tous les clics sur les liens",
    biolinkStatisticsMarketviews: "Vues du marché",
    biolinkStatisticsmostview: "le plus vu",
    biolinkStatisticscouponcodeused: "code promo utilisé",
    biolinkStatisticslastupdate: "dernière mise à jour",
    biolinkStatisticsAllsearches: "toutes les recherches",
    biolinkStatisticsfeatures: "fonctionnalités",
    biolinkStatisticsVisits: "Visites",
    biolinkStatisticsClicksAndInteractions: "Clics et interactions",
    biolinkStatisticsVisitsConverted: "Visites converties en clics",
    biolinkStatisticsQuickUserExitAfterEntry: "Sortie rapide des utilisateurs après l'entrée",
    biolinkStatisticsNoInteractionExit: "Sortie sans interaction",
    biolinkStatisticsMaxClicksPerVisit: "Nombre maximal de clics par utilisateur en une visite",
    biolinkStatisticsAvgClicksAndInteractionsPerVisitor: "Moyenne de clics et d'interactions par visiteur",
    biolinkStatisticsTotalVisitTime: "Temps total de visite",
    biolinkStatisticsAvgVisitTime: "Durée moyenne de visite",
    biolinkStatisticsVideoPlatformsComparison: "Comparaison des plateformes vidéo",
    biolinkStatisticsYoutube: "YouTube",
    biolinkStatisticsAparat: "Aparat",
    biolinkStatisticsTwitch: "Twitch",
    biolinkStatisticsPlatformEntry: "Entrée sur la plateforme",
    biolinkStatisticsRedirectEvent: "Événement de redirection",
    biolinkStatisticsPlayVideo: "Lecture de vidéo",
    biolinkStatisticsPlayEvent: "Événement de lecture",
    biolinkStatisticsUniqueVisit: "Visite unique",
    biolinkStatisticsDedicatedLinkVisits: "Visites du lien dédié",
    biolinkStatisticsCombinedLinkVisits: "Graphique combiné des visites de liens",
    // 5️⃣ Market -> Properties
    biolinkPropertiesfeatures: "Fonctionnalités",
    biolinkPropertiesProfileInfoBanner: "Informations de Profil & Bannière",
    biolinkPropertiesFeaturebox: "Boîte de Fonctionnalités",
    biolinkPropertiesTermsAndActiveTime: "Conditions et horaires d’ouverture",
    biolinkPropertiesFeatureboxexplain:
      "En activant chaque fonctionnalité, vous pouvez afficher des informations importantes aux visiteurs de votre page de lien",
    biolinkPropertiesBanner: "Bannière",
    biolinkPropertiesFeaturesBox: "Boîte de Fonctionnalités",
    biolinkPropertiesReviews: "Avis",
    biolinkPropertiesAnnouncements: "Annonces",
    biolinkPropertiesAnnouncementsexplain:
      "Vous pouvez écrire des informations dans cette section afin d’informer les visiteurs de votre page de lien sur des points importants",

    biolinkPropertiesOnlineStream: "Diffusion en Ligne",
    biolinkPropertiesOnlineStreamexplain:
      "En activant cette option, chaque fois que vous démarrez un live sur votre chaîne, il sera automatiquement affiché sur votre lien dédié",

    biolinkPropertiesLastVideo: "Dernière Vidéo",
    biolinkPropertiesLastVideoexplain:
      "En activant cette option, chaque fois que vous publiez une nouvelle vidéo sur votre chaîne, la dernière vidéo sera automatiquement affichée sur votre lien dédié et restera toujours à jour",

    biolinkPropertiesProducts: "Produits",
    biolinkPropertiesProduct: "Produit",
    biolinkProperties_showLast10Products: "Afficher les 10 derniers produits",
    biolinkProperties_showBestSellingProducts: "Afficher les produits les plus vendus",
    biolinkPropertiesAdsTimeline: "Chronologie des Annonces",
    biolinkPropertiesQandABox: "Boîte de Questions et Réponses",
    biolinkPropertiesLinkShortcut: "Raccourci de Lien",
    biolinkPropertiesContactAndMap: "Contact et Carte",
    biolinkPropertieslinks: "Liens",
    clickonstreamvideo: "Cliquez sur la vidéo pour regarder le direct",
    livestarted: "La Diffusion en Direct est en Cours",
    live: "En Direct",
    biolinkPropertiesaddnew: "Ajouter un Nouveau Lien",
    biolinkProperties_DomainManager: "Gestion de Domaine",
    biolinkProperties_DomainManagerexplain: "Votre site web dédié",
    biolinkProperties_DomainManagerexplain2:
      "Vous pouvez ajouter ce lien dans la Bio Instagram ou le partager avec d’autres utilisateurs",

    biolinkProperties_explain:
      "Lorsque le nom d'utilisateur Instagram est modifié, ce lien sera mis à jour automatiquement.",
    biolinkProperties_rejected: "Votre domaine a été rejeté (veuillez nous contacter)",
    customDomain_inactive_title: "Le domaine personnalisé est inactif",
    customDomain_inactive_desc:
      "Votre domaine est actuellement inactif. Veuillez soumettre un ticket d'assistance pour l'activer.",
    customDomain_noPackage_title: "Forfait domaine personnalisé introuvable",
    customDomain_noPackage_desc:
      "Votre forfait actuel n'inclut pas la prise en charge des domaines personnalisés. Veuillez mettre à niveau votre forfait pour utiliser cette fonctionnalité.",
    customDomain_rule_validChars: "Only letters and numbers are allowed",
    customDomain_rule_noUnderscore: "The (_) and (-) characters are not allowed",
    customDomain_rule_noSubdomain: "Subdomains are not allowed",
    biolinkProperties_Request: "Demande",
    biolinkProperties_Requested: "Demandé",
    biolinkProperties_Checking: "Vérification",
    biolinkProperties_yourstore: "Magasin (lien de votre magasin)",
    biolinkProperties_yourads: "Lien de commande publicitaire",
    biolinkProperties_yourlottery: "Vos loteries terminées",
    biolinkProperties_yourtariff: "Tarif (votre grille tarifaire)",
    biolinkProperties_yourBusinesshours: "Vos Heures d'Ouverture Actives",
    biolinkProperties_yourBusinessTerms: "Vos Conditions Commerciales",
    biolinkProperties_defaultAddress: "Adresse de Domaine par Défaut",
    biolinkProperties_CustomAddress: "Votre Adresse de Domaine Personnalisée",
    biolinkPropertiespopup_GeneralCustom: "Général",
    biolinkPropertiespopup_socialmedia: "Réseaux sociaux",
    biolinkPropertiespopup_mediastream: "Média et streaming",
    biolinkPropertiespopup_clouddrivecontent: "Contenu du cloud",
    biolinkPropertiespopup_Finance: "Finance",
    biolinkProperties_followersrate: "Nombre de followers",
    biolinkProperties_followersrateExplain: "Affiche le nombre de followers de votre page Instagram",
    biolinkProperties_successRating: "Taux de réussite",
    biolinkProperties_successRatingExplain: "Affiche votre score de réussite dans l’exécution des commandes",
    biolinkProperties_bussinessHours: "Heures d’activité",
    biolinkProperties_bussinessHoursExplain: "Affiche les horaires d’ouverture de votre entreprise",
    biolinkProperties_Enamadverified: "Vérification E-Namad",
    biolinkProperties_EnamadverifiedExplain: "Affiche le statut de vérification de votre badge de confiance E-Namad",
    biolinkProperties_BusinessTerms: "Conditions d’utilisation",
    biolinkProperties_BusinessTermsExplain: "Affiche les termes et conditions de votre activité",
    biolinkProperties_tariff: "Tarifs",
    biolinkProperties_TariffExplain: "Affiche vos tarifs de services",
    biolinkProperties_StartADS: "Démarrer une demande de publicité",
    biolinkProperties_StartADSExplain: "Les utilisateurs peuvent lancer leur publicité selon vos tarifs",
    biolinkProperties_StartSALES: "Démarrer un achat",
    biolinkProperties_StartSALESExplain: "Les utilisateurs peuvent commencer leurs achats selon vos produits",
    biolinkProperties_NameServers: "Serveurs de Noms du Domaine",
    biolinkProperties_NameServersExplain:
      "Enregistrez les serveurs de noms dans le panneau de contrôle de votre fournisseur de domaine",
    customDomain_dnsError:
      "Les serveurs de noms du domaine ne sont pas encore enregistrés auprès de votre fournisseur de domaine. Veuillez réessayer",
    customDomain_active_desc:
      "Pour modifier ou supprimer ce domaine, envoyez votre demande via la section Ticket d'assistance dans les paramètres",
    biolinkProperties_NameServerstooltip:
      "Votre demande peut prendre jusqu'à 12 heures pour que les serveurs de noms se propagent sur Internet et que votre domaine devienne actif.",
    linkURL: "URL du lien",
    searchID: "Ajouter une chaîne",
    searchIDexplain: "Entrez l’identifiant ou le nom de la chaîne souhaitée",

    Browse: "Parcourir",
    biolinkPropertiespopup_yourcustomIcon: "Votre icône personnalisée",
    Boldit: "Attire l’attention !",

    Scheduletime: "Temps de suppression automatique programmé",
    biolinkPropertiespopup_ProfileInfo: "Informations du profil",
    biolinkPropertiespopup_Banner: "Bannière",
    biolinkPropertiespopup_Personal: "Personnel",
    biolinkPropertiespopup_SameasInstagramProfile: "Identique au profil Instagram",
    marketpropertise_aboutus: "Ce site a été créé via la plateforme Brancy",
    marketpropertise_copyright: "Tous les droits de ce site appartiennent à",
    marketpropertise_aboutusslogan:
      "Brancy est le meilleur choix pour créer un Biolink intelligent et gérer votre page Instagram",
    marketpropertise_madeby: "Créé avec 🤍 par",

    custom: "Personnalisé",
    advertiseProperties_biography: "Biographie",
    uploadbannerexplain: "Le téléchargement de plusieurs images peut affecter la vitesse de chargement.",
    Embed: "Intégrer la vidéo",
    Embedexplain:
      "En activant cette option, la vidéo sera affichée et lue directement sur votre lien dédié, permettant aux utilisateurs de la regarder sans quitter la page ni être redirigés vers une autre plateforme",

    notfound: "non trouvé",
    showsavecontactbutton: "Afficher le bouton de sauvegarde du contact",
    Map: "Carte",
    Contact: "Contact",
    Showmap: "Afficher la carte",
    location: "Emplacement",
    phone: "Téléphone",
    invalidphone: "Téléphone invalide",
    email: "E-mail",
    invalidemail: "E-mail invalide",
    Address: "Adresse",
    // #endregion Market Section
    // #region 6️⃣advertise Section
    advertise_ADDetail: "Détails de l'annonce",
    content: "contenu",
    advertise_orderdate: "date de commande",
    advertise_duration: "durée",
    Remaining: "Restant",
    ago: "il y a",
    // advertise -> calendar
    advertisecalendar_calendar: "Calendrier",
    advertisecalendar_nextday: "Prochaines annonces pour ce jour",
    advertisecalendar_TODAY: "Aujourd'hui",
    advertisecalendar_BookaTime: "Réserver une heure",
    advertisecalendar_TIMELINEZOOM: "Zoom sur la chronologie",
    advertisecalendar_Timeline: "Chronologie",
    // advertise -> statistics
    advertisestatistics_lasttwomonth: "Les deux derniers mois",
    advertisestatistics_lastmonth: "Le mois dernier",
    advertisestatistics_thismonth: "Ce mois-ci",
    advertisestatistics_ads: "Annonce",
    advertisestatistics_fromlast: "% Du mois dernier",
    advertisestatistics_totalADSstatistics: "Statistiques Totales des Annonces",
    advertisestatistics_TotalAds: "Annonces Totales",
    advertisestatistics_TotalIncome: "Revenu Total",
    advertisestatistics_totaladsreport: "Rapport Total des Annonces",
    advertisestatistics_adno: "Numéro d'Annonce",
    advertisestatistics_advertiser: "Annonceur",
    advertisestatistics_type: "Type",
    advertisestatistics_status: "Statut",
    advertisestatistics_price: "Prix",
    advertisestatistics_date: "Date",
    advertisestatistics_share: "Partage",
    // advertise -> adlist
    advertiseadlist_activeAd: "des Annonces Publiées",
    advertiseadlist_AwaitingApproval: "des Annonces en Attente d'Approbation",
    advertiseadlist_AwaitingPublication: "des Annonces Programmées",
    advertiseadlist_rejectedlist: "des Annonces Rejetées",
    // advertise -> Properties
    advertiseProperties_Concurrentads: "Annonces Simultanées",
    advertiseProperties_Concurrentadsexplain: "Nombre d'annonces actives à un moment donné",
    advertiseProperties_numberofads: "Nombre de Pages d'Annonces",
    advertiseProperties_numberofadsexplain: "Nombre d'annonces actives tout au long de la journée",
    advertiseProperties_campaign: "Campagne",
    advertiseProperties_campaignexplain: "Possibilité de participer aux campagnes publicitaires par Brancy",
    advertiseProperties_adsoptions: "Options de Publicités",
    advertiseProperties_rejectreasonheader1: "Raison 1 (Contenu non pertinent)",
    advertiseProperties_rejectreasonheader2: "Raison 2 (Contenu malsain)",
    advertiseProperties_rejectreasonheader3: "Raison 3 (Violation des politiques)",
    advertiseProperties_rejectreasonheader4: "Raison 4 (Retour négatif)",
    advertiseProperties_rejectreason1:
      "Malheureusement, le contenu fourni ne correspond pas aux valeurs et aux objectifs de notre page, n'est pas pertinent pour notre public général, ou manque d'informations essentielles. Par conséquent, nous ne pouvons pas accepter cette publicité.",
    advertiseProperties_rejectreason2:
      "Malheureusement, le contenu fourni peut être malsain, trompeur, ou contenir des informations complexes pour notre public. Il nécessite des modifications importantes, nous ne pouvons donc pas accepter cette publicité.",
    advertiseProperties_rejectreason3:
      "Malheureusement, le contenu fourni ne respecte pas nos règlements ou les directives d'Instagram et peut être jugé déraisonnable, offensant, controversé ou criminel. Par conséquent, nous ne pouvons pas accepter cette publicité.",
    advertiseProperties_rejectreason4:
      "Malheureusement, en raison du volume élevé de publicités similaires, des conflits de programmation, des retours négatifs des utilisateurs des expériences précédentes, ou de la faible qualité du contenu fourni, nous ne pouvons pas accepter cette publicité.",
    advertiseProperties_AdvertisingTerms: "Conditions de publicité",
    advertiseProperties_AdvertisingTermsexplain:
      "Les annonceurs doivent accepter ces règles pour pouvoir faire de la publicité sur votre page.",
    advertiseProperties_AdvertisingTerm1: "Terme de votre page 1",
    advertiseProperties_AdvertisingTerm2: "Terme de votre page 2",
    advertiseProperties_AdvertisingTerm3: "Terme de votre page 3",
    advertiseProperties_AdvertisingTerm4: "Terme de votre page 4",
    advertiseProperties_AdvertisingTermsave: "Enregistrer",
    advertiseProperties_businesshours: "Heures d'activité de l'admin",
    advertiseProperties_24hours: "24 Heures Actives",
    advertiseProperties_close: "24 Heures Inactives",
    advertiseProperties_notifications: "Notifications",
    advertiseProperties_notificationsSMS: "SMS",
    advertiseProperties_notificationsEmail: "E-mail",
    advertiseProperties_notificationssystem: "Notification système",
    advertiseProperties_notificationsinstagramdirect: "Direct Instagram",
    advertiseProperties_notificationssystemticket: "Ticket",
    advertiseProperties_advertisetariff: "Tarif Publicitaire",
    advertiseProperties_onlyToday: "Seulement pour Aujourd'hui",
    advertiseProperties_onlyTodayexplain: "Tarif de prix publicitaire seulement pour aujourd'hui",
    advertiseProperties_tariff12hours: "12 Heures",
    advertiseProperties_tariff24hours: "24 Heures",
    advertiseProperties_otherdays: "Basique (Autres Jours)",
    advertiseProperties_otherdaysexplain: "Tarif de prix publicitaire pour les autres jours",
    advertiseProperties_Campaign: "Campagne",
    advertiseProperties_Campaignexplain: "Tarif de prix publicitaire pour la campagne",
    advertiseProperties_lastModified: "Dernière Modification",
    advertiseProperties_userreport: "Rapport Utilisateur",
    advertiseProperties_userID: "ID Utilisateur",
    advertiseProperties_reportexplain: "Votre rapport sera envoyé au support de Brancy.",
    advertiseProperties_reportsubmit: "Soumettre",
    Apply: "Appliquer",
    signinyouradvertise: "Activer les Publicités",
    signinyouradvertiseExplain: "Activez vos publicités en quelques clics",

    // #endregion advertise Section
    // #region 7️⃣Store Section
    // Store -> product
    Storeproduct_activatestore: "Activer votre boutique",
    signinyourstore: "Créer votre boutique",
    signinyourstoreExplain: "Créez votre boutique en quelques clics seulement",
    Storeproduct_needyourID: "Vérification d'identité",
    Storeproduct_needyourIDExplain: "Téléversez votre carte d'identité",
    Storeproduct_successyourID: "Votre identité a été vérifiée avec succès",
    Storeproduct_NationalCardexplain:
      "Cette carte doit appartenir à la personne qui s’est inscrite avec son numéro de mobile sur Brancy.",
    Storeproduct_addcreditnumber: "Informations financières",
    Storeproduct_addcreditnumberExplain: "Entrez votre carte bancaire",
    Storeproduct_successnumber: "Vos informations bancaires ont été vérifiées avec succès",
    Storeproduct_shippingmethod: "Méthode d'expédition",
    Storeproduct_shippingmethodExplain: "Sélectionnez votre méthode d'expédition préférée",
    Storeproduct_shippingmethodsuccess: "La méthode d'expédition sélectionnée a été enregistrée avec succès",
    Storeproduct_shippingmethodtooltip:
      "Les méthodes recommandées ont été sélectionnées en fonction de votre emplacement. Vous pouvez les modifier ultérieurement dans les paramètres de la boutique.",
    Storeproduct_uploadimagefirst: "Veuillez d'abord télécharger la photo de votre carte d'identité nationale",
    Storeproduct_creditcardsameidcard:
      "Le numéro de carte bancaire doit appartenir au titulaire de la carte d'identité nationale",
    Storeproduct_postalcode: "Adresse de l'entreprise",
    Storeproduct_postalcodeExplain: "Entrez le code postal",
    Storeproduct_postalcodesuccess: "L'adresse et l'emplacement ont été enregistrés avec succès",
    Storeproduct_postalcodeinputExplain:
      "Les frais de livraison sont calculés en fonction de cette adresse, veuillez saisir le code postal avec précision.",
    Storeproduct_TermsAndCondition: "Termes et conditions",
    Storeproduct_TermsAndConditionExplain: "Lisez et acceptez les conditions",
    Storeproduct_TermsAndConditionesuccess: "L'acceptation des conditions a été enregistrée avec succès",
    Storeproduct_AcceptTermsAndCondition:
      "J'ai lu et j'accepte toutes les règles et réglementations concernant la création d'une boutique sur Brancy",
    Storeproduct_notyet: "Vous n'avez pas encore ajouté de produit !",
    Storeproduct_addnow: "AJOUTEZ DES PRODUITS MAINTENANT",
    Storeproduct_addexplain: "Ils seront ajoutés automatiquement depuis votre Page Instagram.",
    Storeproduct_productlist: "Liste des produits",
    Storeproduct_search: "Rechercher 'Nom du produit' ou 'PID'",
    Storeproduct_importproduct: "Importer un produit",
    Storeproduct_importfrominsta: "Importer depuis votre Instagram",
    Storeproduct_newproduct: "Nouveau produit",
    Storeproduct_addnewproduct: "Ajouter un nouveau produit",
    Storeproduct_name: "Nom produit",
    Storeproduct_weight: "Poids",
    Storeproduct_size: "Taille",
    Storeproduct_color: "Couleur",
    Storeproduct_stock: "Stock",
    Storeproduct_price: "Prix",
    Storeproduct_active: "Actif",
    Storeproduct_gram: "Gramme",
    bulkProduct: {
      title: "Gérer les produits sélectionnés",
      selectedCount: "{{count}} produits sélectionnés",
      priceChange: "Modifier le prix",
      valueType: "Type de valeur",
      amount: "Montant",
      increase: "Augmenter",
      decrease: "Réduire",
      applyAll: "Appliquer la même modification à tous",
      applyIndividual: "Régler chaque produit séparément",
      allProducts: "Appliquer aux {{count}} produits",
      discountAllHint: "Définissez un pourcentage ou un montant de remise fixe pour tous les produits sélectionnés.",
      priceAllHint: "Augmentez ou réduisez tous les prix par pourcentage ou montant fixe.",
      currentDiscount: "Remise actuelle",
      saving: "Enregistrement...",
    },
    loadingmoreproducts: "Chargement de plus de produits...",
    noMoreProducts: "Aucun produit trouvé",
    storestatistics_lasttwomonth: "Deux Derniers Mois",
    storestatistics_lastmonth: "Mois Dernier",
    storestatistics_thismonth: "Ce Mois-ci",
    storestatistics_sales: "Ventes",
    storestatistics_fromlast: "% par rapport au mois dernier",
    storestatistics_totalSalesstatistics: "Statistiques Globales des Ventes",
    storestatistics_TotalSales: "Ventes Totales",
    storestatistics_TotalIncome: "Revenus Totaux",
    storestatistics_totalsalesreport: "Meilleurs Acheteurs",
    storestatistics_buyer: "Informations sur l'Acheteur",
    storestatistics_totalPurchases: "Nombre Total d'Achats",
    storestatistics_totalAmount: "Montant Total des Achats",
    storestatistics_lastPurchase: "Date du Dernier Achat",
    storestatistics_saleno: "Numéro de Vente",
    storestatistics_seller: "Vendeur",
    storestatistics_type: "Type",
    storestatistics_status: "Statut",
    storestatistics_price: "Prix",
    storestatistics_date: "Date",
    storestatistics_share: "Partager",
    storestatistics_couponTitle: "Réductions",
    storestatistics_addCoupon: "Ajouter un code promo",
    storestatistics_noCoupons: "Aucun code promo n'a encore été créé.",
    storestatistics_couponCode: "Code promo",
    storestatistics_discountPercent: "Pourcentage de réduction",
    storestatistics_maxUses: "Nombre maximal d'utilisations",
    storestatistics_phoneNumber: "Numéro de téléphone",
    storestatistics_maxDiscountOptional: "Réduction maximale (facultatif)",
    storestatistics_couponExpiry: "Heure d’expiration (doit être dans au moins 1 heure)",
    storestatistics_showInBio: "Afficher dans la bio",
    storestatistics_couponDeleted: "Supprimé",
    storestatistics_couponExpired: "Expiré",
    storestatistics_couponExhausted: "Épuisé",
    storestatistics_couponActive: "Actif",
    storestatistics_unlimited: "Illimité",
    storestatistics_couponUsage: "{{used}} sur {{max}} utilisés",
    storestatistics_discountValue: "{{discount}} % de réduction",
    storestatistics_maxDiscountValue: "Maximum : {{value}}",
    storestatistics_expiryValue: "Expire le : {{date}}",
    storestatistics_private: "Privé",
    storestatistics_public: "Public",
    // Store -> order
    incartcount: "Dans le panier",
    addtocart: "Ajouter au Panier",
    AllProducts: "Tous les Produits",
    Storeproduct_inQueue: "En Attente d'Approbation",
    Storeproduct_inprogress: "En Cours",
    Storeproduct_pickingup: "Collecte",
    Storeproduct_sent: "Envoyé",
    Storeproduct_delivered: "Livré",
    Storeproduct_failed: "Échoué",
    Storeproduct_canceledbyuser: "Annulé par l'acheteur",
    Storeproduct_canceledbyadmin: "Annulé par l'administrateur",

    Storeproduct_returned: "Retourné",
    Storeproduct_yourcartisempty: "Votre panier est vide",
    Storeproduct_noitemfounded: "Aucun article trouvé",
    Storeproduct_incart: "Dans le Panier",
    ShowUnprocessedItemsOnly: "Articles non traités",
    pageStatistics_fromstore: "Du Magasin",
    ordernumber: "Numéro de Commande",
    order_addressSubject: "Domicile, Lieu de travail",
    order_addressReceiver: "Nom du destinataire à cette adresse",
    order_addressNote: "Note d'adresse",

    Storeorder_all: "Tout",
    Storeorder_ORDERID: "Numéro de Commande",
    Storeorder_CUSTOMER: "Client",
    Storeorder_ITEMS: "Articles",
    Storeorder_ITEM: "Article",
    Storeorder_PRICE: "Prix",
    Storeorder_OrderDATE: "Date de Commande",
    copytrackingcode: "Copier le Code de Suivi",
    Storeorder_SentDATE: "Date d'Envoi",
    Storeorder_deliverdate: "Date de Livraison",
    Storeorder_DELIVERY: "Envoyé via",
    Storeorder_bymyself: "Envoyé par moi-même",
    Storeorder_Envelope: "Enveloppe",
    Storeorder_Invoice: "Facture",

    Storeorder_DeliveryAmount: "Frais de livraison",
    Storeorder_InsuranceAmount: "Frais d’assurance",
    Storeorder_Coupon: "Code promo",
    Storeorder_RemoveCoupon: "Supprimer le code",
    Storeorder_Productsinyourshoppingcart: "Produits dans votre panier",
    Storeorder_SendtotheAddress: "Envoyer à l’adresse",
    Storeorder_changeofaddress: "Changement d’adresse",

    Storeorder_postparselbox: "Boîte postale",
    Storeorder_pocketenveloptitle: "Nombre d’articles par enveloppe",
    Storeorder_pocketenveloptitleExplain:
      "Veuillez indiquer combien de produits peuvent être placés dans une enveloppe standard (ou votre emballage habituel). Cela nous aide à effectuer des calculs plus précis pour le stock, l’emballage et l’expédition.",
    Storeorder_Destination: "Destination",
    Storeorder_STATUS: "Statut",
    Storeorder_DETAILS: "Détails",
    Storeorder_PickupRequest: "Demande de Collecte",
    Storeorder_PrintWaybill: "Imprimer le Bordereau",
    Storeorder_Waybill: "Lettre de transport",
    Storeorder_WaybillExplain:
      "Veuillez imprimer la lettre de transport et la coller de manière lisible, plate et solide sur le colis avant de soumettre la demande de collecte.",
    Storeorder_noneSendExplain:
      "Étant donné que ce colis n’a pas pu être envoyé via le système de livraison Brancy et que vous l’avez expédié personnellement sous votre responsabilité, vous devez confirmer cette étape. En confirmant, l’acheteur sera informé que le colis a été expédié.",
    Storeorder_ManualTrackingExplain:
      "Étant donné que vous avez remis le colis directement à la société de transport, veuillez saisir le code de suivi dans le champ approprié après l’avoir reçu et confirmer cette étape.  Ainsi, Brancy informera automatiquement l’acheteur du code de suivi et des informations d’expédition.",
    Storeorder_SendExplain: "Les informations de cette section seront mises à jour automatiquement",

    Storeorder_requestedpickup: "En attente de collecte",
    Storeorder_TrackingCode: "Code de Suivi",
    Storeorder_PostMan: "Facteur",
    Storeorder_from: "Envoyé de",
    Storeorder_currentLocation: "Localisation actuelle",
    Storeorder_lastUpdateTime: "Dernière mise à jour",
    Storeorder_sender: "Expéditeur",

    Storeorder_IssuingTrackingCode: "Émission du Code de Suivi",
    Storeorder_orderDetailsStep: "Informations sur la commande",
    Storeorder_orderconfirmStep: "Taille du colis et bon de transport",
    Storeorder_orderlist: "Liste des commandes",
    Storeorder_singleorder: "Commande",
    Storeorder_quantityorder: "Quantité",
    Showmore: "Voir plus",
    totalprice: "Prix total",
    note: "Remarque",
    navbar_PaymentNumber: "Code de suivi du paiement",
    Storeorder_receiver: "Destinataire",
    Storeorder_AcceptthisOrder: "Confirmer cette commande",
    Storeorder_ParselisConfirmed: "Je confirme que les détails saisis sont corrects",
    Storeorder_ParselisConfirmedExplain:
      "Une erreur dans la saisie de la taille ou du poids peut entraîner des pénalités et un retour du colis",
    Storeorder_CancelOrder: "Annuler la commande",
    Storeorder_nextWaybill: "Continuer (Recevoir le bon de transport)",
    Storeorder_Pickedup: "Collecté",
    SelectProduct: "Sélectionner le produit",
    SelectedPosts: "Publications sélectionnées:",
    product_BasicDetail: "Détail de base",
    BacktoProductList: "Retour à la liste des produits",
    Backtocart: "Retour au panier",
    product_ProductID: "ID du produit",
    product_Producttitle: "Titre du produit",
    product_Product: "Produits",
    product_Categories: "Catégories",
    product_MainCategory: "Catégorie principale",
    product_Subcategory: "Sous-catégorie",
    product_Subset: "Sous-ensemble",
    product_Group: "Groupe",
    product_Branch: "Branche",
    product_Subbranch: "Sous-branche",
    product_Dependency: "Dépendance",
    product_Brand: "Marque",
    product_instagramcaption: "Caption Instagram",
    product_productDescription: "Description du produit",
    product_Informationplaceholder:
      "Dans cette section, vous pouvez écrire la description du produit.\n\n Cette description peut inclure des informations complètes et attrayantes telles que\n les caractéristiques, les avantages, les détails clés sur le produit, ou comment l'utiliser, les ingrédients\n exprimés brièvement et efficacement.\n\n Les clients se familiariseront davantage avec les caractéristiques du produit, et les chances de vente du produit augmenteront.",
    product_General: "Général",
    product_Specifications: "Spécifications",
    product_Information: "Informations",
    product_addNewTable: "Ajouter un nouveau tableau",
    product_EditTable: "Modifier le tableau",
    product_PreviewTable: "Tableau",
    product_addtable: "Créer un tableau",
    product_tabletitle: "Titre du tableau (optionnel)",
    product_tabletitleExplain: "Par exemple : tableau des tailles",
    product_tableheaderoption: "Première ligne comme en-tête",
    product_AddColumn: "Ajouter une colonne à côté",
    product_DeleteColumn: "Supprimer cette colonne",
    product_AddRow: "Ajouter une ligne en dessous",
    product_DeleteRow: "Supprimer cette ligne",
    rowheader: "En-tête",
    cell: "Cellule",
    product_Media: "Médias",
    Nodescriptionavailable: "Aucune description disponible",
    NoSpecificationsavailable: "Aucune description disponible",
    product_Properties: "Propriétés",
    product_Setting: "Paramètres",
    product_productdeleted: "produit supprimé",
    product_SetProperties: "Définir les propriétés",
    product_SetPropertiesexplain: "Vous pouvez sélectionner 1 à 3 propriétés et l'une d'elles peut être personnalisée",
    product_AddNewproperty: "Ajouter une nouvelle propriété",
    product_Nopropertyisset: "Aucune propriété définie",
    product_Variation: "Variation",
    product_Discount: "Remise",
    product_PricewithDiscount: "Prix avec remise",
    product_AddNewVariation: "Ajouter une nouvelle variation",
    product_Definenew: "Définir nouveau (Personnalisé)",
    product_systemlist: "Liste par défaut intelligente",
    product_itemlist: "Liste des éléments",
    product_Available: "Disponible",
    product_supplying: "En Approvisionnement",
    product_OutOfStock: "Rupture de Stock",
    product_Stoppedsale: "Vente Arrêtée",
    product_draft: "brouillon",
    product_Amount: "Quantité",
    product_NUMBEROFUSES: "Nombre d'utilisations",
    product_UNLIMITED: "Illimité",
    product_LIMITED: "Limité",
    product_USINGTIMES: "Durée d'utilisation",
    product_UNLIMITEDTIME: "Temps illimité",
    permanent: "Permanent",
    product_LIMITEDTIME: "Temps limité",
    product_mediatitle: "Gérer les images et vidéos du produit",
    product_clicktoupload: "Cliquez pour télécharger",
    product_SuggestedImages: "Images suggérées",
    product_SuggestedImagesExplain:
      "Améliorez votre galerie de produits en utilisant des images suggérées ou téléchargez vos images souhaitées",
    product_ordragdrop: "ou glissez-déposez",
    product_productspecifications: "spécifications du produit",
    product_choosesystemlist: "choisir dans la liste des systèmes",
    product_choosesystemlistexplain: "Recherchez et sélectionnez toutes les spécifications dont vous avez besoin",
    product_Definenewexplain: "Si vous ne trouvez pas les spécifications, créez-les",
    product_importbatch: "importer un lot",
    product_importbatchexplain: "Ajoutez toutes les spécifications du produit précédent",
    Value: "Valeur",
    Undefined: "Indéfini",
    product_original: "Original",
    product_HighCopy: "Haute Copie",
    product_notoriginal: "Non original",
    product_Corporate: "Entreprise",
    product_Miscellaneous: "Divers",
    product_fake: "Faux",
    tomorrow: "Demain",
    NotSet: "Non défini",
    Yes: "Oui",
    No: "Non",
    "Video generation request sent.": "La demande de génération vidéo a été envoyée.",
    "Image generation request sent.": "La demande de génération d'image a été envoyée.",
    ", Image generation failed.": ", échec de la génération de l'image.",
    "Create and manage AI-generated images and videos.": "Créez et gérez des images et vidéos générées par l'IA.",
    Storeproduct_OutOfStandardSize: "Hors taille standard",
    product_box: "Taille de la boîte",
    Product_Availablity: "Disponibilité",
    Product_maxincart: "Max dans le panier",
    Product_originality: "Originalité",
    Product_preperingforship: "Préparation pour l'expédition",
    Product_Evat: "TVA",
    Product_Evatcount: "Valeur TVA",
    Product_Guarantee: "Garantie",
    Product_Guaranteelength: "Durée de la garantie",
    Product_packageshipping: "Emballage et expédition",
    Product_packageshippingexplain:
      "En désactivant cette option, l'expédition des produits et les services connexes seront à votre charge",
    Product_titleExplain:
      "Les titres suggérés sont fournis en fonction des caractéristiques de votre produit et de la moyenne des titres similaires sur le marché afin d’augmenter leur visibilité dans les recherches et les produits similaires. \n(Ces titres peuvent contenir des erreurs)",
    Product_Breakable: "Fragile",
    Product_Luquid: "Liquide",
    Product_sack: "Sachet / Sac",
    Product_sackExplain:
      "Si votre produit est expédié dans un sac, tote ou un emballage souple et flexible, sélectionnez cette option. Cela nous aide à mieux organiser la disposition, le transport et l’emballage.",
    Product_Productweights: "Poids du produit",
    Product_Productweightsexplian: "Poids net du produit sans emballage",
    Product_packaging: "Emballage",
    Product_packagingexplian:
      "Le poids de l'emballage du produit sans contenu interne, y compris le carton d'emballage, le ruban adhésif et l'étiquette d'expédition, calculé par le système",
    Product_shippingSize: "Dimensions de l'expédition",
    product_SuggestedPrice: "Analyse des prix de ce produit sur l'ensemble du marché",
    product_MinimumPrice: "Prix Minimum",
    product_AveragePrice: "Prix Moyen",
    product_MaximumPrice: "Prix Maximum",
    length: "Longueur",
    width: "Largeur",
    height: "Hauteur",
    Weight: "Poids ",
    finalWeight: "Poids final",
    product_deleteproductexplain: "Vous êtes en train de supprimer ce produit.",
    // #endregion Store Section
    // #region 8️⃣Setting Section
    // Setting -> General -> System
    SettingGeneralSystemTitle: "Système",
    SettingGeneralSystemlanguage: "Langue",
    SettingGeneralSystemcalendar: "Calendrier",
    SettingGeneralSystemGregorian: "Grégorien",
    SettingGeneralSystemshamsi: "Shamsi",
    SettingGeneralSystemHijri: "Hégirien",
    SettingGeneralSystemHindi: "Hindi",
    SettingGeneralSystemStartWeek: "Début de la semaine",
    SettingGeneralSystemsaturday: "Samedi",
    SettingGeneralSystemmonday: "Lundi",
    SettingGeneralSystemtuesday: "Mardi",
    SettingGeneralSystemwednesday: " Mercredi",
    SettingGeneralSystemthursday: " Jeudi",
    SettingGeneralSystemfriday: "Vendredi",
    SettingGeneralSystemsunday: "Dimanche",
    SettingGeneralSystemtheme: "Thème",
    SettingGeneralSystemDarkmode: "Mode Sombre",
    SettingGeneralSystemlightmode: "Mode Clair",
    SettingGeneralSystemPrice: "Modèle de Prix",
    SettingGeneralSystemDollar: "Dollar",
    SettingGeneralSystemeuro: "Euro",
    SettingGeneralSystempound: "Livre",
    SettingGeneralSystemrial: "Rial",
    SettingGeneralSystemtoman: "Toman",
    SettingGeneralAiModelsTitle: "Modèles IA",
    SettingGeneralAiModelsTextModels: "Modèles de texte",
    SettingGeneralAiModelsVoiceModels: "Modèles voix-vers-texte",
    SettingGeneralAiModelsDirectVoiceSupport: "Support vocal direct",
    SettingGeneral_activedevice: "Appareils actifs",
    SettingGeneral_leatestentery: "Historique d'activité de l'utilisateur",
    SettingGeneral_cantdeletesession: "Les sessions créées il y a moins de 24 heures ne peuvent pas être supprimées.",
    SettingGeneral_deletesession: "Vous tentez de supprimer cette session.",
    SettingGeneral_addSubAdmin: "Ajouter un sous-administrateur",
    SettingGeneral_addSubAdminExplain: "Ajouter un sous-admin avec des accès limités",
    SettingGeneral_addSubAdminExplain2:
      "Inviter un Admin avec un Accès Limité et Sécurisé, sans se Connecter à Instagram.",

    SettingGeneral_addSubAdmintitleExplain:
      "Saisissez le numéro du nouvel admin pour envoyer l’invitation. Une fois confirmée, l’accès sera activé.",
    SettingGeneral_accesslevel: "Niveau d'accès",
    SettingGeneral_access: "Accès",
    SettingGeneral_partnertitle: "Titre de l’Admin Collaborateur",
    SettingGeneral_partnernumberexplain:
      "Une invitation sera envoyée à ce numéro, et l’admin collaborateur doit la confirmer dans son panneau (l’admin doit s’inscrire sur Brancy pour accepter l’invitation).",
    SettingGeneral_contentTooltip: "Publications, stories, Reels, IGTV et carrousels.",
    SettingGeneral_publishTooltip:
      "Créer des publications, des stories et créer du contenu. L’accès au contenu est requis.",
    SettingGeneral_automaticsTooltip: "IA, flux, processus et tâches automatisés. L’accès au contenu est requis.",
    SettingGeneral_messageTooltip: "Messages directs Instagram, messages internes et outils associés.",
    SettingGeneral_commentTooltip: "Commentaires, réponses et outils associés.",
    SettingGeneral_transactionTooltip: "Gestion du compte de paiement, transactions, portefeuille et outils associés.",
    SettingGeneral_adsTooltip:
      "Gestion du calendrier, des annonceurs, validation des publicités, tarification et outils associés.",
    SettingGeneral_ordersTooltip: "Produits, prix, stock, commandes, bons de livraison et outils associés.",
    SettingGeneral_bioTooltip: "Contenu et mise en page de la bio, liens et raccourcis de contenu tiers.",
    SettingGeneral_ticketTooltip: "CRM, tickets système et assistance.",
    SettingGeneral_productsTooltip: "Outils de gestion des produits.",

    // Setting -> General -> support
    SettingGeneral_GeneralSupport: "Support Général",
    SettingGeneral_Customerservices: "Services Clients",
    SettingGeneral_ReportBug: "Signaler un Bug",
    SettingGeneral_Advertise: "Publicité",
    SettingGeneral_Store: "Magasin",
    SettingGeneral_biolink: "Lien Bio",
    SettingGeneral_Walletandfinance: "Portefeuille et Finances",
    SettingGeneral_MessageingandComment: "Messagerie et Commentaire",
    SettingGeneral_Support: "Support",
    SettingGeneral_Department: "Département",
    SettingGeneral_Title: "Titre",
    SettingGeneral_Description: "Description",
    SettingGeneral_Send: "Envoyer",
    // #endregion Setting Section
    userpanel_market: "Marché",
    userpanel_order: "Commande",
    userpanel_Messages: "Messages",
    userpanel_Settings: "Paramètres",
    userpanel_PersonalInfo: "Informations personnelles",
    userpanel_UploadNewPicture: "Télécharger une nouvelle image",
    userpanel_Instagramid: "Identifiant Instagram",
    userpanel_Nameandfamily: "Nom et prénom",
    userpanel_NationalCode: "Code national",
    userpanel_BirthDay: "Date de naissance",
    userpanel_MobileNumber: "Numéro de mobile",
    userpanel_Email: "E-mail",
    userpanel_CreditNumber: "Numéro de crédit",
    userpanel_Addresses: "Adresses",
    userpanel_AddNewAddress: "Ajouter une nouvelle adresse",
    userpanel_ZipCode: "Code postal",
    userpanel_Address: "Adresse",
    userpanel_EditAddress: "Modifier l'adresse",
    userpanel_AddNewAddressexplain: "Votre colis sera livré à cette adresse et à cette personne",
    startbusiness: "Créer une entreprise",
    AI: "IA",
    ExtraTokens: "Jetons Suppl.",
    TokenUsage: "Utilisation des tokens",
    AdvancedAnalytics: "Analyse Avancée",
    AIResponse: "Réponses IG IA",
    CustomSupport: "Support Perso",
    CustomDomain: "Domaine Personnalisé",
    WinnerPicker: "Choix du Gagnant",
    WinnerPickerReserve: "Tirage au sort de réserve",

    dataTable1_feature1: "Gestion des Posts et statistiques avancées",

    dataTable1_tooltip1:
      "Planification facile des Posts. Graphiques et statistiques détaillées pour chaque Post, y compris : (Like, Partage, Comment, Enregistrement, Taux d’engagement, Portée, Impression, Lectures, Rétention, Follow/Unfollow, Activité du profil, Hashtags utilisés), et bien plus...",

    dataTable1_feature2: "Créer un nouveau Post",
    dataTable1_tooltip2:
      "Propose le meilleur moment et la meilleure date selon votre page. Planification des Posts. Sauvegarde des hashtags pour réutilisation. Réponse automatique aux Comments. Enregistrement du Post comme brouillon, etc.",

    dataTable1_feature3: "Gestion des Stories et statistiques détaillées",
    dataTable1_tooltip3:
      "Planification des Stories. Statistiques complètes et graphiques pour chaque Story : (Like, Partage, Comment, Enregistrement, Taux d’engagement, Portée, Impression, Lectures, Rétention, Follow/Unfollow, Activité du profil, Direct, Capture d’écran), etc.",

    dataTable1_feature4: "Créer une nouvelle Story",
    dataTable1_tooltip4:
      "Propose le meilleur moment et la meilleure date selon votre page. Planification des Stories. Réponse automatique aux Comments. Enregistrement comme brouillon, etc.",

    dataTable1_feature5: "Statistiques globales de la page",
    dataTable1_tooltip5:
      "Nombre de Posts et Stories. Tri par vues, Comments, Likes. Identification des meilleurs et pires moments pour publier (avec graphique). Historique des Likes, Follow/Unfollow, vues, Comments, visiteurs fantômes. Identification des meilleurs Followers. Comparaison avec les statistiques précédentes, etc.",

    dataTable1_feature6: "Gestion des hashtags",
    dataTable1_tooltip6:
      "Créer des listes illimitées. Génération intelligente de hashtags par analyse d’image (IA). Analyse de page. Voir les hashtags utilisés. Liste des hashtags tendance (par jour, semaine, mois et langue : anglais, persan, arabe...), et plus encore.",

    dataTable1_feature7: "Like automatique des nouveaux Comments",
    dataTable1_tooltip7:
      "Like automatique des nouveaux Comments des Followers sur chaque Post. Historique affiché en graphique et en liste.",

    dataTable1_feature8: "Tirage au sort aléatoire entre Followers",
    dataTable1_tooltip8:
      "Sélection du meilleur Follower selon Likes et Comments. Choix aléatoire des gagnants. Définir le nombre de gagnants. Création et publication automatique de Story des résultats. Suivi avec code unique, etc.",

    dataTable1_feature9: "Tirage au sort avec points entre Followers",
    dataTable1_tooltip9:
      "Définir les tâches pour participer (Like, Comment, Mention, Follow). Définir nombre de gagnants. Création automatique de la Story des conditions. Rappel automatique. Publication automatique des résultats. Suivi avec code unique, etc.",
    WithStrongCallToAction: "Avec un fort appel à l'action",
    WithProsAndCons: "Avec avantages et inconvénients",
    ForComparison: "Pour comparaison",
    WithKeyPoints: "Avec points clés",
    ForPromotionalPost: "Pour publication promotionnelle",
    WithDetailedExplanation: "Avec explication complète",
    PersuasiveStyle: "Avec style persuasif",
    ForProductIntroduction: "Pour présentation du produit",
    LongText: "En texte long",
    Aipromptexplain:
      "Brancy analyse le contenu de votre page pour comprendre votre ton et style d'écriture ; aucune explication supplémentaire n'est nécessaire !",
    ImagineSomething: "Imagine quelque chose... ✦",
    Generating: "Génération...",
    AccessAndManageComments: "Accéder et Gérer les Commentaires",
    AccessAndManageMessages: "Accéder et Gérer les Messages",
    AccessAndPublishContent: "Accéder et Publier du Contenu",
    AccessAndManageInsights: "Accéder et Gérer les Statistiques et Rapports",
    AccessAndManageCommentsExplain:
      "Pour gérer les commentaires Instagram, cliquez sur « Activer l’autorisation » et validez sur la page ouverte.",
    AccessAndManageMessagesExplain:
      "Pour gérer les messages Instagram, cliquez sur « Activer l’autorisation » et validez sur la page ouverte.",
    AccessAndPublishContentExplain:
      "Pour voir et publier du contenu Instagram, cliquez sur « Activer l’autorisation » et validez sur la page ouverte.",
    AccessAndManageInsightsExplain:
      "Pour gérer les statistiques Instagram, cliquez sur « Activer l’autorisation » et validez sur la page ouverte.",
    EnablePermission: "Activer l’Autorisation",
    instagramTutorialTitle: "Guide de connexion à Instagram",
    instagramTutorialStep1Title: "Étape 1 : Connexion sécurisée à Instagram",
    instagramTutorialStep1Text:
      "Cliquez sur « Connecter le compte Instagram » pour être redirigé vers instagram.com et connectez-vous. Cela garantit la sécurité et une connexion valide.",
    instagramTutorialStep2Title: "Étape 2 : Autoriser l’accès",
    instagramTutorialStep2Text:
      "Après connexion, Instagram demandera l’accès à vos infos publiques. Acceptez tout pour un fonctionnement optimal.",
    instagramremoveStep1Title: "Étape 3 : Vérifier les accès",
    instagramremoveStep1text: "Allez dans les paramètres pour voir tous les accès actifs de votre compte.",
    instagramremoveStep2Title: "Étape 4 : Gérer & supprimer les accès inutiles",
    instagramremoveStep2text:
      "Brancy est un partenaire officiel d’Instagram, aucun autre service n’est requis. Supprimez les accès superflus pour plus de sécurité.",

    understood: "Compris",
    previous: "Précédent",
    connectTutorial: "Guide de connexion",
    invalidcode: "Code invalide",
    wearesorry: "Nous sommes désolés!",
    PaymentFailed: "Échec du paiement!",
    thankyou: "Merci!",
    Paymentsuccess: "Paiement Réussi!",

    TransactionNumber: "Numéro de transaction :",
    TransactiontrackingNumber: "Numéro de suivi de transaction :",
    InvoiceNumber: "Numéro de facture :",

    mainSubscriptionPlan: "Abonnement Principal",
    Tokens: "tokens",
    tokenExplain:
      "Le token est l’unité de consommation des services d’IA ; en moyenne, le traitement de 100 requêtes nécessite environ 1 000 tokens.",
    ReserveToken: "Jeton de Réserve",
    packageTokenExplain:
      "Jetons gratuits activés avec le forfait et utilisables jusqu’à l’expiration du forfait ; après cela, ils expirent.",
    ReserveTokenExplain: "Jetons de réserve achetés qui n’expirent pas avec le temps.",

    pageTools_Months: "Mois",
    subscriptionExpired: "Votre abonnement a expiré, renouvelez-le",
    subscriptionExpireSoon: "Votre abonnement va bientôt expirer",
    subscriptionManagement: "Gestion d'abonnement",
    subscription: "Abonnement",
    AIAssisment: "Assistant IA",
    timeperiod: "Période restante",
    domain: "Domaine",
    winnerpickerexpired: "Vous ne pouvez plus lancer de loterie, veuillez recharger",
    winnerpickerexpiresoon: "Vos tirages au sort sont presque épuisés",
    Aiexpired: "Vous n'avez plus accès à l'intelligence artificielle. Veuillez recharger.",
    Aiexpiresoon: "Vos jetons d'intelligence artificielle sont sur le point de s'épuiser.",

    followercount: "Nombre de Followers",
    yourCurrentSubscription: "Votre abonnement actuel",
    noItemsAvailableContactSupport:
      "Cette section n’est pas disponible pour le moment. Veuillez contacter le support Brancy en envoyant un ticket.",

    // #region AIFlow Section
    AIAssismentexplain:
      "Grâce à l’assistant IA de Brancy, vous pouvez créer des flows de conversation intelligents pour répondre automatiquement aux messages et commentaires Instagram",
    livetest: "Test en direct",
    testlab: "Laboratoire de test",
    promptmode: "Mode Prompt",
    promptanalysis: "Analyse du Prompt",
    promptanalysisExplain:
      "Saisissez votre prompt en détail ; Brancy l’analysera en fonction de votre personnalité, de votre ton et de votre style d’interaction.",
    promptanalysisplaceholder: "Saisissez au moins 20 caractères pour analyser le prompt",
    reanalyze: "Réanalyser",
    shouldFollowerexplain: "Les réponses sont envoyées uniquement aux utilisateurs qui vous follow",
    RenewForThread: "Renouveler le Flow de Conversation",
    RenewForThreadexplain:
      "À chaque conversation, si l’utilisateur envoie un nouveau message, le flow de conversation redémarre depuis le début",
    prompt: "Prompt",
    promptanalysisexplain:
      "Brancy analyse votre Prompt et propose les meilleurs réglages pour des réponses intelligentes",

    autosave: "Sauvegarde Automatique",
    Restrictorzoom: "Limiter le Zoom",
    snapGrid: "Alignement sur la Grille",
    PanningBoundary: "Limite de Déplacement",
    Flow: "Flux (Flow)",
    flowtitle: "Titre du Flux",
    AIFlow_input: "Entrée",
    AIFlow_input_message_block: "Message d’Entrée Utilisateur",
    AIFlow_output: "Sortie",
    AIFlow_output_title: "Titre de la Sortie",
    AIFlow_text: "Texte",
    AIFlow_item_text: "Élément",
    AIFlow_block_title_required: "Veuillez saisir le titre du bloc (obligatoire)",
    AIFlow_item_title: "Titre de l’Élément:",
    AIFlow_show_graph: "Afficher le graphique du flux",
    AIFlow_connect_post: "Associer à une publication",
    AIFlow_connect_post_access:
      "Les autorisations Instagram de commentaires et de messages et les accès Automatisation et Commentaires sont requis.",
    AIFlow_connect_post_save_first: "Enregistrez ce flux avant de l'associer à une publication.",
    AIFlow_connect_post_confirm:
      "Ce flux remplace la réponse automatique actuelle de la publication et est activé. Les mots-clés et leur mode de correspondance sont conservés ; sans mots-clés, le flux répond à tous les commentaires.",
    AIFlow_connect_post_resume:
      "L'association du flux est enregistrée, mais l'activation a échoué. Réessayez de l'activer.",
    AIFlow_connect_post_incompatible:
      "Ce flux est incompatible avec les réponses privées aux commentaires. Modifiez-le et enregistrez-le avant de l'associer.",
    AIFlow_retry: "Réessayer",
    AIPrompt_connect_post_access:
      "L'autorisation de commentaires Instagram et les accès Automatisation et Commentaires sont requis.",
    AIPrompt_connect_post_confirm:
      "Cette IA remplace la réponse automatique actuelle de la publication et est activée. Les mots-clés et leur mode de correspondance sont conservés ; sans mots-clés, tous les commentaires reçoivent une réponse. L'envoi privé est conservé uniquement si l'autorisation de messages est disponible ; sinon, les réponses sont envoyées en commentaires.",
    AIPrompt_connect_post_resume:
      "L'association de l'IA est enregistrée, mais l'activation a échoué. Réessayez de l'activer.",
    messagesetting_PhoneNumbers: "Numéros de téléphone",
    messagesetting_PhoneNumbersExplain: "Numéros de téléphone collectés auprès de vos clients via les flux",
    messagesetting_PhoneNumbersEmpty: "Aucun numéro de téléphone n'a encore été collecté",
    AIFlow_item_subtitle: "Sous-titre de l’Élément:",
    AIFlow_option_title: "Titre de l’Option",
    AIFlow_option_default: "Option",
    AIFlow_quick_reply: "Réponse Rapide",
    AIFlow_quick_reply_validation_error: "Tous les champs de réponse rapide doivent être remplis!",
    AIFlow_quick_reply_block_title_empty: "Bloc {label}\n Aucun titre saisi",
    AIFlow_quick_reply_option_title_empty: "Bloc {label}\n Option {index} sans titre",
    AIFlow_delete_image: "🗑️ Supprimer l’Image",
    AIFlow_delete_image_button_text: "🗑️ Supprimer l’Image",
    AIFlow_delete_all_block: "🗑️ Supprimer le Bloc",
    AIFlow_delete_all_blocks: "Supprimer tout le Flux",
    AIFlow_save_all_blocks: "Sauvegarder tout le Flux",
    AIFlow_delete: "🗑️ Supprimer",
    AIFlow_upload_image: "📷 Télécharger une Image",
    AIFlow_image_uploaded: "Image Téléchargée ✓",
    AIFlow_add_image: "📷 Ajouter une Image",
    AIFlow_voice_recorded: "🎵 Voix Enregistrée",
    AIFlow_record_voice: "🎤 Enregistrer une Voix",
    AIFlow_record_voice_confirm: "Prêt à enregistrer ? (minimum 3 secondes)",
    AIFlow_play_voice: "▶️ Lire la Voix",
    AIFlow_add_output: "Ajouter une Nouvelle Sortie",
    AIFlow_add_subtitle: "➕ Ajouter un Sous-titre",
    AIFlow_subtitle_input: "Veuillez saisir le sous-titre:",
    AIFlow_link: "Lien:",
    AIFlow_general_block: "Bloc Général",
    AIFlow_text_block: "Bloc de Texte",
    AIFlow_image_block: "Bloc d’Image",
    AIFlow_voice_block: "Bloc de Voix",
    AIFlow_quick_reply_block: "Bloc de Réponse Rapide",
    AIFlow_weblink_block: "Bloc de Lien",
    AIFlow_add_text_block: "Ajouter un Bloc de Texte",
    AIFlow_add_image_block: "Ajouter un Bloc d’Image",
    AIFlow_add_voice_block: "Ajouter un Bloc de Voix",
    AIFlow_add_quick_reply_block: "Ajouter une Réponse Rapide",
    AIFlow_add_general_block: "Ajouter un Bloc Général",
    AIFlow_add_weblink_block: "Ajouter un Lien",
    AIFlow_generic_block: "Bloc Générique",
    AutoLayout_block: "Disposition Automatique",
    AIFlow_live_test_block: "Test en Direct du Flux",
    AIFlow_Deleteallblocks_alert: "Êtes-vous sûr de vouloir supprimer tout le flux?",
    AIFlow_add_output_error_alert: "Erreur lors de l’ajout de la sortie: {error}",
    AIFlow_unknown_block_type_alert: "Type de bloc inconnu:",
    AIFlow_multiple_flow_for_private_reply_alert: "Plusieurs flux trouvés pour la réponse privée",
    AIFlow_empty_title_for_flow_alert: "Le titre du flux est vide",
    AIFlow_weblink_has_hyphen_alert: "Bloc {label}\n Le lien ne doit pas contenir «-»",
    AIFlow_min_output_required: "Au moins une sortie doit rester",
    AIFlow_max_quick_reply_outputs: "Maximum de 15 sorties autorisées",
    AIFlow_max_generic_outputs: "Maximum de 10 sorties autorisées",
    AIFlow_generic_item_connection_only: "Ce bloc se connecte uniquement aux blocs génériques",
    AIFlow_weblink_generic_item_only: "Ce bloc se connecte uniquement aux sous-éléments génériques",
    AIFlow_voice_record_failed: "❌ L’enregistrement vocal a échoué (aucun son enregistré)",
    AIFlow_voice_upload_failed: "✅ L’enregistrement a réussi mais le téléversement a échoué",
    AIFlow_voice_record_empty: "❌ L’enregistrement vocal est vide",
    AIFlow_voice_record_start: "🎙️ Enregistrement commencé...",
    AIFlow_session_invalid: "Session utilisateur invalide, veuillez vous reconnecter",
    AIFlow_no_on_message_node: "Aucun nœud de message de départ trouvé!",
    AIFlow_validation_warning: "⚠️ Avertissement de validation",
    AIFlow_generic_item_validation_error: "Veuillez compléter tous les champs du bloc générique",
    AIFlow_weblink_validation_error_alert: "Tous les champs du lien doivent être remplis",
    AIFlow_generic_item_title_empty_alert: "Élément {label}\n Le titre est vide",
    AIFlow_generic_item_output_title_empty_alert: "Élément {label}\n La sortie {index} n’a pas de titre",
    AIFlow_weblink_empty_alert: "Bloc {label}\n Le lien est vide",

    AIFlow_weblink_incomplete_alert: "Bloc {label}\n Le lien est incomplet (seul le protocole saisi)",
    AIFlow_weblink_invalid_format_alert: "Bloc {label}\n Format de lien invalide",
    AIFlow_weblink_non_english_alert: "Bloc {label}\n Le lien doit être en anglais",
    AIFlow_editor_init_error: "❌ Erreur lors de l'initialisation de l'éditeur",
    AIFlow_unexpected_error: "⚠️ Une erreur inattendue est survenue",
    AIFlow_server_error: "❌ Erreur serveur",
    AIFlow_connection_error: "⚠️ Problème de connexion",
    AIFlow_generic_connection_error: "Erreur de connexion du bloc générique à un sous-élément",
    AIFlow_weblink_connection_error: "Erreur de connexion du nœud",
    AIFlow_voice_fetch_error: "Erreur lors de la récupération du fichier audio",
    AIFlow_voice_record_error: "Erreur lors de l'enregistrement vocal",
    AIFlow_voice_play_error: "Erreur lors de la lecture audio",
    AIFlow_media_recorder_error: "Erreur dans l'enregistreur média",
    AIFlow_upload_error: "❌ Erreur de téléchargement",
    AIFlow_add_output_error: "❌ Erreur lors de l'ajout de sortie",
    AIFlow_json_parse_error: "Erreur lors du traitement du JSON",
    AIFlow_position_error: "Erreur lors du traitement de la position du message de départ",
    AIFlow_node_remove_error: "Erreur lors de la suppression du nœud",
    AIFlow_node_connection_warning: "Impossible d'établir la connexion :",
    AIFlow_unknown_value_type: "Type de valeur inconnu dans le bouton",
    AIFlow_success: "✅ Opération réussie",
    AIFlow_subtitle_success: "✓ Sous-titre ajouté avec succès",
    AI_live_test: "Testez vos invites d'IA en temps réel",

    New_Flow_input_message_block: "Message d'entrée utilisateur",
    New_Flow_general_block: "Bloc général",
    New_Flow_text_block: "Bloc de texte",
    New_Flow_voice_block: "Bloc audio",
    New_Flow_imageorvideo_block: "Bloc image / vidéo",
    New_Flow_quick_reply_block: "Bloc de réponse rapide",
    New_Flow_weblink_block: "Bloc de lien",
    New_Flow_phonenumbergrabber_block: "Collecte du numéro de téléphone",
    New_Flow_ai_block: "IA",
    New_Flow_ai_select: "Sélectionner une IA",
    New_Flow_ai_livetest: "Votre bloc d’IA est en cours d’exécution ici",
    New_Flow_masterflow_block: "Sous-flux",
    New_Flow_masterflow_select: "Sélectionner un flux",
    New_Flow_masterflow_livetest: "Le sous-flux sélectionné continue à partir d’ici",
    New_Flow_Tutorials_buttongroup_title: "Bloc Groupe de boutons",
    New_Flow_Tutorials_buttongroup_description:
      "Ce bloc envoie un message avec jusqu'à trois boutons ; chaque bouton a sa propre sortie, et le bloc possède aussi une sortie classique qui poursuit le flux.",
    New_Flow_Tutorials_buttongroup_usageType:
      "Adapté pour proposer quelques choix clairs, des menus, une navigation rapide et orienter l'utilisateur vers un lien ou l'étape suivante.",
    New_Flow_Tutorials_buttongroup_feature_1: "Texte du message jusqu'à 640 caractères",
    New_Flow_Tutorials_buttongroup_feature_2: "Jusqu'à 3 boutons, chacun avec une sortie indépendante",
    New_Flow_Tutorials_buttongroup_feature_3:
      "Une sortie classique poursuit le flux sans attendre un clic sur un bouton",
    New_Flow_Tutorials_buttongroup_tip_1: "Rédigez le message et les libellés des boutons de façon claire et brève",
    New_Flow_Tutorials_buttongroup_tip_2: "Reliez chaque bouton au bloc qui doit suivre son choix",
    New_Flow_Tutorials_buttongroup_tip_3: "Seules les sorties des boutons peuvent être reliées à un bloc Lien web",
    New_Flow_Tutorials_buttongroup_limitation_1: "Maximum 3 boutons",
    New_Flow_Tutorials_buttongroup_limitation_2: "Texte du message : 640 caractères max",
    New_Flow_Tutorials_buttongroup_limitation_3: "Titre du bouton : 20 caractères max",
    New_Flow_Tutorials_buttongroup_limitation_4: "Supprimer le dernier bouton supprime le bloc",
    New_Flow_Tutorials_ai_title: "Bloc IA",
    New_Flow_Tutorials_ai_description:
      "Ce bloc confie la conversation à l'une des IA que vous avez créées ; choisissez l'IA dans la liste du bloc.",
    New_Flow_Tutorials_ai_usageType:
      "Adapté pour répondre automatiquement aux questions ouvertes des clients, au support, au conseil et aux conversations de vente.",
    New_Flow_Tutorials_ai_feature_1: "Affiche toutes les IA que vous avez créées pour en choisir une",
    New_Flow_Tutorials_ai_feature_2: "L'IA choisie prend en charge la conversation à partir de ce point du flux",
    New_Flow_Tutorials_ai_tip_1: "Créez et configurez d'abord votre IA pour qu'elle apparaisse dans la liste",
    New_Flow_Tutorials_ai_tip_2: "Placez-le après un bloc message qui introduit la conversation",
    New_Flow_Tutorials_ai_limitation_1: "Possède une entrée mais aucune sortie, il termine donc le flux",
    New_Flow_Tutorials_ai_limitation_2: "Une seule IA peut être sélectionnée par bloc",
    New_Flow_Tutorials_ai_limitation_3: "Ne peut pas être le premier bloc du flux",
    New_Flow_Tutorials_masterflow_title: "Bloc Sous-flux",
    New_Flow_Tutorials_masterflow_description:
      "Redirige la conversation vers un autre flux déjà créé lorsque l’utilisateur appuie sur un bouton.",
    New_Flow_Tutorials_masterflow_usageType: "Réutiliser un flux existant comme suite d’un bouton",
    New_Flow_Tutorials_masterflow_feature_1: "Liste tous les flux que vous avez créés pour en choisir un",
    New_Flow_Tutorials_masterflow_feature_2: "Le flux sélectionné poursuit la conversation à partir de ce point",
    New_Flow_Tutorials_masterflow_tip_1: "Créez et enregistrez d’abord le flux cible pour qu’il apparaisse dans la liste",
    New_Flow_Tutorials_masterflow_tip_2: "Utilisez-le pour partager des parcours communs (support, tarifs) entre flux",
    New_Flow_Tutorials_masterflow_limitation_1: "Possède une entrée uniquement et aucune sortie, il termine donc ce flux",
    New_Flow_Tutorials_masterflow_limitation_2: "Ne peut être relié qu’à des boutons, pas aux sorties normales",
    New_Flow_Tutorials_masterflow_limitation_3: "Le flux en cours de modification ne peut pas être sélectionné",
    New_Flow_Tutorials_masterflow_connection_1: "Boutons du bloc Réponse rapide",
    New_Flow_Tutorials_masterflow_connection_2: "Boutons du bloc Groupe de boutons",
    New_Flow_Tutorials_masterflow_connection_3: "Boutons du sous-bloc Galerie",
    New_Flow_generic_block: "Bloc Galerie (Carrousel)",
    New_Flow_add_general_block: "Ajouter un bloc de galerie",
    New_Flow_add_text_block: "Ajouter un bloc de texte",
    New_Flow_add_image_block: "Ajouter un bloc d'image",
    New_Flow_add_voice_block: "Ajouter un bloc audio",
    New_Flow_add_quick_reply_block: "Ajouter une réponse rapide",
    New_Flow_add_weblink_block: "Ajouter un lien",
    New_Flow_upload_imageorvideo: "Téléverser une image ou une vidéo",
    New_Flow_upload_image: "Téléverser une image",
    New_Flow_upload_unsupported_media: "Format de média non pris en charge",
    New_Flow_uploadmaxsizeexceeded: "La taille du fichier ne doit pas dépasser 50MB",
    New_Flow_uploadfilefailed: "Échec du téléversement, veuillez réessayer",
    New_Flow_unsupportedbrowser: "Votre navigateur ne prend pas en charge la lecture vidéo",
    New_Flow_micphoneaccessdenied: "Activez l'accès au microphone",
    New_Flow_upload_audio: "Téléverser un fichier audio",
    New_Flow_record_voice: "Enregistrer la voix",
    New_Flow_stop_record_voice: "Arrêter l'enregistrement",
    New_Flow_areyoureadytorecord: "Prêt à enregistrer ?",
    New_Flow_voice_recording_started: "Enregistrement en cours...",
    New_Flow_add_generic_sub_block: "Ajouter un sous-bloc",
    New_Flow_generic_sub: "Sous-bloc",
    New_Flow_add_button: "Ajouter un bouton",
    New_Flow_quick_reply_title_placeholder: "Titre de l’option de réponse rapide",
    New_Flow_buttongroup_block: "Bloc de groupe de boutons",
    New_Flow_add_buttongroup_block: "Ajouter un groupe de boutons",
    New_Flow_buttongroup_title_placeholder: "Texte du message du groupe de boutons",
    New_Flow_imagegallery_block: "Bloc Galerie d'images",
    New_Flow_add_imagegallery_block: "Ajouter une galerie d'images",
    New_Flow_imagegallery_max_reached: "Vous pouvez ajouter jusqu'à {{max}} images dans ce bloc",
    New_Flow_Tutorials_imagegallery_title: "Bloc Galerie d'images",
    New_Flow_Tutorials_imagegallery_description:
      "Ce bloc permet de téléverser et d'envoyer plusieurs images (jusqu'à {{max}}) aux utilisateurs par message direct.",
    New_Flow_Tutorials_imagegallery_usageType:
      "Idéal pour présenter plusieurs produits, des albums photo, des photos avant/après et des collections d'images.",
    New_Flow_Tutorials_imagegallery_feature_1: "Accepte jusqu'à {{max}} images dans un seul bloc",
    New_Flow_Tutorials_imagegallery_limitation_1:
      "Maximum {{max}} images par bloc (cette limite pourrait augmenter à l'avenir)",
    New_Flow_message_title: "Titre du message",
    New_Flow_message_description: "Description du message",
    New_Flow_live_test_block: "Test en direct du flux",
    New_Flow_delete_all_blocks: "Supprimer l'intégralité du flux",
    New_Flow_shortcuts_explain:
      "Raccourcis clavier pour augmenter la vitesse et la maîtrise dans la gestion des flux de travail.",
    New_Flow_Tutorials_Not_Available: "Tutoriel non disponible",
    New_Flow_Tutorials_Not_Available_Description: "Aucun tutoriel n’est disponible pour ce nœud.",
    New_Flow_Tutorials_Usage_Type: "Type d’utilisation",
    New_Flow_Tutorials_Features: "Fonctionnalités",
    New_Flow_Tutorials_Tips: "Astuces pratiques",
    New_Flow_Tutorials_Limitations: "Limites",
    New_Flow_Tutorials_Connections: "Connexions",
    New_Flow_unsavedChanges: "Vous avez des modifications non enregistrées",
    New_Flow_addedNodes: "Nœuds ajoutés",
    New_Flow_removedNodes: "Nœuds supprimés",
    New_Flow_modifiedNodes: "Nœuds modifiés",
    New_Flow_invalidFlow_explain:
      "Le flow n’est pas valide. Veuillez vérifier les nœuds pour détecter d’éventuelles erreurs avant d’enregistrer",
    sendsms: "Envoyer un SMS à l’utilisateur",
    sendtotelegram: "Rediriger l’utilisateur vers Telegram",
    senderusername: "Mentionner le nom de l’utilisateur",
    addtools: "Ajouter un outil",
    generatebyai: "Générer par IA",

    //tutorials

    New_Flow_Tutorials_onmessage_title: "Point de départ de votre flux",
    New_Flow_Tutorials_onmessage_description:
      "Ce bloc est le point de départ de votre flux. Lorsqu'un utilisateur envoie un message à votre direct Instagram, ce bloc est déclenché et le flux commence. Il est toujours le premier bloc dans toute automatisation et ne peut pas être supprimé.",
    New_Flow_Tutorials_onmessage_feature_1: "Une sortie unique pour se connecter au bloc suivant",
    New_Flow_Tutorials_onmessage_tip_1:
      "Connectez la sortie de ce bloc à n'importe quel autre bloc. Le flux démarre lorsque l'utilisateur envoie tout type de message (texte, image, vidéo, audio, etc.)",
    New_Flow_Tutorials_onmessage_connection_1: "Connectable aux blocs suivants :",
    New_Flow_Tutorials_onmessage_connection_2: "❌ Bloc Lien Web",
    New_Flow_Tutorials_onmessage_connection_3: "✅ Bloc Message Vocal",
    New_Flow_Tutorials_onmessage_connection_4: "✅ Bloc Message Texte",
    New_Flow_Tutorials_onmessage_connection_5: "✅ Bloc Réponse Rapide",
    New_Flow_Tutorials_onmessage_connection_6: "✅ Bloc Image & Vidéo",
    New_Flow_Tutorials_onmessage_connection_7: "✅ Bloc Galerie",

    New_Flow_Tutorials_text_title: "Bloc Message Texte",
    New_Flow_Tutorials_text_description: "Ce bloc est utilisé pour envoyer des messages texte aux utilisateurs.",
    New_Flow_Tutorials_text_usageType:
      "Convient pour les messages de bienvenue, explication des produits, FAQ, notifications et orientation des utilisateurs.",
    New_Flow_Tutorials_text_feature_1: "Prend en charge toutes les langues",
    New_Flow_Tutorials_text_feature_2: "Possibilité d'utiliser des emojis et des caractères spéciaux",
    New_Flow_Tutorials_text_tip_1: "Rédigez des messages courts et clairs",
    New_Flow_Tutorials_text_tip_2: "Utilisez les emojis avec modération",
    New_Flow_Tutorials_text_tip_3: "Divisez les textes longs en plusieurs sections",
    New_Flow_Tutorials_text_tip_4: "Adoptez un ton amical et accessible",
    New_Flow_Tutorials_text_tip_5: "Utilisez une mise en page appropriée",
    New_Flow_Tutorials_text_limitation_1: "Maximum 2200 caractères",
    New_Flow_Tutorials_text_limitation_2: "Texte uniquement (pas de fichiers ou médias)",
    New_Flow_Tutorials_text_limitation_3: "Pas de formatage (Gras, Italique)",
    New_Flow_Tutorials_text_connection_1: "✅ Bloc Entrée Message",
    New_Flow_Tutorials_text_connection_2: "❌ Bloc Lien Web",
    New_Flow_Tutorials_text_connection_3: "✅ Bloc Message Vocal",
    New_Flow_Tutorials_text_connection_4: "✅ Bloc Message Texte",
    New_Flow_Tutorials_text_connection_5: "✅ Bloc Réponse Rapide",
    New_Flow_Tutorials_text_connection_6: "✅ Bloc Image & Vidéo",
    New_Flow_Tutorials_text_connection_7: "❌ Bloc Galerie",
    New_Flow_Tutorials_text_connection_8: "✅ Bloc Sous-branche Galerie",

    New_Flow_Tutorials_image_title: "Bloc Image & Vidéo",
    New_Flow_Tutorials_image_description:
      "Ce bloc est utilisé pour télécharger et envoyer des images et vidéos aux utilisateurs via direct.",
    New_Flow_Tutorials_image_usageType:
      "Convient pour présenter des produits, des galeries d'images, des logos, des bannières promotionnelles, des vidéos éducatives et de présentation.",
    New_Flow_Tutorials_image_feature_1: "Support des images : JPEG, PNG, GIF, WebP, SVG",
    New_Flow_Tutorials_image_feature_2: "Support des vidéos : MP4, WebM, OGG, MOV, AVI, MKV",
    New_Flow_Tutorials_image_feature_3: "Détection automatique du type de fichier",
    New_Flow_Tutorials_image_tip_1: "Utilisez des images de haute qualité",
    New_Flow_Tutorials_image_tip_2: "Compressez les fichiers volumineux avant le téléchargement",
    New_Flow_Tutorials_image_tip_3: "Dimensions standard : 1080×1080 ou 1080×1350",
    New_Flow_Tutorials_image_tip_4: "Gardez les vidéos sous 30 secondes",
    New_Flow_Tutorials_image_tip_5: "JPEG pour les images normales, PNG pour les fonds transparents",
    New_Flow_Tutorials_image_limitation_1: "Taille maximale : 50 Mo",
    New_Flow_Tutorials_image_limitation_2: "Un fichier par bloc",
    New_Flow_Tutorials_image_limitation_3: "Les formats inhabituels peuvent ne pas être pris en charge",
    New_Flow_Tutorials_image_connection_1: "✅ Bloc Entrée Message",
    New_Flow_Tutorials_image_connection_2: "❌ Bloc Lien Web",
    New_Flow_Tutorials_image_connection_3: "✅ Bloc Message Vocal",
    New_Flow_Tutorials_image_connection_4: "✅ Bloc Message Texte",
    New_Flow_Tutorials_image_connection_5: "✅ Bloc Réponse Rapide",
    New_Flow_Tutorials_image_connection_6: "✅ Bloc Image & Vidéo",
    New_Flow_Tutorials_image_connection_7: "❌ Bloc Galerie",
    New_Flow_Tutorials_image_connection_8: "✅ Sous-bloc Galerie",
    invalidFlowDetected: "Flux non valide ! Certains blocs n'ont pas d'entrée ou le bloc de message est isolé.",

    New_Flow_Tutorials_voice_title: "Bloc Message Vocal",
    New_Flow_Tutorials_voice_description:
      "Ce bloc est utilisé pour télécharger et envoyer des fichiers audio ou des enregistrements en direct aux utilisateurs.",
    New_Flow_Tutorials_voice_usageType:
      "Convient pour les messages vocaux personnels, les tutoriels narrés, les podcasts courts et les guides vocaux.",
    New_Flow_Tutorials_voice_feature_1: "Support des formats : MP3, M4A, WAV, OGG, AAC",
    New_Flow_Tutorials_voice_feature_2: "Enregistrement direct depuis le micro",
    New_Flow_Tutorials_voice_feature_3: "Télécharger des fichiers audio préenregistrés",
    New_Flow_Tutorials_voice_tip_1: "Enregistrez dans un environnement calme",
    New_Flow_Tutorials_voice_tip_2: "Les messages courts (moins de 1 minute) sont préférables",
    New_Flow_Tutorials_voice_tip_3: "Vérifiez la qualité audio avant l'envoi",
    New_Flow_Tutorials_voice_tip_4: "Préparez votre texte avant l'enregistrement",
    New_Flow_Tutorials_voice_limitation_1: "Taille maximale : 50 Mo",
    New_Flow_Tutorials_voice_limitation_2: "Accès au micro requis pour l'enregistrement",
    New_Flow_Tutorials_voice_limitation_3: "Un fichier par bloc",
    New_Flow_Tutorials_voice_connection_1: "✅ Bloc Entrée Message",
    New_Flow_Tutorials_voice_connection_2: "❌ Bloc Lien Web",
    New_Flow_Tutorials_voice_connection_3: "✅ Bloc Message Vocal",
    New_Flow_Tutorials_voice_connection_4: "✅ Bloc Message Texte",
    New_Flow_Tutorials_voice_connection_5: "✅ Bloc Réponse Rapide",
    New_Flow_Tutorials_voice_connection_6: "✅ Bloc Image & Vidéo",
    New_Flow_Tutorials_voice_connection_7: "❌ Bloc Galerie",
    New_Flow_Tutorials_voice_connection_8: "✅ Sous-bloc Galerie",

    New_Flow_Tutorials_quickreply_title: "Bloc de réponse rapide",
    New_Flow_Tutorials_quickreply_description:
      "Ce bloc est utilisé pour créer des boutons Quick Reply jetables pour les utilisateurs, où chaque bouton guide l'utilisateur dans un chemin spécifique du flux.",
    New_Flow_Tutorials_quickreply_usageType:
      "Convient pour les menus de sélection, catégories de produits, questions à choix multiples, sondages et filtres de recherche.",
    New_Flow_Tutorials_quickreply_feature_1: "Jusqu'à 10 boutons par bloc",
    New_Flow_Tutorials_quickreply_feature_2: "Chaque bouton a une sortie indépendante",
    New_Flow_Tutorials_quickreply_feature_3: "Possibilité de supprimer et modifier les boutons",
    New_Flow_Tutorials_quickreply_tip_1: "Écrivez le texte des boutons clairement et de manière pratique",
    New_Flow_Tutorials_quickreply_tip_2: "3 à 5 boutons pour une meilleure expérience",
    New_Flow_Tutorials_quickreply_tip_3: "Gardez les étiquettes courtes (moins de 20 caractères)",
    New_Flow_Tutorials_quickreply_tip_4: "Utilisez le champ titre pour guider",
    New_Flow_Tutorials_quickreply_tip_5: "Priorisez les boutons selon leur importance",
    New_Flow_Tutorials_quickreply_limitation_1: "Maximum 10 boutons",
    New_Flow_Tutorials_quickreply_limitation_2: "Titre du bouton : 40 caractères max",
    New_Flow_Tutorials_quickreply_limitation_3: "Description : 140 caractères max",
    New_Flow_Tutorials_quickreply_limitation_4: "Au moins un bouton requis",
    New_Flow_Tutorials_quickreply_connection_1: "✅ Bloc de saisie de message",
    New_Flow_Tutorials_quickreply_connection_2: "❌ Bloc lien Web",
    New_Flow_Tutorials_quickreply_connection_3: "✅ Bloc message vocal",
    New_Flow_Tutorials_quickreply_connection_4: "✅ Bloc message texte",
    New_Flow_Tutorials_quickreply_connection_5: "✅ Bloc de réponse rapide",
    New_Flow_Tutorials_quickreply_connection_6: "✅ Bloc image et vidéo",
    New_Flow_Tutorials_quickreply_connection_7: "❌ Bloc galerie",
    New_Flow_Tutorials_quickreply_connection_8: "✅ Sous-bloc galerie",

    New_Flow_Tutorials_generic_title: "Bloc Galerie (Carrousel)",
    New_Flow_Tutorials_generic_description: "Créer une galerie déroulante horizontalement (carrousel) d'éléments",
    New_Flow_Tutorials_generic_usageType:
      "Convient pour afficher des produits, menus de services, catégories, présentation de l'équipe, portfolio et comparaison d'options.",
    New_Flow_Tutorials_generic_tip_1: "Utilisez des images avec des dimensions identiques (ex : 1:1)",
    New_Flow_Tutorials_generic_tip_2: "Gardez le nombre d'éléments entre 3 et 5",
    New_Flow_Tutorials_generic_tip_3: "Écrivez des titres courts et clairs",
    New_Flow_Tutorials_generic_tip_4: "Convient pour des produits similaires ou des comparaisons",
    New_Flow_Tutorials_generic_limitation_1: "Maximum 10 éléments par carrousel",
    New_Flow_Tutorials_generic_connection_1: "✅ Bloc de saisie de message",
    New_Flow_Tutorials_generic_connection_2: "✅ Sous-bloc galerie",
    New_Flow_Tutorials_generic_connection_3: "❌ Bloc lien Web",
    New_Flow_Tutorials_generic_connection_4: "❌ Bloc message vocal",
    New_Flow_Tutorials_generic_connection_5: "❌ Bloc message texte",
    New_Flow_Tutorials_generic_connection_6: "❌ Bloc de réponse rapide",
    New_Flow_Tutorials_generic_connection_7: "❌ Bloc image et vidéo",

    New_Flow_Tutorials_genericitem_title: "Élément Carrousel",
    New_Flow_Tutorials_genericitem_description:
      "Un élément dans le carrousel incluant image, titre, description, lien et jusqu'à 3 boutons",
    New_Flow_Tutorials_genericitem_usageType:
      "Convient pour afficher les détails des produits, présenter des services, montrer l'équipe, les portfolios et les packages tarifaires.",
    New_Flow_Tutorials_genericitem_feature_1: "Lien web optionnel",
    New_Flow_Tutorials_genericitem_feature_2: "Image optionnelle: JPEG, PNG, GIF",
    New_Flow_Tutorials_genericitem_feature_3: "Vidéo: MP4, WebM, OGG",
    New_Flow_Tutorials_genericitem_feature_4: "Jusqu'à 3 boutons avec sorties indépendantes",
    New_Flow_Tutorials_genericitem_tip_1: "Ajoutez une image attrayante pour chaque élément",
    New_Flow_Tutorials_genericitem_tip_2: "Titre pour le message principal, description pour les détails",
    New_Flow_Tutorials_genericitem_tip_3: "Testez les liens avant envoi",
    New_Flow_Tutorials_genericitem_tip_4: "Les textes des boutons doivent être courts et clairs",
    New_Flow_Tutorials_genericitem_tip_5: "Privilégiez l'utilisation de liens raccourcis",
    New_Flow_Tutorials_genericitem_limitation_1: "Titre : maximum 140 caractères",
    New_Flow_Tutorials_genericitem_limitation_2: "Description : maximum 140 caractères",
    New_Flow_Tutorials_genericitem_limitation_3: "Maximum 3 boutons",
    New_Flow_Tutorials_genericitem_limitation_4: "Titre du bouton : maximum 40 caractères",
    New_Flow_Tutorials_genericitem_limitation_5: "Taille du fichier : maximum 50 Mo",
    New_Flow_Tutorials_genericitem_limitation_6: "Au moins un bouton est obligatoire",
    New_Flow_Tutorials_genericitem_connection_1: "❌ Bloc d'entrée de message",
    New_Flow_Tutorials_genericitem_connection_2: "✅ Bloc galerie",
    New_Flow_Tutorials_genericitem_connection_3: "✅ Bloc lien web",
    New_Flow_Tutorials_genericitem_connection_4: "✅ Bloc message vocal",
    New_Flow_Tutorials_genericitem_connection_5: "✅ Bloc message texte",
    New_Flow_Tutorials_genericitem_connection_6: "✅ Bloc réponse rapide",
    New_Flow_Tutorials_genericitem_connection_7: "✅ Bloc image et vidéo",

    New_Flow_Tutorials_weblink_title: "Bloc Lien Web",
    New_Flow_Tutorials_phonenumbergrabber_title: "Bloc Collecte du numéro de téléphone",
    New_Flow_Tutorials_phonenumbergrabber_description:
      "Ce bloc attend la réception d'un numéro de téléphone et, une fois reçu, l'enregistre comme numéro valide.",
    New_Flow_Tutorials_phonenumbergrabber_usageType:
      "Idéal pour collecter les numéros des clients, les inscriptions, le suivi des commandes, les consultations et le contact commercial.",
    New_Flow_Tutorials_phonenumbergrabber_feature_1:
      "Attend la réponse de l'utilisateur jusqu'à la réception d'un numéro",
    New_Flow_Tutorials_phonenumbergrabber_feature_2: "Valide et enregistre automatiquement le numéro reçu",
    New_Flow_Tutorials_phonenumbergrabber_tip_1: "Avant ce bloc, demandez le numéro à l'utilisateur avec un bloc texte",
    New_Flow_Tutorials_phonenumbergrabber_tip_2: "Indiquez le format attendu (par ex. avec l'indicatif du pays)",
    New_Flow_Tutorials_phonenumbergrabber_tip_3: "Après ce bloc, envoyez un message de confirmation ou de remerciement",
    New_Flow_Tutorials_phonenumbergrabber_limitation_1: "Ne peut pas être le premier bloc du flux",
    New_Flow_Tutorials_phonenumbergrabber_limitation_2: "Une seule entrée et une seule sortie",
    New_Flow_Tutorials_phonenumbergrabber_limitation_3: "Seuls les numéros valides sont enregistrés",
    New_Flow_Tutorials_phonenumbergrabber_connection_3: "❌ Bloc sous-branche de la galerie",
    New_Flow_Tutorials_phonenumbergrabber_connection_2: "❌ Bloc de réponse rapide",
    New_Flow_Tutorials_phonenumbergrabber_connection_1:
      "❌ Bloc d'entrée de message (ne peut pas être le premier bloc)",
    New_Flow_Tutorials_weblink_description:
      "Envoyer un lien web cliquable qui s’ouvre dans le navigateur de l’utilisateur",
    New_Flow_Tutorials_weblink_usageType:
      "Idéal pour diriger vers un site web, page produit, boutique, formulaire d’inscription, landing pages et articles.",
    New_Flow_Tutorials_weblink_feature_1: "Validation automatique de l'URL",
    New_Flow_Tutorials_weblink_feature_2: "Support des liens avec/sans WWW",
    New_Flow_Tutorials_weblink_tip_1: "Préférez les liens raccourcis",
    New_Flow_Tutorials_weblink_tip_2: "Testez les liens avant envoi",
    New_Flow_Tutorials_weblink_tip_3: "Les liens doivent être mobile-friendly",
    New_Flow_Tutorials_weblink_tip_4: "Évitez trop de redirections",
    New_Flow_Tutorials_weblink_tip_5: "Privilégiez HTTPS",
    New_Flow_Tutorials_weblink_limitation_1: "Seuls http:// ou https:// sont valides",
    New_Flow_Tutorials_weblink_limitation_2: "Impossible d’ajouter une description",
    New_Flow_Tutorials_weblink_limitation_3: "Les liens internes (file://) ne sont pas supportés",
    New_Flow_Tutorials_weblink_connection_1: "⬅️ Entrée de: Bloc galerie enfant",
    New_Flow_Tutorials_weblink_connection_2: "❌ Pas de sortie (point de fin du flux)",

    // #region AIFlow Section

    // #region Notification Section
    Notify_Ok: "Opération effectuée avec succès",
    Notify_InternalException: "Une erreur système s'est produite",
    Notify_CannotSendSmsNow: "Impossible d'envoyer le SMS pour le moment",
    Notify_InvalidPhoneNumber: "Le numéro de téléphone saisi est invalide",
    Notify_InvalidCountryCode: "Le code pays saisi est invalide",
    Notify_PhoneNumberNotAvailableInThisCountry: "Ce numéro ne peut pas être utilisé dans le pays sélectionné",
    Notify_InstagramerIdNotExist: "Utilisateur Instagram introuvable",
    Notify_EmptyProductList: "La liste des produits est vide",
    Notify_InvalidVerificationCode: "Le code de vérification saisi est incorrect",
    Notify_LowQuality: "La qualité du contenu est faible",
    Notify_CannotEmptyChildren: "Impossible de supprimer les sous-éléments",
    Notify_InvalidAspectRatio: "Le rapport d'aspect saisi est invalide",
    Notify_InvalidMediaCodec: "Le codec média n'est pas pris en charge",
    Notify_InvalidMediaType: "Le type de média n'est pas pris en charge",
    Notify_MediaUrlNotAccessible: "L'URL du média n'est pas accessible",
    Notify_CannotCreatePrePostNow: "Impossible de créer un pré-post pour le moment",
    Notify_InvalidMediaContent: "Le contenu média est invalide",
    Notify_Unexpected: "Une erreur inattendue s'est produite",
    Notify_TooManyRequestForImageHashtagGenerator: "Trop de requêtes pour la génération de hashtags d'image",
    Notify_LoginFailed: "Échec de la connexion, veuillez réessayer",
    Notify_NullUserId: "ID utilisateur non fourni",
    Notify_RealtimeSocketNotExist: "Connexion au serveur non établie",
    Notify_PushSocketNotExist: "Connexion non établie",
    Notify_InstaApiNotFoundForConnect: "Connexion aux serveurs Instagram non établie",
    Notify_EmptyHashtagList: "La liste des hashtags est vide",
    Notify_InvalidHashtagListId: "ID de la liste de hashtags invalide",
    Notify_DeleteHashtagFail: "Échec de la suppression du hashtag",
    Notify_InvalidBase64Content: "Contenu Base64 invalide",
    Notify_InvalidTermsAndConditionSvgType: "Conditions générales invalides",
    Notify_InvalidLotteryAnnouncementBannerId: "ID de la bannière d'annonce de loterie invalide",
    Notify_InvalidLotteryAnnouncementBannerStr: "Texte de la bannière d'annonce de loterie invalide",
    Notify_InvalidPostId: "ID du post invalide",
    Notify_TooSoonLotteryInfo: "Informations sur la loterie envoyées trop tôt",
    Notify_InvalidDirectParams: "Paramètres Direct invalides",
    Notify_NoInstagramerExists: "Aucun compte Instagram trouvé",
    Notify_PropertyNotFoundOrNull: "Élément non trouvé ou vide",
    Notify_ReachNumberOfPinDirect: "Nombre maximal de messages épinglés atteint",
    Notify_InvalidStoryId: "ID de Story invalide",
    Notify_MaxPrePostReach: "Nombre maximal de pré-posts atteint",
    Notify_InvalidDraftId: "ID du brouillon invalide",
    Notify_InvalidPrePostId: "ID du pré-post invalide",
    Notify_ReachHashtagListLimit: "Nombre maximal de listes de hashtags atteint",
    Notify_EmptyUsername: "Nom d'utilisateur non fourni",
    Notify_TooManyRequestForPageHashtagAnalysis: "Trop de requêtes pour l'analyse de hashtags de la page",
    Notify_PasswordRequired: "Mot de passe requis",
    Notify_PackageRequiredInThisTime: "Un package actif est requis",
    Notify_FeatureRequiredInThisTime: "Cette fonctionnalité doit être activée",
    Notify_NoShopperExist: "Aucun vendeur trouvé",
    Notify_FollowerLotteryTypeRandomlyWithoutLoginForVerifiedOrPrivateAccount:
      "Tirage aléatoire de followers sans connexion non autorisé pour comptes privés ou vérifiés",
    Notify_FollowerLotteryTypeEngagmentWithoutLoginForPrivateAccount:
      "Tirage d'engagement de followers sans connexion non autorisé pour comptes privés",
    Notify_InvalidLinkId: "ID du lien invalide",
    Notify_ReachMaxBioLink: "Nombre maximal de liens bio atteint",
    Notify_OnlyBusinessAccountHasThisAccess: "Cet accès est uniquement disponible pour les comptes professionnels",
    Notify_NoYoutubeChannelFound: "Aucune chaîne YouTube trouvée",
    Notify_CannotGetYoutubeRightNow: "Impossible de récupérer les informations YouTube pour le moment",
    Notify_AparatUsernameNotFound: "Nom d'utilisateur Aparat introuvable",
    Notify_AparatChannelHasNotAnyVideo: "La chaîne Aparat n'a aucune vidéo",
    Notify_InvalidYoutubeChannelId: "ID de la chaîne YouTube invalide",
    Notify_NoAparatChannelFound: "Aucune chaîne Aparat trouvée",
    Notify_CannotGetAparatRightNow: "Impossible de récupérer les informations Aparat pour le moment",
    Notify_NotSettedCustomDomain: "Domaine personnalisé non défini",
    Notify_CannotStoryWithoutWinnerBanner: "Impossible de créer une Story sans bannière gagnante",
    Notify_ExceedMaxStoryWinnerLotteryBanner: "Nombre de bannières gagnantes Story dépassé",
    Notify_LotteryOnProcessingOrEnded: "La loterie est en cours de traitement ou terminée",
    Notify_CannotAbortLotteryOneHourBefore: "Impossible d'annuler la loterie moins d'une heure avant l'exécution",
    Notify_CannotAbortFollowerLottery: "Impossible d'annuler la loterie des followers",
    Notify_InvalidImageOrExceedMaxSize: "Image invalide ou dépassant la taille maximale",
    Notify_ExceedLoginAttempt: "Nombre maximal de tentatives de connexion dépassé",
    Notify_NotExistComment: "Commentaire non trouvé",
    Notify_UserNotFound: "Utilisateur non trouvé",
    Notify_ExistInstagramerBefore: "Ce compte Instagram est déjà enregistré",
    Notify_CannotChangeBusinessAccountType:
      "Impossible de changer le type de compte professionnel, veuillez contacter le support via ticket",
    Notify_InvalidProductId: "L'ID du produit saisi n'est pas valide",
    Notify_InvalidTrendHashtagPeriod: "La période choisie pour le hashtag tendance n'est pas valide",
    Notify_InvalidLanguageId: "L'ID de langue n'est pas valide",
    Notify_CannotStoryWithoutTermsBanner: "Impossible de créer un Story sans bannière des conditions",
    Notify_ExceedMaxStoryTermsLotteryBanner:
      "Le nombre de bannières de conditions de loterie Story dépasse la limite autorisée",
    Notify_LotteryTermsIsNull: "Les conditions de la loterie n'ont pas été enregistrées",
    Notify_CanShareTermsBefore6HoursOfStartLottery:
      "Les conditions ne peuvent être partagées que jusqu'à 6 heures avant le début de la loterie",
    Notify_CanShareTermForOnlyDefinedStatusLotteries:
      "Le partage des conditions est actif uniquement pour les loteries en statut défini",
    Notify_SharedRemainingTimeBefore: "Le temps restant a déjà été partagé",
    Notify_ShareRemainingTimeOnlyActiveForScoreLottery:
      "Le partage du temps restant est actif uniquement pour les loteries de score",
    Notify_CanShareTermsBefore1HoursOfStartLottery:
      "Les conditions ne peuvent être partagées que jusqu'à 1 heure avant le début de la loterie",
    Notify_InvalidSubProductIds: "Les ID des sous-produits ne sont pas valides",
    Notify_ReachMaxProductMedia: "Vous avez atteint le nombre maximum de médias pour ce produit",
    Notify_InvalidMediaProductId: "L'ID du média produit n'est pas valide",
    Notify_AccountNotABusiness: "Ce compte n'est pas un compte professionnel",
    Notify_NotFoundProductWithThisTempId: "Aucun produit trouvé avec cet ID temporaire",
    Notify_InvalidAvailabilityStatus: "Le statut de disponibilité saisi n'est pas valide",
    Notify_InvalidIbanNumber: "Le numéro IBAN saisi n'est pas valide",
    Notify_ExistedIbanNumber: "Ce numéro IBAN est déjà enregistré",
    Notify_IbanMethodNotAvailableForNotTomanPriceUser:
      "La méthode IBAN n'est pas disponible pour les utilisateurs avec une devise non-Toman",
    Notify_SearchQueryIsEmpty: "La requête de recherche est vide",
    Notify_ExceedMaxInEachCard: "Le nombre d'éléments dans chaque carte dépasse la limite autorisée",
    Notify_ProductNotAlbumPost: "Ce produit n'est pas enregistré comme Post d'album",
    Notify_InvalidChildrenId: "L'ID de l'enfant n'est pas valide",
    Notify_NotAvailableProduct: "Le produit n'est pas disponible pour le moment",
    Notify_ExceedStockCount: "La quantité sélectionnée dépasse le stock",
    Notify_CannotUnloadAnInstanceProduct: "Impossible de décharger une instance du produit",
    Notify_InvalidCategoryId: "L'ID de catégorie n'est pas valide",
    Notify_NotFoundAnyProductOnThisCategory: "Aucun produit trouvé dans cette catégorie",
    Notify_NotFoundAnyNextProduct: "Aucun produit suivant trouvé",
    Notify_NotFoundAnyPreviousProduct: "Aucun produit précédent trouvé",
    Notify_InvalidItemId: "L'ID de l'article n'est pas valide",
    Notify_IpInvalid: "L'IP saisie n'est pas valide",
    Notify_InstagramRedirectInTenSeconds: "Vous serez automatiquement redirigé vers Instagram dans 10 secondes",
    Notify_InstagramRedirect: "Redirection vers Instagram",
    Notify_InstagramRedirectExplain: "Assurez-vous que votre VPN est activé, car votre adresse IP n'est pas valide",
    Notify_ThisInstagramAccountAddedBefore: "Ce compte Instagram a déjà été ajouté",
    Notify_InvalidTicketId: "L'ID du ticket n'est pas valide",
    Notify_ExpiredSignature: "Signature expirée",
    Notify_Forbidden: "Accès non autorisé",
    Notify_ConnectedInstagramPageNotFound: "Page Instagram connectée introuvable",
    Notify_AllInstagramAccountConnectedAddedBefore: "Tous les comptes Instagram connectés ont déjà été ajoutés",
    Notify_SelectInstagramPageToConnect: "Veuillez sélectionner la page Instagram à connecter",
    Notify_InstagramRedirectRoleNotFound: "Rôle de redirection Instagram introuvable",
    Notify_FacebookLoginNotFound: "Connexion Facebook introuvable",
    Notify_SelectedPageNotFound: "Page sélectionnée introuvable",
    Notify_ShouldConnectInstaPageAgain: "Vous devez reconnecter la page Instagram",
    Notify_InvalidProductSuggestionId: "L'ID de suggestion de produit n'est pas valide",
    Notify_NotSavedSuggestions: "Les suggestions n'ont pas été enregistrées",
    Notify_ExistedSuggestedMedia: "Ce média suggéré a déjà été enregistré",
    Notify_InvalidUploadMediaUrl: "L'URL de téléchargement du média n'est pas valide",
    Notify_SuggestedPostAutoReplyKeyNotExist: "La clé de réponse automatique du Post suggéré est introuvable",
    Notify_UploadingTimeIsSoSoon: "Le temps de téléchargement est trop tôt",
    Notify_InvalidPreStoryId: "L'ID du Pre-Story n'est pas valide",
    Notify_NotProvidedInstagramerId: "ID de l'Instagramer non fourni",
    Notify_InvalidInstagramerId: "ID de l'Instagramer non valide",
    Notify_InvalidThreadId: "ID du thread non valide",
    Notify_InvalidLiveMediaId: "ID du média en direct non valide",
    Notify_NotCreatedExportComment: "Export de commentaire non créé",
    Notify_CreateExportAvailableWith24HourPeriod: "Export disponible toutes les 24 heures",
    Notify_NotSetted: "Non défini",
    Notify_ExceedGeneralAutoReplyCount: "Le nombre de réponses automatiques générales dépasse la limite",
    Notify_InvalidTransactionId: "ID de transaction non valide",
    Notify_CannotRenewalPackageWith1MonthTimeExist: "Impossible de renouveler le package d'un mois pour le moment",
    Notify_CannotDeleteCurrentSession: "Impossible de supprimer la session actuelle",
    Notify_InvalidSessionId: "ID de session non valide",
    Notify_CannotDeleteCurrentSessionForNewSessionFor1Day:
      "Impossible de supprimer la session actuelle pour créer une nouvelle session pendant 1 jour",
    Notify_UpgradedBefore: "Ce compte a déjà été mis à niveau",
    Notify_PermissionNotExist: "Permission inexistante",
    Notify_NotExistUser: "Utilisateur non trouvé",
    Notify_UserAlreadyAsPartner: "L'utilisateur est déjà enregistré comme partenaire admin",
    Notify_ReachMaxPartnerCount: "Nombre maximal de partenaires administrateurs atteint",
    Notify_InvalidPartnerRoleProvided: "Le rôle de partenaire admin fourni n'est pas valide",
    Notify_PartnerRolesLengthIsZero: "Aucun rôle défini pour le partenaire admin",
    Notify_PartnerNotExist: "Partenaire admin introuvable",
    Notify_CannotMakeYourSelfPartnerAsPartnerForYourSelf:
      "Vous ne pouvez pas vous sélectionner comme partenaire admin pour vous-même",
    Notify_PartnerExpireTimeMustBeBiggerThan1HourFromNow:
      "Le temps d'expiration du partenaire admin doit être d'au moins 1 heure à partir de maintenant",
    Notify_PartnerNameCannotExceed100: "Le nom du partenaire admin ne peut pas dépasser 100 caractères",
    Notify_ProductIsMultiSubproducted: "Ce produit contient plusieurs sous-produits",
    Notify_InvalidSubProductId: "L'ID du sous-produit n'est pas valide",
    Notify_ProductIdOutOfStock: "Le produit n'est pas en stock",
    Notify_SubProductIdRequired: "L'ID du sous-produit est requis",
    Notify_CardIsEmpty: "La carte est vide",
    Notify_InvalidAddressId: "L'ID de l'adresse n'est pas valide",
    Notify_ExceedTotalCreateAddress: "Vous avez dépassé le nombre maximum d'adresses autorisées",
    Notify_NotSupportedCountry: "Le pays sélectionné n'est pas pris en charge",
    Notify_CannotFetchAddressInThisEndpoint: "Impossible de récupérer l'adresse à ce point de terminaison",
    Notify_InvalidPostalCode: "Le code postal n'est pas valide",
    Notify_NeedCompleteAddress: "Saisir l'adresse complète est obligatoire",
    Notify_CannotBuyFromYourSelf: "Vous ne pouvez pas acheter chez vous-même",
    Notify_AllReadyIsBusiness: "Ce compte est déjà enregistré comme professionnel",
    Notify_InvalidBusinessType: "Le type de compte professionnel n'est pas valide",
    Notify_UserAlreadyAuthorized: "L'utilisateur a déjà été autorisé",
    Notify_InstagramerNotInfluencer: "L'Instagramer n'est pas un influenceur",
    Notify_InstagramerNotShopper: "L'Instagramer n'est pas un vendeur",
    Notify_AuthorizedInstagramerBefore: "Cet Instagramer a déjà été autorisé",
    Notify_UserNotAuthorizedYet: "L'utilisateur n'a pas encore été autorisé",
    Notify_InstagramerNotAuthorized: "L'Instagramer n'est pas autorisé",
    Notify_InvalidBankCardNumber: "Le numéro de carte bancaire n'est pas valide",
    Notify_TheOwnerOfPhoneNumberNotBlongsNationalNumber:
      "Le propriétaire du numéro de téléphone ne correspond pas au numéro national",
    Notify_CouponCodeAlreadyExists: "Le code coupon existe déjà",
    Notify_InvalidCouponId: "L'ID du coupon n'est pas valide",
    Notify_CannotChangeShowPrivateCouponInBio: "Impossible de modifier l'affichage du coupon privé dans la bio",
    Notify_InvalidCouponCode: "Le code coupon n'est pas valide",
    Notify_CouponForAnotherPerson: "Le coupon appartient à une autre personne",
    Notify_CouponExpired: "Le coupon a expiré",
    Notify_CouponDeleted: "Le coupon a été supprimé",
    Notify_CouponUsedUp: "Le coupon a été utilisé",
    Notify_InvalidUsernameSearchQuery: "La requête de recherche du nom d'utilisateur n'est pas valide",
    Notify_PreviouslyAddedShopAddress: "Cette adresse de boutique a déjà été ajoutée",
    Notify_NotSettedShopperAddress: "L'adresse du vendeur n'est pas définie",
    Notify_NotExistAnyLogesticInYourCountry: "Aucun système logistique n'existe dans votre pays",
    Notify_InvalidLogesticIds: "Les identifiants logistiques ne sont pas valides",
    Notify_LogsticsNotSetted: "Logistique non configurée",
    Notify_NotCommpletedAllBusinessVerification: "Toutes les vérifications commerciales ne sont pas terminées",
    Notify_ThisParcelNotSupportedByAnySelectedAvailableLogestic:
      "Ce colis n'est pris en charge par aucune logistique sélectionnée disponible",
    Notify_NotSupportedLogestic: "La logistique sélectionnée n'est pas prise en charge",
    Notify_ExceedLogesticHeight: "La hauteur du colis dépasse la limite logistique",
    Notify_ExceedLogesticWidth: "La largeur du colis dépasse la limite logistique",
    Notify_ExceedLogesticLength: "La longueur du colis dépasse la limite logistique",
    Notify_ExceedLogesticTotalLength: "La longueur totale du colis dépasse la limite logistique",
    Notify_ExceedLogesticWeight: "Le poids du colis dépasse la limite logistique",
    Notify_UserAddressesIsEmptyOrNotSetDefaultAddress:
      "Les adresses de l'utilisateur sont vides ou l'adresse par défaut n'est pas définie",
    Notify_NotSupportedBoxByThisDimensions: "La boîte avec ces dimensions n'est pas prise en charge",
    Notify_CannotAvailableOutOfStackProduct: "Impossible de rendre le produit disponible hors stock",
    Notify_YouAreDeadInCivilRegistration: "Vous êtes enregistré comme décédé dans l'état civil",
    Notify_InstagramerAlreadyAuthorized: "Instagramer est déjà autorisé",
    Notify_ThreadShouldBeActiveForSendMessage: "Le fil doit être actif pour envoyer un message",
    Notify_PreviouslyClosedTicket: "Le ticket a été fermé précédemment",
    Notify_NotMatchedCart: "Le panier ne correspond pas",
    Notify_PhoneNumberNotBlongsNationalNumber: "Le numéro de téléphone ne correspond pas au numéro national",
    Notify_NotMatchedCardNumberAndIdentity: "Le numéro de carte et les informations d'identité ne correspondent pas",
    Notify_SuspendedShop: "Cette boutique est suspendue, veuillez contacter le support",
    Notify_LogesticIdNotSpecifiedForaPostParcel: "L'identifiant logistique n'est pas spécifié pour le colis postal",
    Notify_LogesticNotInAvailableLogestics:
      "La logistique sélectionnée n'est pas dans la liste des logistiques disponibles",
    Notify_ExceedProductReportForLast24Hour:
      "Le nombre de rapports de produit au cours des dernières 24 heures dépasse la limite",
    Notify_PreviouslyReportedThisProduct: "Vous avez déjà signalé ce produit",
    Notify_InvalidOrderId: "L'identifiant de la commande est invalide",
    Notify_NotPendingPayRequest: "La demande de paiement n'est pas en attente",
    Notify_NotExistShopAddress: "Adresse de boutique introuvable",
    Notify_InvalidOrderStatus: "Le statut de la commande n'est pas valide",
    Notify_CancelInvoiceFailed: "Échec de l'annulation de la facture",
    Notify_PaymentSystemNotSupportedThisPriceType: "Le système de paiement ne prend pas en charge ce type de prix",
    Notify_InvalidSentOrderType: "Le type de commande envoyée n'est pas valide",
    Notify_InvalidParcelId: "L'identifiant du colis n'est pas valide",
    Notify_AddedParcelIdBefore: "L'identifiant du colis a déjà été ajouté",
    Notify_InvoiceNotOnPaid: "La facture n'a pas encore été payée",
    Notify_CreatedSystemTicketOnOrderBefore: "Le ticket système pour cette commande a déjà été créé",
    Notify_PaymentServiceNotResponding: "Le service de paiement ne répond pas pour le moment",
    Notify_YouAreNotAdmin: "Vous n'êtes pas administrateur",
    Notify_YouAreNotASubAdmin: "Vous n'êtes pas sous-administrateur",
    Notify_InvalidFbId: "ID Facebook invalide",
    Notify_InvalidFeatureId: "ID de fonctionnalité invalide",
    Notify_InActiveFeature: "Cette fonctionnalité est inactive",
    Notify_FeaturePaused: "Cette fonctionnalité est mise en pause",
    Notify_InvalidPromptInput: "Entrée de prompt invalide",
    Notify_PromptNotGenerated: "Prompt non généré",
    Notify_AIGeneratorFailed: "Le générateur IA a rencontré une erreur",
    Notify_NotExecutedPromptForCommentYet: "Le prompt pour le comment n'a pas encore été exécuté",
    Notify_InstagramPermissionNotExist: "La permission Instagram n'existe pas",
    Notify_InvalidTimeZone: "Fuseau horaire invalide",
    Notify_PromptCaptionExampleNotGenerated: "L'exemple de légende de prompt n'a pas été généré",
    Notify_InvalidMasterFlowId: "ID de flux principal invalide",
    Notify_InvalidFlowId: "ID de flux invalide",
    Notify_EmptySubFlows: "Les sous-flux sont vides",
    Notify_InvalidFlowObject: "Objet de flux invalide",
    Notify_InvalidMasterFlowTitle: "Titre de flux principal invalide",
    Notify_InvalidPromptId: "ID de prompt invalide",
    Notify_ExceedThreadTokenLimit: "Limite de jetons de fil dépassée pour cette conversation",
    Notify_InvalidMediaId: "ID de média invalide",
    Notify_InvalidLotteryId: "ID de loterie invalide",
    Notify_CannotAbortNonUpcomingLottery: "Impossible d'annuler les loteries non à venir actuellement",
    Notify_CommentCountExceedFreeExport:
      "Le nombre de commentaires dépasse la limite autorisée pour la loterie gratuite",
    Notify_InvalidReserveFeatureId: "ID de fonctionnalité de réserve invalide",
    Notify_CannotRenewalThisFeatureNow: "Impossible de renouveler cette fonctionnalité actuellement",
    Notify_InvalidLotteryStatus: "Le statut de la loterie n'est pas valide pour le changement",
    Notify_PublishedLotteryBannerBefore: "La bannière de loterie a été publiée auparavant",
    Notify_LotteryWinnerBannerIsNull: "La bannière du gagnant de la loterie n'existe pas",
    Notify_InvalidCustomPromptSigniture: "Signature de prompt personnalisée invalide",
    Notify_ServiceTemporarilyUnavailable: "Le service est temporairement indisponible",
    Notify_PageSummaryNotGenerated: "Brancy a besoin de plus de données pour analyser votre page.\nVeuillez patienter.",
    Notify_GenerateAIFail: "La génération IA a échoué",
    Notify_InvalidPageAnalysis: "Analyse de page invalide",
    Notify_InvalidCustomPrompt: "Invite personnalisée invalide",
    Notify_AIModelNotSupportImage: "Le modèle IA ne prend pas en charge les images",
    Notify_PromptNotSupportImage: "L'invite ne prend pas en charge les images",
    Notify_AIModelNotSupportAudio: "Le modèle IA ne prend pas en charge l'audio",
    Notify_PromptNotSupportVoice: "L'invite ne prend pas en charge la voix",
    Notify_AIModelNotSupportVideo: "Le modèle IA ne prend pas en charge la vidéo",
    Notify_InvalidPrompt: "Invite invalide",
    Notify_InvalidImageGeneratorInput: "Entrée du générateur d'images invalide",
    Notify_InSuffcientNumberOfImage: "Nombre d'images insuffisant",
    Notify_CreateImageExceedLimit: "La création d'images a dépassé la limite",
    Notify_InvalidPromptType: "Type d'invite invalide",
    Notify_UnSupportedAIInputType: "Type d'entrée IA non pris en charge",
    Notify_UnSupportedOrientationType: "Type d'orientation non pris en charge",
    Notify_SoraFailedAiCall: "L'appel IA Sora a échoué",
    Notify_AIVideoSecondNotSupported: "La durée de la vidéo IA n'est pas prise en charge",
    Notify_FailedToTraslateDescription: "Échec de la traduction de la description",
    Notify_FailedToGenerateEmbedVector: "Échec de la génération du vecteur d'intégration",
    Notify_NotGeneratedSummaryYet: "Le résumé n'a pas encore été généré",
    Notify_NoEventsFoundForTheGivenTimeRange: "Aucun événement trouvé pour la plage horaire donnée",
    Notify_NoEventsFoundForThisPrompt: "Aucun événement trouvé pour cette invite",
    Notify_PageAnalysisNotExist: "L'analyse de page n'existe pas",
    Notify_NoEventIdeaGenerated: "Aucune idée d'événement générée",
    Notify_PhoneNumberAddedBefore: "Ce numéro de téléphone a déjà été ajouté",
    Notify_WhatsAppCodeSendedBeforeAndWait1Day: "Un code WhatsApp a déjà été envoyé. Veuillez attendre un jour",
    Notify_WhatsAppCodeNotRequested: "Aucun code de vérification WhatsApp n'a été demandé",
    Notify_WhatsAppCodeMaxInvalidCountReach: "Le nombre maximal de tentatives de code WhatsApp incorrect a été atteint",
    Notify_UserWithThisPhoneNumberAlreadyExist: "Un utilisateur avec ce numéro de téléphone existe déjà",
    Notify_InvalidAIToolId: "Identifiant d'outil d'IA non valide",
    Notify_AIToolParameterRequired: "Le paramètre de l'outil d'IA est requis",
    Notify_AIToolParameterNotRequired: "Cet outil d'IA n'accepte aucun paramètre",
    Notify_ExceedDailyLimit: "La limite quotidienne a été dépassée",
    Notify_CannotGetTwitchRightNow: "Impossible de récupérer les données Twitch pour le moment",
    Notify_InvalidTwitchChannelId: "Identifiant de chaîne Twitch non valide",
    Notify_PhoneNumberRequired: "Le numéro de téléphone est requis",
    Notify_NotVerifiedHost: "L'hôte n'est pas vérifié",
    Notify_NotBusinesser: "Cet utilisateur n'est pas un professionnel",
    Notify_NotFoundAnySuggestedCategory: "Aucune catégorie suggérée n'a été trouvée",
    Notify_NoInvoiceExist: "Aucune facture n'existe",
    Notify_InvalidMediaAiCreatorKey: "Modèle d'IA invalide",
    Notify_InvalidMediaAiVersionKey: "Version d'IA invalide",
    Notify_InvalidMediaAiRequestModel: "Modèle de requête de média IA invalide",
    Notify_MediaAIError: "Une erreur s'est produite lors de la génération du média IA",
    Notify_TwitchChannelDoestHaveAnyVideo: "Cette chaîne Twitch ne contient aucune vidéo",
    Notify_CouponAlreadyDeleted: "Ce coupon a déjà été supprimé",
    Notify_CouponNotDeleted: "Ce coupon n'est pas supprimé",
    Notify_ExceedSubFlowCount: "Le nombre maximal de sous-flux a été dépassé",
    Notify_ExceedFlowDepth: "La profondeur maximale du flux a été dépassée",
    Notify_ExceedFlowItemCount: "Le nombre maximal d'éléments du flux a été dépassé",
    Notify_ExceedFlowMediaAudioCount: "Le nombre maximal de médias et d'audios du flux a été dépassé",
    Notify_OneFlowButtonHasEmptyItem: "L'un des boutons n'a pas de flux",
    InternalNotify_Ok: "Opération réussie",
    InternalNotify_RepetitiveHashtagInput: "Le hashtag saisi est répétitif",
    InternalNotify_NotFoundDevice: "Appareil non trouvé",
    InternalNotify_EmptyHashtagList: "Impossible de créer une liste vide",
    InternalNotify_CannotCreatePrePostNow: "Impossible de créer un pré-post pour le moment",
    InternalNotify_PrivateAccountSelectedForCheckHashtag: "Impossible de sélectionner un compte privé pour l'analyse",
    InternalNotify_InstagramLoginRequired: "Cette option nécessite une connexion Instagram",
    InternalNotify_InstagramLoginRequiredForVerifiedAccount:
      "Cette option nécessite une connexion Instagram pour les comptes vérifiés",
    InternalNotify_PrivateOrVerifiedSponsor: "Impossible de sélectionner un compte privé ou vérifié comme sponsor",
    InternalNotify_StartUploadingPost: "Le post est en cours de téléchargement",
    InternalNotify_UploadingPostError: "Erreur lors du téléchargement du post",
    InternalNotify_PostUploaded: "Post téléchargé, actualisez la page pour le voir",
    InternalNotify_ExceededMedia: "Nombre de médias dépassé",
    InternalNotify_More4IceBreaker: "Vous ne pouvez pas avoir plus de 4 conversations rapides",
    InternalNotify_CopyLink: "Votre lien a été copié",
    InternalNotify_copy: "Informations copiées avec succès",
    InternalNotify_CopyTrackingpost: "Le code de suivi de votre colis a été copié",
    InternalNotify_Network: "Erreur de connexion réseau",
    InternalNotify_TimeExpire: "Impossible d'enregistrer, le temps est écoulé",
    InternalNotify_ExceedPermittedHashtagNumber: "Le nombre de hashtags dépasse la limite autorisée",
    InternalNotify_UnexpectedError: "Une erreur inattendue est survenue",
    InternalNotify_CopyToClipboard: "Vos informations ont déjà été copiées dans le presse-papiers",
    InternalNotify_ExceedPermittedUploadMedia: "Le nombre de médias dépasse la limite autorisée",
    InternalNotify_FillRedBorderFields: "Veuillez remplir les champs encadrés en rouge",
    InternalNotify_RepeatedVariation: "Au moins deux éléments sont répétés",
    InternalNotify_NeedOneProduct: "Au moins un produit est requis",
    InternalNotify_UploadMedia: "Problème lors du téléchargement des médias",
    InternalNotify_TurnOnProxy: "Vous devez utiliser une IP valide",
    InternalNotify_ExceedPermittedLiveTime: "Le temps de live a dépassé la limite autorisée",
    InternalNotify_CommentDisabled: "Vous ne pouvez pas effectuer d'actions lorsque les commentaires sont désactivés",
    InternalNotify_ExceedSelectedCollaboratorPage:
      "Le nombre de pages collaboratrices sélectionnées dépasse la limite autorisée",
    InternalNotify_RepetitiveCollaboratorPage: "Ce nom d'utilisateur a déjà été sélectionné",
    InternalNotify_ExceedPermittedSizeOfImage: "La taille de l'image dépasse la limite autorisée",
    InternalNotify_ExceedPermittedAspectRatioAlbum:
      "Le rapport d'aspect de la vidéo de l'album dépasse la limite autorisée",
    InternalNotify_ExceedPermittedSizeOfVideoAlbum: "La taille de la vidéo de l'album dépasse la limite autorisée",
    InternalNotify_ExceedPermittedDurationOfVideoAlbum: "La durée de la vidéo de l'album dépasse la limite autorisée",
    InternalNotify_ExceedPermittedAspectRatioReels: "Le rapport d'aspect des Reels dépasse la limite autorisée",
    InternalNotify_ExceedPermittedSizeOfVideoReels: "La taille des Reels dépasse la limite autorisée",
    InternalNotify_ExceedPermittedDurationOfVideoReels: "La durée des Reels dépasse la limite autorisée",
    InternalNotify_NotPermittedMediaType: "Type de média non autorisé",
    InternalNotify_InvalidMetaData: "Les métadonnées ne sont pas valides",
    InternalNotify_ExceedSelectedMaxTaggedPeople: "Le nombre de personnes taguées dépasse la limite autorisée",
    InternalNotify_ExceedSelectedMaxHashtags: "Le nombre de hashtags sélectionnés dépasse la limite autorisée",
    InternalNotify_ExistedInCollaborate:
      "Ce nom d'utilisateur existe déjà parmi les collaborateurs et ne peut pas être dans la première diapositive",
    InternalNotify_ExceedPermittedAspectRatioStory: "Le ratio d'aspect de l'histoire dépasse la limite autorisée",
    InternalNotify_ExceedPermittedSizeOfVideoStory: "La taille de la vidéo de l'histoire dépasse la limite autorisée",
    InternalNotify_ExceedPermittedWidthOfVideo: "La largeur de la vidéo dépasse la limite autorisée",
    InternalNotify_BelowMinimumDurationOfVideoStory: "La vidéo de story doit durer au moins 3 secondes",
    InternalNotify_ExceedPermittedDurationOfVideoStory:
      "La durée de la vidéo de l'histoire dépasse la limite autorisée",
    InternalNotify_ExceedPermittedSpecificWordForAutoreply:
      "Le nombre de mots spécifiques pour la réponse automatique dépasse la limite autorisée",
    InternalNotify_ExceedPermittedAspectRatioImage: "Le ratio d'aspect de l'image dépasse la limite autorisée",
    InternalNotify_Success: "Opération réussie",
    InternalNotify_CreateExportAvailableWith24HourPeriod:
      "La création d'exportation avec une période de 24 heures est disponible",
    InternalNotify_SaveIceBreaker: "Ajouté avec succès",
    InternalNotify_deleteIceBreaker: "Supprimé avec succès",
    InternalNotify_SavePersistenceMenu: "Menu de persistance ajouté avec succès",
    InternalNotify_SelectLanguage: "Langue changée avec succès",
    InternalNotify_SaveFollowTemplate: "Modèle de follow enregistré avec succès",
    InternalNotify_AutoReplyOn: "Réponse automatique activée avec succès",
    InternalNotify_AutoReplyOff: "Réponse automatique désactivée avec succès",
    InternalNotify_AutoGeneralOn: "Réponse automatique générale activée avec succès",
    InternalNotify_AutoGeneralOff: "Réponse automatique générale désactivée avec succès",
    InternalNotify_MaxInEachCard: "Maximum dans chaque carte",
    InternalNotify_ExceedStockCard: "La quantité demandée dépasse le stock de la carte",
    InternalNotify_DefaultAddress: "Vous ne pouvez pas supprimer l'adresse par défaut",
    InternalNotify_FetchingYourData: "Récupération de vos données, veuillez patienter...",
    InternalNotify_EmptyTitleInQuickReply: "Le titre de la réponse rapide est vide",
    InternalNotify_EmptyTitleForOutputsInQuickReply: "Les titres de sortie dans la réponse rapide sont vides",
    InternalNotify_EmptyTitleForFlow: "Le titre du flux est vide",
    InternalNotify_MultipleFlowForPrivateReply: "Vous ne pouvez pas avoir plusieurs flux pour une réponse privée",
    InternalNotify_NotPermittedForDownload: "Vous n'êtes pas autorisé à télécharger ce contenu",
    InternalNotify_NotFeature: "Cette fonctionnalité n'est pas disponible pour votre compte",
    InternalNotify_ExceedBasefeatureTime: "Le temps de base de cette fonctionnalité a été dépassé",
    InternalNotify_ChannelIdNotStartedWithUC: "L'ID de la chaîne doit commencer par 'UC'",
    InternalNotify_PageAnalysisNotCompleted: "Malheureusement, votre page n'a pas encore été analysée par l'IA",
    JustCreated: "Le ticket a été enregistré",
    AdminReplied: "Le support a répondu",
    UserReplied: "L’utilisateur a répondu",
    AdminClosed: "Le ticket a été fermé par le support",
    UserClosed: "Le ticket a été fermé par l’utilisateur",
    TimerClosed: "Le ticket a été fermé automatiquement",
    closethisticket: "Fermer ce ticket",

    Create: "Créer",
    image: "image",
    video: "vidéo",
    Images: "Images",
    Videos: "Vidéos",
    "Generated artwork and visuals": "Illustrations et visuels générés",
    "AI motion and clips": "Mouvements et clips IA",
    "Media type": "Type de média",

    "Generated AI video preview": "Aperçu de la vidéo générée par IA",

    Close: "Fermer",
    Prompt: "Prompt",
    Metadata: "Métadonnées",
    Creator: "Créateur",
    Version: "Version",
    Status: "Statut",
    "Image ID": "ID de l’image",
    "Video ID": "ID de la vidéo",
    "Job ID": "ID de la tâche",
    "Download image": "Télécharger l’image",
    "Download video": "Télécharger la vidéo",
    "Your browser does not support video playback.": "Votre navigateur ne prend pas en charge la lecture vidéo.",

    Uploading: "Téléversement",
    "Add video": "Ajouter une vidéo",
    "Add audio": "Ajouter un audio",
    "Add reference image": "Ajouter une image de référence",
    model: "modèle",
    models: "modèles",
    "resize aspect ratio": "redimensionner le rapport d’aspect",
    "Video models": "Modèles vidéo",
    "Image models": "Modèles d’image",
    "Cost level {level}": "Niveau de coût {level}",
    "Calculating...": "Calcul en cours...",
    "Search from People or Keyword": "Rechercher des personnes ou un mot-clé",
    "Create new Flow": "Créer un nouveau flux",
    "Welcome illustration": "Illustration de bienvenue",
    "Untitled generation": "Création sans titre",
    "No images yet": "Aucune image pour le moment",
    "No videos yet": "Aucune vidéo pour le moment",
    "Your successful image generations will appear here.": "Vos images générées avec succès apparaîtront ici.",
    "Your successful video generations will appear here.": "Vos vidéos générées avec succès apparaîtront ici.",
    "Create your first image": "Créez votre première image",
    "Create your first video": "Créez votre première vidéo",
    "Generating image": "Génération de l’image",
    "Generating video": "Génération de la vidéo",

    "In progress": "En cours",
    "Just now": "À l’instant",
    "Waiting for the result": "En attente du résultat",

    "Try again": "Réessayer",

    "AI provider": "Fournisseur d'IA",

    "Choose a model": "Choisir un modèle",

    "Describe the subject, setting, light, composition, and style...":
      "Décrivez le sujet, le cadre, la lumière, la composition et le style...",
    "Use at least {count} characters.": "Utilisez au moins {count} caractères.",

    "Video creator is unavailable": "Le créateur vidéo est indisponible",
    "Image creator is unavailable": "Le créateur d'images est indisponible",
    "No video models found": "Aucun modèle vidéo trouvé",
    "No image models found": "Aucun modèle d'image trouvé",
    "There are no video generation models available for this account.":
      "Aucun modèle de génération vidéo n'est disponible pour ce compte.",
    "There are no image generation models available for this account.":
      "Aucun modèle de génération d'images n'est disponible pour ce compte.",
    "Not available": "Indisponible",
    // #endregion Notification Section
    how: "Comment",
    SharedRemainingTimeBefore: "Vous devez attendre 24 heures avant de partager à nouveau.",
    ConnectProduct: "Connexion directe au produit",
    messagesetting_ConnectProductResponseExplain: "Connectez votre produit à la Story ou au Live.",
    biolinkProperties_Connect: "Connecter",
    economy: "Économique",
    Retry: "Réessayer",
    SettingGeneralProfileTitle: "Profil",
    messagesetting_SpecifyProductResponseExplain:
      "Sélectionnez un produit pour qu’il soit envoyé automatiquement aux utilisateurs",
    messagesetting_ProductResponseExplain: "Connectez le produit actuel à l’utilisateur",

    // #region wallet
    createdtime: "Date de création",
    BankCards: "Cartes bancaires",
    Transactions: "Transactions",
    Settlements: "Règlements",
    AddNewBankCard: "Ajouter une nouvelle carte bancaire",
    RegisterANewCard: "Enregistrer une nouvelle carte",
    CardBankNumber: "Numéro de carte bancaire",
    CardNumberExplain:
      "Saisissez votre numéro de carte. La carte bancaire doit être enregistrée au nom de la personne ayant créé le compte.",
    RegisterBankCard: "Enregistrer la carte bancaire",
    CardNumber: "Numéro de carte",
    DefaultBankCard: "Carte bancaire par défaut",
    SetAsDefaultBankCard: "Définir comme carte bancaire par défaut",
    Type: "Type",
    Suspended: "Suspendu",
    Amount: "Montant",
    Time: "Heure",
    Order: "Commande",
    User: "Utilisateur",
    NotAvailable: "Indisponible",
    Unsettled: "Non réglé",
    AwaitingSettled: "En attente de règlement",
    Settled: "Réglé",
    SettlementFailed: "Échec du règlement",
    SettleRequest: "Demande de règlement",
    emptyInvoice: "Aucune facture n’a encore été enregistrée.",
    InvoiceID: "ID de la facture",
    InvoiceType: "Type de facture",
    InvoiceHistory: "Historique des factures",
    OrderDetails: "Détails de la commande",
    InvoiceDetails: "Détails de la facture",
    Paid: "Payé",
    Success: "Réussi",
    RefundRequest: "Demande de remboursement",
    Refunding: "Remboursement en cours",
    Refunded: "Remboursé",
    RefundFailed: "Échec du remboursement",
    Failed: "Échec",
    Package: "Forfait",
    Product: "Produit",
    Feature: "Fonctionnalité",
    Custom: "Personnalisé",
    Invoice: "Facture",
    UnknownStatus: "Statut inconnu",
    NoSettlementsRegisteredYet: "Aucun règlement n’a encore été enregistré.",
    LogesticPayment: "Paiement logistique",
    ProductIncome: "Revenus des produits",
    BrancyFeatureIncome: "Revenus des fonctionnalités Brancy",
    BrancyLogesticPayment: "Paiement logistique Brancy",
    BrancyPackageIncome: "Revenus des forfaits Brancy",
    BrancyProductIncome: "Revenus des produits Brancy",
    BrancyTransferPayment: "Frais de transfert Brancy",
    WalletBalance: "Solde du portefeuille",
    TotalWithdrawn: "Total retiré",
    FailedTransactions: "Transactions échouées",
    PendingSettlement: "Règlement en attente",
    OrderInProgress: "Commande en cours de traitement",
    OrderPickup: "Collecte de la commande",
    OrderDelivery: "Livraison de la commande",
    SubInvoiceHistory: "Historique des sous-factures",
    history: "Historique",
    // #endregion wallet
  },
};
